webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(981)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(784);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["a"] = ({
  getSignedRequest: function getSignedRequest(file) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var newFile, urlsApi;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.tratamentoImagem(file);

            case 2:
              newFile = _context2.sent;
              urlsApi = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.api;
              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(urlsApi + ('s3/sign-s3?file-name=' + newFile.name + '&file-type=' + newFile.type)).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(res.status === 200)) {
                            _context.next = 4;
                            break;
                          }

                          _context.next = 3;
                          return _this.uploadFile(newFile, res.data.signedRequest, res.data.url);

                        case 3:
                          return _context.abrupt('return', _context.sent);

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (err) {
                return { salva: false, erro: err };
              }));

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  uploadFile: function uploadFile(file, signedRequest, url) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', signedRequest);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve({ salva: true, url: url });
          } else {
            reject({ salva: false, erro: 'Arquivo inválida.' });
          }
        }
      };
      xhr.send(file);
    });
  },
  tratamentoImagem: function tratamentoImagem(file) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('original file => ', file);
      var file2 = file,
          reader = new FileReader(),
          reader2 = new FileReader(),
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');

      if (file) {
        reader.readAsDataURL(file);
        reader2.readAsDataURL(file2);
      }

      reader.addEventListener("load", function () {

        var imageObj1 = new Image(),
            imageObj2 = new Image(),
            imageObj3 = new Image();

        imageObj1.src = reader.result;
        imageObj1.onload = function () {

          var ALTURA = 280,
              LARGURA = 512;
          var blur = 6,
              recorte = 1.8;

          canvas.width = LARGURA;
          canvas.height = ALTURA;

          ctx.filter = 'blur(' + blur + 'px)';
          ctx.drawImage(imageObj1, 0, 0, LARGURA, ALTURA);
          ctx.filter = 'blur(0px)';

          imageObj3.src = canvas.toDataURL('image/jpeg');

          imageObj2.src = reader2.result;
          imageObj2.onload = function () {

            var width = this.width,
                height = this.height;

            if (width > height) {
              if (width > LARGURA) {
                height *= LARGURA / width;
                width = LARGURA;
              }
            } else {
              if (height > ALTURA) {
                width *= ALTURA / height;
                height = ALTURA;
              }
            }

            ctx.drawImage(imageObj3, blur * recorte, blur * recorte, LARGURA - blur * recorte * 2, ALTURA - blur * recorte * 2, 0, 0, LARGURA, ALTURA);

            ctx.drawImage(imageObj2, LARGURA / 2 - width / 2, ALTURA / 2 - height / 2, width, height);

            var dataURI = canvas.toDataURL('image/jpeg');
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
            }
            var newBlob = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });

            new Compress().compress([newBlob], {
              size: 4,
              quality: 0.75,
              maxWidth: LARGURA,
              maxHeight: ALTURA,
              resize: false }).then(function (images) {
              var dataURI = '' + images[0].prefix + images[0].data;
              var binary = atob(dataURI.split(',')[1]);
              var array = [];
              for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
              }
              var newBlob = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });

              var newFile = new File([newBlob], file.name, { type: file.type });
              console.log('finished => ', newFile);

              resolve(newFile);
            });
          };
        };
      }, false);
    });
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceServicos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceServicos = function () {
  function resourceServicos() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceServicos);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceServicos, null, [{
    key: 'getListaServicos',
    value: function getListaServicos() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servicos');
    }
  }, {
    key: 'getServico',
    value: function getServico(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servicos/' + id);
    }
  }, {
    key: 'gravaServico',
    value: function gravaServico(servico) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servicos', servico);
    }
  }, {
    key: 'atualizaServico',
    value: function atualizaServico(servico, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servicos/' + id, servico);
    }
  }, {
    key: 'dellServico',
    value: function dellServico(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servicos/' + id);
    }
  }]);

  return resourceServicos;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceServicos);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(965)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1220),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_map__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(21);












__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_6__router_map__["a" /* default */]
});

function requestToken() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('autenticacaoUsuario', { user: localStorage.getItem('usuario'), password: localStorage.getItem('password') }).then(function (response) {
      console.log('sucesso login => ', response);
      resolve();
    }).catch(function (responseError) {
      console.log('erro login => ', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(responseError));
      localStorage.setItem('token', 'false');
      resolve();
    });
  });
}

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().onAuthStateChanged(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
      var _this = this;

      var requiresAuth, response, indexEmpresa, url;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requiresAuth = to.matched.some(function (record) {
                return record.meta.requiresAuth;
              });

              if (user != null && localStorage.getItem('password') && localStorage.getItem('usuario')) {
                response = JSON.parse(localStorage.getItem('response'));
                indexEmpresa = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.empresa_ativa !== null && !isNaN(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.empresa_ativa) ? __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.empresa_ativa : 0;

                if (response !== null && response.Empresas[indexEmpresa].modulos) {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESAS', response.Empresas);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESA_ID', response.Empresas[indexEmpresa].id);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESA', response.Empresas[indexEmpresa].nome);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_API', response.Empresas[indexEmpresa].api);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_LOGO', response.Empresas[indexEmpresa].logo);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_APIBOT', response.Empresas[indexEmpresa].api_bot);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_USERNAME', response.nome_usuario);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FULLNAME', response.nome_completo);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMAIL', response.email);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FOTO', response.url_foto);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_INDEXEMPRESA', indexEmpresa);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_TOKEN', response.Empresas[indexEmpresa].fb_page_token);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_PERMITE_IMPRESSAO', response.permite_impressao);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_PERMITE_EMAIL', response.permite_email);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FB_ID_EMPRESA', response.Empresas[indexEmpresa].fb_id);
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_MODULOS_EMPRESA', response.Empresas[indexEmpresa].modulos);
                  document.title = response.Empresas[indexEmpresa].nome;

                  if (!localStorage.getItem('token')) {
                    requestToken().then(function () {
                      next();
                    }).catch(function (err) {
                      location.reload();
                    });
                  } else {
                    console.log(localStorage.getItem('token'));
                    console.log(response.Empresas[indexEmpresa].api.indexOf('dev-chatlivery'));
                    if (localStorage.getItem('token') === 'false' && response.Empresas[indexEmpresa].api.indexOf('dev-chatlivery') != -1) {
                      console.log('precisa de token***********');
                      requestToken().then(function () {
                        next();
                      }).catch(function (err) {
                        location.reload();
                      });
                    } else {
                      console.log('nao precisa de token***********');

                      next();
                    }
                  }
                } else {
                  url = 'https://sev-delivery.herokuapp.com/api/usuarios';

                  __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(url, {
                    'email': user.email
                  }).then(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              console.log('response-> ', response);

                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESAS', response.data.Empresas);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESA_ID', response.data.Empresas[indexEmpresa].id);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMPRESA', response.data.Empresas[indexEmpresa].nome);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_API', response.data.Empresas[indexEmpresa].api);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_LOGO', response.data.Empresas[indexEmpresa].logo);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_APIBOT', response.data.Empresas[indexEmpresa].api_bot);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_USERNAME', response.data.nome_usuario);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FULLNAME', response.data.nome_completo);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_EMAIL', response.data.email);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FOTO', response.data.url_foto);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_INDEXEMPRESA', indexEmpresa);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_TOKEN', response.data.Empresas[indexEmpresa].fb_page_token);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_PERMITE_IMPRESSAO', response.data.permite_impressao);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_PERMITE_EMAIL', response.data.permite_email);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_FB_ID_EMPRESA', response.data.Empresas[indexEmpresa].fb_id);
                              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('SET_MODULOS_EMPRESA', response.data.Empresas[indexEmpresa].modulos);
                              localStorage.setItem('response', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));
                              document.title = response.data.Empresas[indexEmpresa].nome;

                              if (!localStorage.getItem('token')) {
                                requestToken().then(function () {
                                  next();
                                }).catch(function (err) {
                                  console.log('erro token ==> ', err);
                                  alert('Erro ao obter token');
                                  location.reload();
                                });
                              } else {
                                next();
                              }

                            case 20:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }
              } else if (!requiresAuth) {
                next();
              } else next('login');

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resourceCategorias; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceCategorias = function () {
  function resourceCategorias() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceCategorias);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceCategorias, null, [{
    key: 'getListaCategorias',
    value: function getListaCategorias() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servico-categorias');
    }
  }, {
    key: 'getCategoriaById',
    value: function getCategoriaById(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servico-categorias/' + id);
    }
  }, {
    key: 'gravarCategoria',
    value: function gravarCategoria(categoria) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servico-categorias', categoria);
    }
  }, {
    key: 'atualizarCategoria',
    value: function atualizarCategoria(servico, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servico-categorias/' + id, servico);
    }
  }, {
    key: 'dellCategoria',
    value: function dellCategoria(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'servico-categorias/' + id);
    }
  }]);

  return resourceCategorias;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceCategorias);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  DADOS_CRIPTOGRAFAR: {
    algoritmo: "aes256",
    segredo: "OZt5fUh3ol6o6WrU",
    tipo: "hex"
  }
});

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceCampanhas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceCampanhas = function () {
  function resourceCampanhas() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceCampanhas);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceCampanhas, null, [{
    key: 'getListaCampanhas',
    value: function getListaCampanhas() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'cupons?empresa=' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.empresa_fb_id);
    }
  }, {
    key: 'getCampanhaByID',
    value: function getCampanhaByID(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'cupons/' + id);
    }
  }, {
    key: 'updateCampanha',
    value: function updateCampanha(obj, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'cupons/' + id, obj);
    }
  }, {
    key: 'gravarCampanha',
    value: function gravarCampanha(obj) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'cupons', obj);
    }
  }, {
    key: 'aprovar',
    value: function aprovar(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'campanhas/aprovar?campanha=' + id);
    }
  }, {
    key: 'reprovar',
    value: function reprovar(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'campanhas/reprovar?campanha=' + id);
    }
  }, {
    key: 'restartAll',
    value: function restartAll() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://clarim.herokuapp.com/restart-all?empresa=' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.empresa_fb_id);
    }
  }]);

  return resourceCampanhas;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceCampanhas);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceFiltros */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceFiltros = function () {
  function resourceFiltros() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceFiltros);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceFiltros, null, [{
    key: 'getListaFiltros',
    value: function getListaFiltros() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'filtros');
    }
  }, {
    key: 'getFiltro',
    value: function getFiltro(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'filtros/' + id);
    }
  }, {
    key: 'gravarFiltro',
    value: function gravarFiltro(filtro) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'filtros/', filtro);
    }
  }, {
    key: 'atualizaFiltro',
    value: function atualizaFiltro(filtro, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'filtros/' + id, filtro);
    }
  }, {
    key: 'dellFiltros',
    value: function dellFiltros(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'filtros/' + id);
    }
  }]);

  return resourceFiltros;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceFiltros);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceFuncionarios */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceFuncionarios = function () {
  function resourceFuncionarios() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceFuncionarios);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceFuncionarios, null, [{
    key: 'getListaFuncionarios',
    value: function getListaFuncionarios() {
      console.log(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'funcionarios');
    }
  }, {
    key: 'getFuncionario',
    value: function getFuncionario(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'funcionarios/' + id);
    }
  }, {
    key: 'gravaFuncionario',
    value: function gravaFuncionario(funcionario) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'funcionarios/', funcionario);
    }
  }, {
    key: 'atualizaFuncionario',
    value: function atualizaFuncionario(funcionario, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'funcionarios/' + id, funcionario);
    }
  }, {
    key: 'dellFuncionario',
    value: function dellFuncionario(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'funcionarios/' + id);
    }
  }]);

  return resourceFuncionarios;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceFuncionarios);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceServicos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceServicos = function () {
  function resourceServicos() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceServicos);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceServicos, null, [{
    key: 'getListaPacotes',
    value: function getListaPacotes() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes');
    }
  }, {
    key: 'getPacote',
    value: function getPacote(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes/' + id);
    }
  }, {
    key: 'gravarPacote',
    value: function gravarPacote(obj) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes', obj);
    }
  }, {
    key: 'atualizaPacote',
    value: function atualizaPacote(obj, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes/' + id, obj);
    }
  }, {
    key: 'dellPacote',
    value: function dellPacote(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes/' + id);
    }
  }, {
    key: 'getTagsPacote',
    value: function getTagsPacote(tipo) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'pacotes/tags?tipo=' + tipo);
    }
  }]);

  return resourceServicos;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceServicos);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resorcePerguntas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resorcePerguntas = function () {
  function resorcePerguntas() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resorcePerguntas);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resorcePerguntas, null, [{
    key: 'getListaPerguntas',
    value: function getListaPerguntas() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'perguntas');
    }
  }, {
    key: 'getPergunta',
    value: function getPergunta(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'perguntas/' + id);
    }
  }, {
    key: 'gravarPergunta',
    value: function gravarPergunta(obj) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'perguntas', obj);
    }
  }, {
    key: 'atualizaPergunta',
    value: function atualizaPergunta(obj, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'perguntas/' + id, obj);
    }
  }, {
    key: 'dellPergunta',
    value: function dellPergunta(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'perguntas/' + id);
    }
  }]);

  return resorcePerguntas;
}();

/* harmony default export */ __webpack_exports__["a"] = (resorcePerguntas);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceProblemas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceProblemas = function () {
  function resourceProblemas() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceProblemas);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceProblemas, null, [{
    key: 'getListaProblemas',
    value: function getListaProblemas() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'problemas');
    }
  }, {
    key: 'getProblema',
    value: function getProblema(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'problemas/' + id);
    }
  }, {
    key: 'gravaProblema',
    value: function gravaProblema(servico) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'problemas', servico);
    }
  }, {
    key: 'atualizaProblema',
    value: function atualizaProblema(servico, id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'problemas/' + id, servico);
    }
  }, {
    key: 'dellProblema',
    value: function dellProblema(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'problemas/' + id);
    }
  }]);

  return resourceProblemas;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceProblemas);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resourceSolicitacoes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);






var resourceSolicitacoes = function () {
  function resourceSolicitacoes() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, resourceSolicitacoes);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(resourceSolicitacoes, null, [{
    key: 'getListaSolicitacoes',
    value: function getListaSolicitacoes() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'solicitacoes');
    }
  }, {
    key: 'getSolicitacao',
    value: function getSolicitacao(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'solicitacoes/' + id);
    }
  }, {
    key: 'getEstados',
    value: function getEstados() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'solicitacoes/status');
    }
  }, {
    key: 'atualizaEstado',
    value: function atualizaEstado(id, estado) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.api + 'solicitacoes/' + id, estado);
    }
  }]);

  return resourceSolicitacoes;
}();

/* harmony default export */ __webpack_exports__["a"] = (resourceSolicitacoes);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(148);



/* harmony default export */ __webpack_exports__["a"] = ({
    descriptografar: function descriptografar(senha) {
        var decipher = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createDecipher(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].DADOS_CRIPTOGRAFAR.algoritmo, __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].DADOS_CRIPTOGRAFAR.segredo);
        decipher.update(senha, __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].DADOS_CRIPTOGRAFAR.tipo);
        return decipher.final().toString();
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session_storage__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
    get token() {
        return __WEBPACK_IMPORTED_MODULE_1__session_storage__["a" /* default */].getObject('token');
    },
    set token(value) {
        __WEBPACK_IMPORTED_MODULE_1__session_storage__["a" /* default */].setObject('token', value);
    },
    accessToken: function accessToken(email, password) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* Jwt */].accessToken(email, password).then(function (response) {
            _this.token = response.data.token;
            return response;
        });
    },
    logout: function logout() {
        __WEBPACK_IMPORTED_MODULE_1__session_storage__["a" /* default */].clear();
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut();
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
    set: function set(key, value) {
        window.localStorage[key] = value;
        return this;
    },
    get: function get(key, defaultValue) {
        return window.localStorage[key] || defaultValue;
    },
    setObject: function setObject(key, value) {
        window.localStorage[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
        return this.getObject(key);
    },
    getObject: function getObject(key) {
        return JSON.parse(window.localStorage[key] || null);
    },
    remove: function remove(key) {
        window.localStorage.removeItem(key);
    },
    clear: function clear() {
        localStorage.clear();
    }
});

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIxNy41MTgiIGN5PSIxNy41MTgiIHI9IjE3LjUxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjUyIDU1KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1036)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(957)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */,
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(1096);

var _Header2 = _interopRequireDefault(_Header);

var _MessageList = __webpack_require__(1100);

var _MessageList2 = _interopRequireDefault(_MessageList);

var _UserInput = __webpack_require__(1103);

var _UserInput2 = _interopRequireDefault(_UserInput);

var _ListUsers = __webpack_require__(1098);

var _ListUsers2 = _interopRequireDefault(_ListUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Header: _Header2.default,
    MessageList: _MessageList2.default,
    UserInput: _UserInput2.default,
    ListUsers: _ListUsers2.default
  },
  props: {
    'mensagens': {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    'showEmoji': {
      type: Boolean,
      default: false
    },
    'showFile': {
      type: Boolean,
      default: false
    },
    'onUserInputSubmit': {
      type: Function,
      required: true
    },
    'onClose': {
      type: Function,
      required: true
    },
    'isOpen': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'escolheuCliente': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: String,
      default: "Envie uma resposta"
    }
  },
  data: function data() {
    return {
      messageList: [],
      clienteEscolhido: {
        nome: '',
        img: '',
        id: ''
      }
    };
  },

  methods: {
    selectedCliente: function selectedCliente(id) {
      var _this = this;

      console.log("id ", id);
      this.$emit('escolheuCliente', id);
      this.mensagens.forEach(function (element) {
        if (element.id === id) {
          _this.clienteEscolhido.nome = element.nome;
          _this.clienteEscolhido.img = element.img;
          _this.clienteEscolhido.id = element.id;
          _this.messageList = element.mensagem;
          _this.escolheuCliente = true;
          return;
        }
      });
    },
    sendMsg: function sendMsg(msg) {
      var _this2 = this;

      var sendBack = {
        autor: msg.author,
        id: this.clienteEscolhido.id,
        mensagem: msg.data.text,
        date: new Date()
      };
      this.mensagens.forEach(function (element, index) {
        if (element.id == _this2.clienteEscolhido.id) {
          _this2.mensagens[index].mensagem.push(msg);
          console.log('messages -> ', _this2.mensagens);
        }
      });
      this.$emit('sendMsg', sendBack);
    },
    atualizarImagem: function atualizarImagem(id) {
      console.log('atualizando chatwindow ', id);
      this.$emit('atualizarImagem', id);
    },
    backChat: function backChat() {
      this.$emit('backChat', null);
      this.escolheuCliente = false;
    }
  }
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiPicker = __webpack_require__(1093);

var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiPicker: _EmojiPicker2.default
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  props: {
    onEmojiPicked: {
      type: Function,
      required: true
    }
  },
  methods: {
    _openPicker: function _openPicker(e) {
      this.isActive = !this.isActive;
    },
    _handlePickerBlur: function _handlePickerBlur() {
      this.isActive = false;
    }
  }
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emojiJs = __webpack_require__(936);

var _emojiJs2 = _interopRequireDefault(_emojiJs);

var _emojiData = __webpack_require__(1089);

var _emojiData2 = _interopRequireDefault(_emojiData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      emojiData: _emojiData2.default,
      emojiConvertor: new _emojiJs2.default()
    };
  },

  props: {
    onBlur: {
      type: Function,
      required: true
    },
    onEmojiPicked: {
      type: Function,
      required: true
    }
  },
  methods: {
    emojiClicked: function emojiClicked(emoji) {
      this.onEmojiPicked(emoji);
      this.$refs.domNode.blur();
    }
  },
  mounted: function mounted() {
    var elem = this.$refs.domNode;
    elem.style.opacity = 0;
    window.requestAnimationFrame(function () {
      elem.style.transition = 'opacity 350ms';
      elem.style.opacity = 1;
    });
    this.$refs.domNode.focus();
    this.emojiConvertor.init_env();
  }
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onChange: {
      type: Function,
      required: true
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      e.target.value = null;
    },
    _handleChange: function _handleChange(e) {
      this.onChange(e.target.files[0]);
    }
  }
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    teamName: {
      type: String
    }
  },
  methods: {
    back: function back() {
      this.$emit('back');
    }
  }
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChatWindow = __webpack_require__(1090);

var _ChatWindow2 = _interopRequireDefault(_ChatWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mensagens: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showEmoji: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    newMessagesCount: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    placeholder: {
      type: String,
      default: "Write a reply"
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    sendMsg: function sendMsg(msg) {
      this.$emit('sendMsg', msg);
    },
    leuMsg: function leuMsg(id) {
      this.$emit('leuMsg', id);
    },
    atualizarImagem: function atualizarImagem(id) {
      this.$emit('atualizarImagem', id);
    },
    backChat: function backChat() {
      this.$emit('backChat');
    }
  },
  components: {
    ChatWindow: _ChatWindow2.default
  }
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    'clientes': {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    cliente: function cliente(id) {
      this.$emit('selectedCliente', id);
    },
    syncClient: function syncClient(id) {
      console.log('atualizando imagem ', id);
      this.$emit('atualizarImagem', id);
    }
  },
  filters: {
    ajusteDate: function ajusteDate(value) {
      var data = new Date(value);
      var newDate = new Date(data.getTime() - data.getTimezoneOffset() * 60000).toISOString();
      var aux = newDate.split('T');
      var date = aux[0].split('-');
      var hr = aux[1];
      return date[2] + '/' + date[1] + '/' + date[0] + ' - ' + hr.substring(0, 5);
    }
  }
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextMessage = __webpack_require__(1102);

var _TextMessage2 = _interopRequireDefault(_TextMessage);

var _FileMessage = __webpack_require__(1095);

var _FileMessage2 = _interopRequireDefault(_FileMessage);

var _EmojiMessage = __webpack_require__(1092);

var _EmojiMessage2 = _interopRequireDefault(_EmojiMessage);

var _chatIcon = __webpack_require__(423);

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    TextMessage: _TextMessage2.default,
    FileMessage: _FileMessage2.default,
    EmojiMessage: _EmojiMessage2.default
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: _chatIcon2.default
    }
  }
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = __webpack_require__(1099);

var _Message2 = _interopRequireDefault(_Message);

var _chatIcon = __webpack_require__(423);

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Message: _Message2.default
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: _chatIcon2.default
    }
  },
  methods: {
    _scrollDown: function _scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
    }
  },
  mounted: function mounted() {
    this._scrollDown();
  },
  updated: function updated() {
    this.$nextTick(this._scrollDown());
  }
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onClick: {
      type: Function,
      required: true
    }
  }
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiIcon = __webpack_require__(1091);

var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);

var _FileIcons = __webpack_require__(1094);

var _FileIcons2 = _interopRequireDefault(_FileIcons);

var _SendIcon = __webpack_require__(1101);

var _SendIcon2 = _interopRequireDefault(_SendIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiIcon: _EmojiIcon2.default,
    FileIcons: _FileIcons2.default,
    SendIcon: _SendIcon2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showFile: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    onSubmit: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: "Write a reply"
    }
  },
  data: function data() {
    return {
      file: null,
      inputActive: false
    };
  },

  methods: {
    cancelFile: function cancelFile() {
      this.file = null;
    },
    setInputActive: function setInputActive(onoff) {
      this.inputActive = onoff;
    },
    handleKey: function handleKey(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        this._submitText(event);
        event.preventDefault();
      }
    },
    _submitText: function _submitText(event) {
      var text = this.$refs.userInput.textContent;
      if (text && text.length > 0) {
        var data = new Date();
        var newDate = new Date(data.getTime() - data.getTimezoneOffset() * 60000).toISOString();
        var msg = {
          author: 'me',
          data: { text: text },
          date: newDate,
          lido: true,
          type: 'text'
        };
        this.$refs.userInput.innerHTML = '';
        this.$emit('sendMsg', msg);
      }
    },
    _handleEmojiPicked: function _handleEmojiPicked(emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji: emoji }
      });
    },
    _handleFileSubmit: function _handleFileSubmit(file) {
      this.file = file;
    }
  }
};

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_downloadjs__);





/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		'type': {
			type: String,
			default: "xls"
		},

		'data': {
			type: Array,
			required: true
		},

		'fields': {
			type: Object,
			required: true
		},

		'title': {
			type: String,
			default: null
		},

		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.fields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_1_downloadjs___default()(blob, filename, mime);
		},

		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';

			if (this.title != null) {
				xlsData += '<tr><th colspan="' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[0]).length + '">' + this.title + '<th></tr>';
			}

			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';

			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},

		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';

			if (this.title != null) {
				csvData += this.title + '\r\n';
			}

			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';

			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + '';
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},

		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		getNestedData: function getNestedData(key, item) {
			var valueFromNestedKey = null;
			var keyNestedSplit = key.split(".");
			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}
			return valueFromNestedKey == null ? '' : valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} });

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 100 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    color: {
      default: '#35495e'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        border: this.stroke + ' solid ' + this.background,
        borderTopColor: this.color
      };
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    dotSize: {
      default: function _default() {
        var size = parseInt(this.size);
        return size / 3 + 1;
      }
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      var halfSize = size / 3;
      return {
        width: this.size,
        height: this.size,
        border: '0px solid ' + this.background,
        boxShadow: '0 -' + halfSize + 'px 0 ' + this.dotSize + 'px ' + this.background + ' inset'
      };
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 44 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 120 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    diamondStyle: function diamondStyle() {
      var size = parseInt(this.size);
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 4 + 'px'
      };
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '2.0s'
    }
  },
  computed: {
    bounceStyle: function bounceStyle() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 2 + 'px'
      };
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 164 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 64 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size) / 2;
      return {
        transform: 'scale(' + size / 75 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 31 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: 'auto',
        fill: this.color
      };
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 250 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size,
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size
      };
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        backgroundColor: this.background,
        width: this.size,
        height: this.size,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 80 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.0s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 220 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    lineStyles: function lineStyles() {
      return {
        width: this.size,
        height: this.stroke,
        background: this.color,
        borderRadius: this.stroke
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.3s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    rectStyles: function rectStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    blobStyles: function blobStyles() {
      return {
        borderColor: this.color
      };
    },
    moveBlobStyles: function moveBlobStyles() {
      return {
        borderColor: this.color,
        background: this.color
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationName: 'sk-cubemove',
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ModalNovoPedido__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ModalNovoPedido___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ModalNovoPedido__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pusher_js__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pusher_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pusher_js__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__Sidebar___default.a,
    ModelSelect: __WEBPACK_IMPORTED_MODULE_5_vue_search_select__["ModelSelect"],
    'modal-pedido': __WEBPACK_IMPORTED_MODULE_6__views_ModalNovoPedido___default.a
  },
  data: function data() {
    return {
      messageList: [],
      newMessagesCount: 0,
      isChatOpen: false,
      mensagens: [],
      mostrar: false,
      escolheuCliente: false,
      url: this.$store.state.api,

      config: [],
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].hideLogoOnMobile
      },
      error: '',
      logo: true,
      bot_ativo: this.$store.state.bot_ativo,
      color: { checked: '#00A65A', unchecked: '#FF0000' },
      options: [],
      item: {
        text: '',
        values: 0
      },
      modal: false,
      pedidosImprimir: [],
      cont: 0
    };
  },
  created: function created() {
    this.getConfig();
    this.getMessages();

    if (this.$store.state.permite_impressao) {
      this.verificaPedido();
    }
  },
  mounted: function mounted() {
    if (!this.isMobile) document.getElementById('toggle-menu').click();
    var barraRecolhida = document.getElementsByClassName('sidebar-collapse');
    if (barraRecolhida.length === 1) {
      this.logo = false;
    } else {
      this.logo = true;
    }
  },

  computed: {
    demo: function demo() {
      return {
        displayName: this.$store.state.nome_usuario,
        empresa: this.$store.state.empresa,
        email: this.$store.state.email,
        avatar: this.$store.state.foto,
        logo: this.$store.state.logo
      };
    },
    isMobile: function isMobile() {
      console.log('is mobile? ', window.innerWidth <= 800 && window.innerHeight <= 600);
      console.log('width => ', window.innerWidth);
      console.log('height => ', window.innerHeight);
      return window.innerWidth <= 500 && window.innerHeight <= 800;
    }
  },
  methods: {
    alertTeste: function alertTeste() {
      var _this = this;

      alert(this.cont);
      setTimeout(function () {
        _this.cont++;
        _this.alertTeste();
      }, 2000);
    },
    verificaPedido: function verificaPedido() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_8_pusher_js___default.a.logToConsole = true;

      var pusher = new __WEBPACK_IMPORTED_MODULE_8_pusher_js___default.a('6846a7777c4cdce67915', {
        cluster: 'us2',
        forceTLS: true
      });

      var channel = pusher.subscribe('order' + window.localStorage.getItem('FB_ID'));
      channel.bind('novo', function (data) {
        _this2.somNotificacao();
        _this2.getNovosPedidos();
      });

      var channelAgenda = pusher.subscribe('agenda' + window.localStorage.getItem('FB_ID'));
      channelAgenda.bind('novo', function (data) {
        console.log('novo agendamento --> ', data);
        alert('Novo agendamento realizado!');
      });
    },
    somNotificacao: function somNotificacao() {
      console.log('audio play');
      var v = document.getElementsByTagName("audio")[0];
      v.play();
    },
    pararSom: function pararSom() {
      console.log('audio pause');
      var v = document.getElementsByTagName("audio")[0];
      v.pause();
    },
    getNovosPedidos: function getNovosPedidos() {
      var _this3 = this;

      this.pedidosImprimir = [];
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$store.state.api + 'pedidos/novos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        console.log('novos pedidos =======> ', response);
        _this3.$swal(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          title: 'Novo Pedido!',
          html: 'Você tem um novo pedido',
          type: 'success',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          confirmButtonColor: '#3085d6'
        }, 'confirmButtonText', 'Imprimir')).then(function (result) {
          _this3.pararSom();
          if (result.value) {
            response.data.forEach(function (element, index, array) {
              var itens = element.itensPedido;
              var itens_pedido = [];
              var prodName = '';
              var qtde = 0;
              var obs = '';
              _this3.preco_total = element.preco_total;
              for (var i = 0; i < itens.length; i++) {
                for (var j = 0; j < itens[i].itens.length; j++) {
                  if (prodName != '') prodName += '/ ' + itens[i].itens[j].produtos.nome;else prodName = itens[i].itens[j].produtos.nome;

                  if (obs != '') obs += '/ ' + itens[i].itens[j].observacao;else obs = itens[i].itens[j].observacao;
                }
                if (j > 1) qtde = 1;else qtde = itens[i].itens[j - 1].quantidade;

                var massa = '';
                if (itens[i].tipo_massa) massa = ' - ' + itens[i].tipo_massa;
                if (itens[i].tipo_borda) massa += ' / ' + itens[i].tipo_borda;

                if (obs !== '') obs += massa;else obs = massa;
                if (obs !== '') prodName += ' (' + obs + ')';

                var nomeProduto = void 0;

                if (itens[i].cardapio && itens[i].cardapio.nome.indexOf('Pizza') != -1) nomeProduto = itens[i].cardapio.nome + ' - ' + prodName;else nomeProduto = prodName;

                var descricao = '';
                if (_this3.config.imprimir_descricao) descricao = itens[i].itens[0].produtos.descricao ? itens[i].itens[0].produtos.descricao.split('.')[0] : '';

                var total = 0;

                itens[i].adicionais.forEach(function (adicional) {
                  total += adicional.preco * adicional.qtde;
                });

                total += itens[i].preco_item;

                itens_pedido.push({ nome: nomeProduto, descricao: descricao, qtde: qtde, total: total, observacao: obs, preco: itens[i].preco_item, adicionais: itens[i].adicionais ? itens[i].adicionais : null });

                prodName = '';
                obs = '';
              }
              element.itensPedido = itens_pedido;

              _this3.pedidosImprimir.push(element);
            });
            _this3.modal = true;
            setTimeout(function () {
              for (var i in _this3.pedidosImprimir) {
                _this3.imprimiu(_this3.pedidosImprimir[i].id);
                _this3.imprimirPedidos(i);
              }
            }, 1500);
          }
        });
      });
    },
    imprimiu: function imprimiu(id) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$store.state.api + 'pedidos/imprimiu?id=' + id);
    },
    imprimirPedidos: function imprimirPedidos(i) {
      console.log('imprimiu ', i);
      var title = document.getElementById('titlePedido' + i).innerHTML,
          endereco = document.getElementById('enderecoNovo' + i).innerHTML,
          itens = document.getElementById('itensNovo' + i).innerHTML,
          pagamento = document.getElementById('pagamentoNovo' + i).innerHTML,
          tela_impressao = window.open('about:blank');

      tela_impressao.document.write(title);
      tela_impressao.document.write('<br>');
      tela_impressao.document.write(endereco);
      tela_impressao.document.write('<br><br>');
      tela_impressao.document.write(itens);
      tela_impressao.document.write('<br><br>');
      tela_impressao.document.write(pagamento);
      tela_impressao.document.write('<br><br>');
      tela_impressao.document.write('<style> table {text-align: center} .lblEnd{margin-top:-1%} label {font-size: 12px!important;} tr {font-size: 12px;} th{font-size: 12px;} h4 {font-size: 12px; margin-bottom: 1%} p {font-size: 12px;} h5 {margin: 0px} .adicionais { font-size: 11px; margin: 0 } .bordaItem{ border-bottom: 1px dotted }</style>');
      tela_impressao.window.print();
      tela_impressao.window.close();
    },
    getConfig: function getConfig() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$store.state.api + 'config?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this4.config = response.data[0];
        console.log('config:', _this4.config);
        if (_this4.config.funcionamento === 'manual') {
          if (_this4.$store.state.bot_ativo === undefined) {
            var url = _this4.$store.state.api_bot + 'status?empresa=' + _this4.$store.state.empresa_fb_id;
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
              var status = response.data.status;

              _this4.$store.commit('ACTIVE_BOT', status);
              _this4.bot_ativo = status;
            });
          } else if (_this4.$store.state.bot_ativo) {
            _this4.bot_ativo = true;
          } else {
            _this4.bot_ativo = false;
          }
        }
      });
    },
    getMessages: function getMessages() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.url + 'mensagens?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this5.mensagens = [];
        _this5.newMessagesCount = 0;
        console.log(response.data);
        response.data.forEach(function (element) {
          var ajusteMsg = _this5.ajustaMsg(element.mensagens);
          _this5.mensagens.push({
            id: element.fb_id ? element.fb_id : element.facebook_id,
            nome: element.nome + ' ' + element.sobrenome,
            img: element.url_foto,
            mensagem: ajusteMsg.msg,
            lido: ajusteMsg.lido
          });
        });
        if (_this5.newMessagesCount > 0 && _this5.$store.state.permite_email) _this5.enviarEmail();
        _this5.mostrar = true;
        _this5.orderCliente();
        setTimeout(function () {
          _this5.getMessages();
        }, 200000);
      });
    },
    orderCliente: function orderCliente() {
      this.mensagens.sort(function (a, b) {
        var dataA = a.mensagem[a.mensagem.length - 1].date;
        var dataB = b.mensagem[b.mensagem.length - 1].date;
        return dataA > dataB ? -1 : dataA < dataB ? 1 : 0;
      });
      console.log('clientes mensagens -> ', this.clientes);
    },
    ajustaMsg: function ajustaMsg(mensagens) {
      var _this6 = this;

      var msg = [],
          lido = true;
      mensagens.forEach(function (element) {
        if (!element.lido) {
          lido = false;
          _this6.newMessagesCount++;
        }
        msg.push({
          author: element.autor,
          data: {
            text: element.mensagem
          },
          date: element.data_hora,
          type: 'text',
          lido: element.lido
        });
      });
      return { msg: msg, lido: lido };
    },
    enviarEmail: function enviarEmail() {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://us-central1-sevsolucoes-44d04.cloudfunctions.net/enviarEmail', {
        'assunto': 'Novas Mensagens',
        'corpo': 'Olá, você possui ' + this.newMessagesCount + ' novas mensagens sem resposta.',
        'destinatario': this.$store.state.email
      }).then(function (res) {
        console.log('retorno email -> ', res);
      });
    },
    sendMessage: function sendMessage(msg) {
      console.log('msg back -> ', msg);
      if (msg.mensagem.length > 0) {
        var url = this.$store.state.api_bot + 'pedidos/estado_pedido?fb_id=' + msg.id + '&msg=' + msg.mensagem + '&mostrar_botao=' + true;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
          return console.log(response);
        });
        this.gravaMsg(msg);
      }
    },
    gravaMsg: function gravaMsg(msg) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.url + 'mensagens', {
        id: msg.id,
        data: msg.date,
        mensagem: msg.mensagem
      }).then(function (ret) {
        console.log('retorno msg -> ', ret);
      }).catch(function (err) {
        console.log('retorno msg -> ', err);
      });
    },
    leuMsg: function leuMsg(id) {
      var _this7 = this;

      this.newMessagesCount = 0;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.url + 'mensagens', {
        id: id
      });
      this.mensagens.forEach(function (element) {
        if (element.id === id) {
          element.mensagem.forEach(function (msg) {
            msg.lido = true;
          });
          _this7.ajustaMsg(element.mensagem);
        }
      });
    },
    onMessageWasSent: function onMessageWasSent(msg) {},
    openChat: function openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat: function closeChat() {
      this.isChatOpen = false;
      this.escolheuCliente = false;
    },
    alteraStatusBot: function alteraStatusBot() {
      this.$store.commit('ACTIVE_BOT', this.bot_ativo);

      var url = this.$store.state.api_bot + 'status/active?status=' + this.bot_ativo + '&empresa=' + this.$store.state.empresa_fb_id;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then();
    },
    logout: function logout() {
      var _this8 = this;

      this.$swal({
        title: 'Tem certeza que deseja sair?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sair',
        cancelButtonText: 'Cancelar'
      }).then(function (result) {
        if (result.value) {
          _this8.$store.dispatch('logout');
          _this8.$router.replace('login');
        }
      });
    },
    minhaConta: function minhaConta() {
      this.$router.push('minha-conta');
    },
    novoUsuario: function novoUsuario() {
      this.$router.push('novo-usuario');
    },
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    barra: function barra() {
      if (!this.isMobile) {
        if (this.logo) {
          this.logo = false;
        } else {
          this.logo = true;
        }

        if (this.$store.state.show_empresa) {
          this.$store.commit('HIDDEN_EMPRESA');
        } else {
          this.$store.commit('SHOW_EMPRESA');
        }
      }
    },
    atualizarImagem: function atualizarImagem(id) {
      var _this9 = this;

      console.log('atualizando imagem ', id);
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://graph.facebook.com/v2.7/' + id + '?access_token=' + this.$store.state.fb_page_token).then(function (ret) {
        _this9.updateCliente(ret.data);
      });
    },
    updateCliente: function updateCliente(cliente) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.$store.state.api + 'clientes/' + cliente.id, {
        nome: cliente.first_name,
        sobrenome: cliente.last_name,
        url_foto: cliente.profile_pic,
        sexo: cliente.gender
      }).then(function (data) {});
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(148);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      username: '',
      password: '',
      response: '',
      classeBtn: '',
      loading: false
    };
  },
  created: function created() {},

  methods: {
    checkCreds: function checkCreds() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn').addClass('disabled');
      this.$store.commit('TOGGLE_LOADING');
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.username, this.password).then(function (user) {
        var criptografada = _this.criptografar(_this.password);
        window.localStorage.setItem('password', criptografada);
        window.localStorage.setItem('usuario', _this.username);
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('/');
      }, function (Error) {
        _this.loading = false;
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn').removeClass('disabled');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn').addClass('animated shake');
        _this.response = Error.message;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#btn').removeClass('animated shake');
        }, 1000);
      });
    },
    criptografar: function criptografar(senha) {
      var cipher = __WEBPACK_IMPORTED_MODULE_3_crypto___default.a.createCipher(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].DADOS_CRIPTOGRAFAR.algoritmo, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].DADOS_CRIPTOGRAFAR.segredo);
      cipher.update(senha);
      return cipher.final(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].DADOS_CRIPTOGRAFAR.tipo);
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RedefinirSenha',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__views_Box___default.a
  },
  data: function data() {
    return {
      response: '',
      email: '',
      enviou: false,
      gravando: false,
      title: 'Informe seu email para redefinir a senha de acesso'
    };
  },
  created: function created() {},

  methods: {
    redefinir: function redefinir() {
      var _this = this;

      this.gravando = true;
      var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();

      auth.sendPasswordResetEmail(this.email).then(function () {
        _this.emailSent = true;
        _this.enviou = true;
        _this.gravando = false;
        _this.response = '';
        _this.title = '';
      }).catch(function (error) {
        _this.response = error.message;
        _this.gravando = false;
      });
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl', 'empresa'],
  components: {
    SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a
  },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  },
  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
        console.log('saiu');
        _this.$router.replace('login');
      });
    }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarName',
  data: function data() {
    return {
      options: this.$store.state.empresas,
      empresa_ativa: this.$store.state.empresa_ativa,
      possuiAgendamento: false,
      possuiDelivery: false,
      possuiAssistencia: false,
      possuiTurismo: false,
      isAdmin: false
    };
  },
  created: function created() {
    this.verificaMenu();
    this.isAdmin = localStorage.getItem('usuario') === 'contato@sevsolucoes.com';
  },

  methods: {
    changeEmpresa: function changeEmpresa(index, fb_id) {
      localStorage.setItem('INDEXEMPRESA', index);
      localStorage.setItem('FB_ID', fb_id);
      this.$router.go();
    },
    verificaMenu: function verificaMenu() {
      var _this = this;

      var modulos = localStorage.getItem('modulos').split(',');
      console.log('modulos => ', modulos);
      modulos.forEach(function (element) {
        switch (element) {
          case 'delivery':
            _this.possuiDelivery = true;
            break;
          case 'assistencia':
            _this.possuiAgendamento = true;
            _this.possuiAssistencia = true;
            break;
          case 'agencia_turismo':
            _this.possuiTurismo = true;
            break;
          default:
            break;
        }
      });
    }
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AlterarEmail',
    components: {
        'box': __WEBPACK_IMPORTED_MODULE_0__Box___default.a
    },
    data: function data() {
        return {
            newEmail: '',
            confirmEmail: '',
            wrongNewEmail: false,
            gravando: false
        };
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(this.$store.state.email, window.localStorage.getItem('senha'));
    },

    methods: {
        gravar: function gravar() {
            var _this = this;

            this.gravando = true;
            if (this.newEmail && this.confirmEmail) {
                if (this.newEmail !== this.confirmEmail) {
                    this.gravando = false;
                    this.wrongNewEmail = true;
                } else {
                    this.wrongNewEmail = false;
                    var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
                    user.updateEmail(this.newEmail).then(function () {
                        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.$store.state.api + 'usuarios/alter-email', {
                            'email': _this.newEmail,
                            'oldEmail': _this.$store.state.email
                        }).then(function (response) {
                            if (response.data.success) {
                                _this.$swal({
                                    position: 'top-end',
                                    type: 'success',
                                    title: 'Gravado com sucesso',
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                _this.$store.commit('SET_EMAIL', _this.newEmail);
                                _this.$router.push('minha-conta');
                            } else {
                                _this.gravando = false;
                                _this.$swal('Ops!', 'O usuário não foi gravado.', 'error');
                            }
                        });
                    }).catch(function (error) {
                        _this.$swal('Ops!', '' + error, 'error');
                        _this.gravando = false;
                    });
                }
            } else {
                this.gravando = false;
                this.$swal('Ops!', 'É necessário preencher todos os campos!', 'error');
            }
        }
    }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AlterarSenha',
    components: {
        'box': __WEBPACK_IMPORTED_MODULE_0__Box___default.a
    },
    data: function data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            wrongOldPassword: false,
            wrongNewPassword: false,
            gravando: false
        };
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(this.$store.state.email, window.localStorage.getItem('senha'));
    },

    methods: {
        gravar: function gravar() {
            var _this = this;

            this.gravando = true;
            if (this.oldPassword && this.newPassword && this.confirmPassword) {
                if (this.oldPassword !== window.localStorage.getItem('senha')) {
                    this.gravando = false;
                    this.wrongOldPassword = true;
                } else if (this.newPassword !== this.confirmPassword) {
                    this.gravando = false;
                    this.wrongOldPassword = false;
                    this.wrongNewPassword = true;
                } else {
                    this.wrongOldPassword = false;
                    this.wrongNewPassword = false;
                    var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
                    user.updatePassword(this.newPassword).then(function () {
                        _this.$swal({
                            position: 'top-end',
                            type: 'success',
                            title: 'Gravado com sucesso',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        window.localStorage.setItem('senha', _this.newPassword);
                        _this.$router.push('minha-conta');
                    }).catch(function (error) {
                        _this.$swal('Ops!', '' + error, 'error');
                        _this.gravando = false;
                    });
                }
            } else {
                this.gravando = false;
                this.$swal('Ops!', 'É necessário preencher todos os campos!', 'error');
            }
        }
    }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Box',
  props: ['title']
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_dropdowns__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_inputs__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__syncfusion_ej2_data__ = __webpack_require__(17);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["a" /* SchedulePlugin */]);

var instance = new __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["a" /* Internationalization */]();
var monthVue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("month-eventTemplate", {
    template: '<div class="subject">{{data.Subject}}</div>',
    data: function data() {
        return {
            data: {}
        };
    }
});

var agendaVue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("agenda-eventTemplate", {
    template: '<div><div class="subject">{{data.Subject}}</div><div v-if="data.Description !== null && data.Description !== undefined" class="group">{{data.Description}}</div>' + '<div class="location">{{getTimeString(data.StartTime)}}, <span v-if="data.City!== null && data.City!==undefined">{{data.City}}</span></div></div>',
    data: function data() {
        return {
            data: {}
        };
    },

    methods: {
        getTimeString: function getTimeString(value) {
            return instance.formatDate(value, { skeleton: 'Hm' });
        }
    }
});

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
    data: function data() {
        return {
            carregou: false,
            resourceData: [],

            selectedDate: new Date(),
            showWeekend: false,
            currentView: 'Day',
            timeScale: { interval: 60, slotCount: 4 },
            agendaEventTemplate: function agendaEventTemplate() {
                return { template: agendaVue };
            },
            monthEventTemplate: function monthEventTemplate(e) {
                return { template: monthVue };
            },
            group: { resources: ['Owners'] },
            groupData: [],
            startHour: "08:00",
            endHour: "20:00",
            servicos: [],
            clientes: []
        };
    },
    created: function created() {
        this.getNovoAgendamento();
        this.getServicos();
        this.getClientes();
        this.getFuncionario();
        this.atualizaAgendamento();
    },

    provide: {
        schedule: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["b" /* Day */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["c" /* Week */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["d" /* Month */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["e" /* Agenda */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["f" /* Resize */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_schedule__["g" /* DragAndDrop */]]
    },
    computed: {
        eventSettings: function eventSettings() {
            return { dataSource: this.generateData() };
        }
    },
    methods: {
        oneventRendered: function oneventRendered(args) {
            var scheduleObj = this.$refs.ScheduleObj;
            var categoryColor = args.data.CategoryColor;
            if (!args.element || !categoryColor) {
                return;
            }
            if (scheduleObj.ej2Instances.currentView === 'Agenda') {
                args.element.firstChild.style.borderLeftColor = categoryColor;
            } else {
                args.element.style.backgroundColor = categoryColor;
            }
        },
        atualizaAgendamento: function atualizaAgendamento() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://tprint.herokuapp.com/api/agenda").then(function (response) {
                response.data.forEach(function (element) {
                    console.log('element => ', element);
                    if (element.confirmado) {
                        _this.resourceData.push({
                            Cliente: element.cliente.fb_id,
                            NomeCliente: element.cliente.nome + " " + element.cliente.sobrenome + " (" + element.cliente.fb_id + ")",
                            Telefone: element.cliente.contato,
                            Servicos: element.servico_id,
                            Subject: element.servico.nome + " <br /> Cliente: " + element.cliente.nome,
                            StartTime: element.data + "T" + element.hr_inicio,
                            EndTime: element.data + "T" + element.hr_termino,
                            IsAllDay: false,
                            StartTimezone: null,
                            EndTimezone: null,
                            GroupId: element.funcionario.id,
                            Description: element.enderecos.length > 0 ? "Endere\xE7o:      " + element.enderecos[0].endereco.rua + ", " + element.enderecos[0].endereco.numero + "\n                        " + element.enderecos[0].endereco.bairro + " \n                        " + element.enderecos[0].endereco.cidade + " \n                        " + element.enderecos[0].endereco.cep + " " : 'Irá levar no local',
                            Id: element.id,
                            RecurrenceException: null,
                            RecurrenceID: null
                        });
                    }
                });
                _this.carregou = true;
            });
        },
        getNovoAgendamento: function getNovoAgendamento() {
            var _this2 = this;

            Pusher.logToConsole = true;

            var pusher = new Pusher('6846a7777c4cdce67915', {
                cluster: 'us2',
                forceTLS: true
            });

            var channel = pusher.subscribe("agenda" + window.localStorage.getItem('FB_ID'));
            channel.bind('novo', function (data) {
                _this2.atualizaAgendamento();
            });
        },
        onCreate: function onCreate(a) {},
        onActionComplete: function onActionComplete(a) {
            console.log("onActionComplete => ", a);
            if (a.requestType === 'eventRemoved' || a.requestType === 'eventChanged') {
                this.confirmaNotificacao(a.data.Cliente ? a.data.Cliente : a.data[0].Cliente);
            }
        },
        confirmaNotificacao: function confirmaNotificacao(fb_id) {
            var _this3 = this;

            this.$swal({
                title: 'Mensagem de Notificação',
                html: '<textarea class="form-control textarea" rows="3" id="txtNotify" placeholder="Notifique seu cliente sobre a alteração."></textarea>',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Enviar'
            }).then(function (result) {
                if (result.value) {
                    var textarea = document.getElementById('txtNotify').value;
                    _this3.notificarCliente(textarea, fb_id);
                }
            });
        },
        notificarCliente: function notificarCliente(msg, fb_id) {
            var url = this.$store.state.api_bot + "notificar";
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
                'fb_id': fb_id,
                'msg': msg
            });
            this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Clientes Notificados',
                showConfirmButton: false,
                timer: 1500
            });
        },

        generateData: function generateData() {
            var collections = [];
            var dataCollections = [this.resourceData];
            for (var i = 0; i < dataCollections.length; i++) {
                collections = collections.concat(dataCollections[i]);
            }
            return collections;
        },
        onPopupOpen: function onPopupOpen(args) {
            console.log('args ==> ', args);
            if (args.type === "Editor") {
                if (!args.element.querySelector(".custom-field-row")) {

                    var rowLblCliente = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", { className: "custom-field-row" });
                    var row = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", { className: "custom-field-row" });
                    var rowLblTel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", { className: "custom-field-row" });
                    var row2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", { className: "custom-field-row" });
                    var rowTel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", { className: "custom-field-row" });

                    var formElement = args.element.querySelector(".e-schedule-form");

                    formElement.firstChild.insertBefore(rowLblCliente, args.element.querySelector(".e-resources-row"));

                    formElement.firstChild.insertBefore(row, args.element.querySelector(".e-resources-row"));

                    formElement.firstChild.insertBefore(rowLblTel, args.element.querySelector(".e-resources-row"));

                    formElement.firstChild.insertBefore(row2, args.element.querySelector(".e-resources-row"));

                    formElement.firstChild.insertBefore(rowTel, args.element.querySelector(".e-resources-row"));

                    var containerLbl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", {
                        className: "custom-field-container"
                    });

                    var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", {
                        className: "custom-field-container"
                    });

                    var containerLblTel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", {
                        className: "custom-field-container"
                    });

                    var container2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", {
                        className: "custom-field-container"
                    });

                    var container3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("div", {
                        className: "custom-field-container"
                    });

                    var inputEle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("input", {
                        className: "e-field",
                        attrs: { name: "Cliente" }
                    });

                    var inputEle2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("input", {
                        className: "e-field",
                        attrs: { name: "Telefone" }
                    });

                    var inputEle3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("input", {
                        className: "e-field disabled",
                        attrs: { name: "Servicos" }
                    });

                    var labelCliente = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("label", {
                        className: 'e-float-text e-label-top',
                        innerHTML: 'Cliente',
                        styles: 'position: relative'
                    });

                    var labelTel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_base__["b" /* createElement */])("label", {
                        className: 'e-float-text e-label-top',
                        innerHTML: 'Telefone',
                        styles: 'position: relative'
                    });

                    containerLbl.appendChild(labelCliente);
                    container.appendChild(inputEle);
                    containerLblTel.appendChild(labelTel);
                    container2.appendChild(inputEle2);
                    container3.appendChild(inputEle3);

                    rowLblCliente.appendChild(containerLbl);
                    row.appendChild(container);
                    rowLblTel.appendChild(containerLblTel);
                    row2.appendChild(container2);
                    rowTel.appendChild(container3);

                    var input = __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_inputs__["a" /* Input */].createInput({
                        floatLabelType: 'Always',
                        element: formElement,
                        placeholder: "Serviço",
                        value: args.data.Servicos
                    });

                    var input2 = __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_inputs__["a" /* Input */].createInput({
                        floatLabelType: 'Always',
                        element: formElement,
                        placeholder: "Cliente",
                        value: args.data.NomeCliente
                    });

                    var input3 = __WEBPACK_IMPORTED_MODULE_5__syncfusion_ej2_inputs__["a" /* Input */].createInput({
                        floatLabelType: 'Always',
                        element: formElement,
                        placeholder: "Telefone",
                        value: args.data.Telefone
                    });

                    labelCliente.setAttribute("style", "position: relative");
                    labelTel.setAttribute("style", "position: relative");

                    var dropDownList = new __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_dropdowns__["a" /* DropDownList */]({
                        dataSource: this.servicos,
                        fields: { text: "text", value: "value" },
                        value: args.data.Servicos,
                        floatLabelType: "Always",
                        placeholder: "Serviço"
                    });
                    dropDownList.appendTo(inputEle3);
                    inputEle3.setAttribute("name", "Servicos");

                    inputEle.setAttribute("id", "input-cliente");
                    inputEle.setAttribute("style", "margin-bottom: 10px");

                    inputEle2.setAttribute("id", "input-telefone");
                    inputEle2.setAttribute("style", "margin-bottom: 10px");

                    document.getElementById('input-cliente').value = args.data.NomeCliente;
                    document.getElementById('input-telefone').value = args.data.Telefone;
                }
            }
        },
        getServicos: function getServicos() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://tprint.herokuapp.com/api/servicos").then(function (response) {
                response.data.forEach(function (element) {
                    _this4.servicos.push({
                        text: element.nome,
                        value: element.id
                    });
                });
                console.log(_this4.servicos);
            });
        },
        getFuncionario: function getFuncionario() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://tprint.herokuapp.com/api/funcionarios").then(function (response) {
                response.data.forEach(function (element) {
                    _this5.groupData.push({
                        GroupText: element.nome,
                        GroupId: element.id,
                        GroupColor: '#3C8DBC'
                    });
                });
            });
        },
        getClientes: function getClientes() {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://tprint.herokuapp.com/api/clientes").then(function (response) {
                response.data.forEach(function (element) {
                    _this6.clientes.push({
                        text: element.nome,
                        value: element.fb_id
                    });
                });
            });
        }
    }
}));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(235);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Campanhas',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_0__Box___default.a
  },
  data: function data() {
    return {
      campanhas: [],
      colunas: ['Tipo', 'Premio', 'Código Cupom', 'Ativo']
    };
  },
  created: function created() {
    this.getCampanhas();
  },

  methods: {
    getCampanhas: function getCampanhas() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getListaCampanhas().then(function (res) {
        console.log('campanhas => ', res.data);
        _this.campanhas = res.data;
      });
    },
    verificarPremio: function verificarPremio(campanha) {
      if (campanha.frete_gratis) return 'Frete Grátis';else if (campanha.dinheiro_desconto > 0) return 'R$' + campanha.dinheiro_desconto;else if (campanha.porcentagem_desconto > 0) return campanha.porcentagem_desconto + '%';
    },
    changeStatus: function changeStatus(ativo, id) {
      var _this2 = this;

      console.log('ativo => ', ativo);
      console.log('id => ', id);
      var obj = {
        ativo: ativo,
        empresa: this.$store.state.empresa_fb_id
      };
      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].updateCampanha(obj, id).then(function (res) {
        _this2.$swal({
          position: 'top-end',
          type: 'success',
          title: 'Gravado com sucesso',
          showConfirmButton: false,
          timer: 1500
        });
        _this2.getCampanhas();
      }).catch(function (err) {
        _this2.$swal('Ops!', 'Ocorreu um erro na gravação da campanha.', 'error');
        _this2.getCampanhas();
      });
    }
  },
  computed: {},
  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Nova Campanha',
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_1__Modal___default.a,
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      gameColor: 'white',
      ticketColor: 'white',

      selecionado: '',
      tipo_desc: 'frete',
      codigo: '',
      qtde_cupom: 0,
      validade: null,
      desconto: 0,
      ativo: true,
      gravando: false,
      alteracao: false,
      id_alteracao: null
    };
  },

  computed: {},
  created: function created() {
    if (this.$route.params.id) {
      this.alteracao = true;
      this.id_alteracao = this.$route.params.id;
      this.getCampanha(this.id_alteracao);
    }
  },

  methods: {
    getCampanha: function getCampanha(id) {
      var _this = this;

      this.selecionarCard('ticket');
      __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].getCampanhaByID(id).then(function (res) {
        var data = res.data;
        console.log('campanha => ', data);
        _this.ativo = data.ativo;
        _this.tipo_desc = data.frete_gratis ? 'frete' : data.porcentagem_desconto > 0 ? 'porcentagem' : 'dinheiro';
        _this.codigo = data.codigo;
        _this.qtde_cupom = data.qtde_permitida;
        _this.desconto = data.porcentagem_desconto > 0 ? data.porcentagem_desconto : data.dinheiro_desconto;

        var novaData = new Date(data.data_validade);
        var dia = novaData.getDate();
        var mes = novaData.getMonth() + 1;
        var ano = novaData.getFullYear();
        var hr = novaData.getHours().toString();
        var min = novaData.getMinutes().toString();
        _this.validade = ano + '-' + mes + '-' + dia + 'T' + (hr.length === 1 ? '0' + hr : hr) + ':' + (min.length === 1 ? '0' + min : min);
        console.log('nova data => ', _this.validade);
      });
    },
    selecionarCard: function selecionarCard(tipo) {
      this.selecionado = tipo;
      switch (tipo) {
        case 'game':
          this.gameColor = 'fundoAzul';
          this.ticketColor = 'white';
          this.freteColor = 'white';
          break;
        case 'ticket':
          this.gameColor = 'white';
          this.ticketColor = 'fundoAzul';
          this.freteColor = 'white';
          break;
        default:
          break;
      }
    },
    validateFirstStep: function validateFirstStep() {
      if (this.selecionado) return true;
    },
    onComplete: function onComplete() {
      var _this2 = this;

      console.log('data => ', this.validade);
      var data = new Date(this.validade).toLocaleString("en-GB", { timeZone: 'Europe/London' });
      var novaData = data.split(',')[0].split('/')[2] + '-' + data.split(',')[0].split('/')[1] + '-' + data.split(',')[0].split('/')[0] + 'T' + data.split(',')[1];
      console.log('nova data => ', novaData);
      this.gravando = true;
      if (this.codigo && this.qtde_cupom && this.validade && (this.tipo_desc != 'frete' && this.desconto > 0 || this.tipo_desc === 'frete')) {
        var obj = {
          codigo: this.codigo,
          qtde_permitida: this.qtde_cupom,
          data_validade: novaData.replace(' ', ''),
          frete_gratis: this.tipo_desc === 'frete',
          dinheiro_desconto: this.tipo_desc === 'dinheiro' ? this.desconto : 0,
          porcentagem_desconto: this.tipo_desc === 'porcentagem' ? this.desconto : 0,
          ativo: this.ativo,
          empresa: this.$store.state.empresa_fb_id
        };
        if (!this.alteracao) {
          __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].gravarCampanha(obj).then(function (res) {
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Gravado com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
            _this2.$swal(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
              title: 'Notificar Clientes',
              html: 'Deseja notificar os clientes sobre o novo cupom?',
              type: 'success',
              showCancelButton: true,
              cancelButtonColor: '#d33',
              confirmButtonText: 'Cancelar',
              confirmButtonColor: '#3085d6'
            }, 'confirmButtonText', 'Notificar')).then(function (result) {
              if (result.value) {
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this2.$store.state.api + 'clientes?empresa=' + _this2.$store.state.empresa_fb_id).then(function (response) {
                  console.log('clientes ==> ', response.data);
                  _this2.$router.push({ name: 'NotificarClientes', params: { clientes: response.data, cupom: _this2.codigo, tipo: _this2.tipo_desc, desconto: _this2.desconto } });
                });
              } else {
                _this2.$router.go(-1);
              }
            });
          }).catch(function (err) {
            _this2.$swal('Ops!', 'Ocorreu um erro na gravação da campanha.', 'error');
            _this2.gravando = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].updateCampanha(obj, this.id_alteracao).then(function (res) {
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Gravado com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
            _this2.$router.go(-1);
          }).catch(function (err) {
            _this2.$swal('Ops!', 'Ocorreu um erro na gravação da campanha.', 'error');
            _this2.gravando = false;
          });
        }
      } else {
        this.$swal('Ops!', 'Por favor, preencha todos os campos.', 'error');
        this.gravando = false;
      }
    }
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Categorias',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      categorias: [],
      produtos: [],
      allCategories: [],
      colunas: ['id', 'nome', 'imagem', 'ativo', ''],
      order: {
        keys: '',
        sort: ''
      },
      tabAtiva: 'comum'
    };
  },
  created: function created() {
    this.getCategorias();
    this.getProdutos();
  },

  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    categoriasComunsFiltered: function categoriasComunsFiltered() {
      var colecao = _.orderBy(this.allCategories, this.order.keys, this.order.sort);
      return _.filter(colecao, function (item) {
        return item.adicionais === false;
      });
    },
    categoriasAdicionaisFiltered: function categoriasAdicionaisFiltered() {
      var colecao = _.orderBy(this.allCategories, this.order.keys, this.order.sort);
      return _.filter(colecao, function (item) {
        return item.adicionais === true;
      });
    }
  },
  methods: {
    getCategorias: function getCategorias() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.allCategories = response.data;
      });
    },
    ajustarCategorias: function ajustarCategorias() {
      for (var i = 0; i < this.allCategories.length; i++) {
        this.categorias.push({ name: this.allCategories[i].nome, id: this.allCategories[i].id });
      }
    },
    getProdutos: function getProdutos() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'produtos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this2.produtos = response.data;
      });
    },
    excluirCategoria: function excluirCategoria(id) {
      var _this3 = this;

      if (!this.verificaProdutos(id) || id === 1 || id === 2) {
        this.$swal('Ops', 'Esta categoria não pode ser excluida, pois possui produtos associados a ela!', 'error');
      } else {
        this.$swal({
          title: 'Tem certeza que deseja excluir?',
          text: "Você não poderá reverter isto!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, delete!',
          cancelButtonText: 'Não, cancele!',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          buttonsStyling: false,
          reverseButtons: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.$store.state.api + 'categorias/delete', {
              'id': id
            }).then(function (response) {
              if (response.data.success) {
                _this3.getCategorias();
                _this3.$swal({
                  position: 'top-end',
                  type: 'success',
                  title: 'Excluída com sucesso',
                  showConfirmButton: false,
                  timer: 1500
                });
              } else {
                _this3.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
              }
            });
          }
        });
      }
    },
    mudarAtivo: function mudarAtivo(id) {
      console.log('id => ', id);
      $('.active').removeClass('active');
      document.getElementById(id).className = 'active';
      this.tabAtiva = id;
    },
    verificaProdutos: function verificaProdutos(id) {
      for (var i = 0; i < this.produtos.length; i++) {
        if (this.produtos[i].categorias_id === id) {
          return false;
        }
      }
      return true;
    },
    orderCategoria: function orderCategoria(coluna) {
      this.order.keys = coluna;

      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
    }
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Clientes',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      order: {
        keys: '',
        sort: ''
      },
      users: [],
      colunas: ['nome', 'sobrenome', 'sexo', 'contato', 'nascimento', ''],
      filter: ''
    };
  },
  created: function created() {
    this.getUsers();
  },

  methods: {
    getUsers: function getUsers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'clientes?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.users = response.data;
      });
    },
    orderCliente: function orderCliente(coluna) {
      var col;
      if (coluna === 'id_facebook') col = 'fb_id';else col = coluna;
      this.order.keys = col;
      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
    },
    syncClient: function syncClient(fb_id, id) {},
    updateCliente: function updateCliente(cliente, id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.$store.state.api + 'clientes/' + id, {
        nome: cliente.first_name,
        sobrenome: cliente.last_name,
        url_foto: cliente.profile_pic,
        sexo: cliente.gender
      }).then(function (data) {
        _this2.getUsers();
      });
    }
  },
  filters: {
    ajusteData: function ajusteData(value) {
      if (value) {
        var data = value.split('-');
        return [data[2], data[1], data[0]].join('/');
      }
      return value;
    },
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    usersFiltered: function usersFiltered() {
      var _this3 = this;

      var colecao = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.users, this.order.keys, this.order.sort);
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(colecao, function (item) {
        var nome = item.nome.toUpperCase() + ' ' + item.sobrenome.toUpperCase();
        return nome.indexOf(_this3.filter.toUpperCase()) >= 0 || item.facebook_id.indexOf(_this3.filter) >= 0;
      });
    }
  }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CondPagto',
    components: {
        'modal': __WEBPACK_IMPORTED_MODULE_1__Modal___default.a,
        'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
    },
    data: function data() {
        return {
            condpagto: '',
            order: {
                keys: '',
                sort: ''
            },
            colunas: ['id', 'nome'],
            filter: ''
        };
    },
    created: function created() {
        this.getProducts();
    },

    methods: {
        getProducts: function getProducts() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'pagamentos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
                _this.condpagto = response.data;
            });
        },
        excluir: function excluir(id) {
            var _this2 = this;

            this.$swal({
                title: 'Tem certeza que deseja excluir?',
                text: "Você não poderá reverter isto!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, delete!',
                cancelButtonText: 'Não, cancele!',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false,
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.api + 'pagamentos/delete', {
                        'id': id
                    }).then(function (response) {
                        if (response.data.success === 'true') {
                            for (var i = 0; i < _this2.condpagto.length; i++) {
                                if (id === _this2.condpagto[i].id) {
                                    _this2.condpagto.splice(i, 1);
                                }
                            }
                            _this2.$swal({
                                position: 'top-end',
                                type: 'success',
                                title: 'Condição de Pagamento Deletada',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        } else {
                            _this2.$swal('Ops!', 'Não foi possivel deletar o pagamento.', 'error');
                        }
                    });
                } else {
                    _this2.$swal('Ops!', 'Não foi possivel deletar o pagamento.', 'error');
                }
            });
        },
        orderCondPagto: function orderCondPagto(coluna) {
            this.order.keys = coluna;

            this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
        }
    },
    filters: {
        ucwords: function ucwords(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        condPagtoFiltered: function condPagtoFiltered() {
            var _this3 = this;

            var colecao = _.orderBy(this.condpagto, this.order.keys, this.order.sort);
            return _.filter(colecao, function (item) {
                return item.nome.indexOf(_this3.filter) >= 0;
            });
        }
    }
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoBox__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_spinner__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_Large__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_Large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Modal_Large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'info-box': __WEBPACK_IMPORTED_MODULE_3__InfoBox___default.a,
    'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a,
    Circle8: __WEBPACK_IMPORTED_MODULE_5_vue_loading_spinner__["a" /* Circle8 */],
    vueSlider: __WEBPACK_IMPORTED_MODULE_6_vue_slider_component___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_7__Modal_Large___default.a
  },
  data: function data() {
    return {
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      },

      pedidosImprimir: [],
      modal: false,
      pedidos: [],
      novosPedidos: 0,
      totalPedidos: 0,
      agendamentos: [],
      agendamentosHoje: 0,
      todosAgendamentos: 0,
      solicitacoesPendentes: 0,
      todasSolicitacoes: 0,
      atendimentos: 0,
      clientes: 0,
      rankingProdutos: [],
      rankingSoma: [],
      rankingPacotes: [],
      rankingSomaPacotes: [],
      config: [],
      gravar: false,
      tempo_entrega: 0,
      gravando: false,
      visualizou: false,
      loading: true,
      value: 10,
      qtdePedidos: 0,
      total_pedido: 0,
      possuiAgendamento: false,
      possuiDelivery: false,
      possuiAssistencia: false,
      possuiTurismo: false,
      labelTags: [],
      qtdeTags: []
    };
  },

  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    tempo_entrega: function tempo_entrega() {
      this.gravar = true;
    }
  },
  created: function created() {
    this.getAtendimentos();
    this.getClientes();
    this.getConfig();
    this.verificaModulos();
  },

  methods: {
    getPedidos: function getPedidos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'pedidos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.pedidos = response.data;
        _this.totalPedidos = _this.pedidos.length;
        _this.novosPedidos = _this.getNovos();

        setTimeout(function () {
          _this.getPedidos();
        }, 20000);
      });
    },
    getNovos: function getNovos() {
      var cont = 0;
      for (var i = 0; i < this.pedidos.length; i++) {
        if (this.pedidos[i].estado.id === 1) {
          cont++;
        }
      }
      return cont;
    },
    getClientes: function getClientes() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'clientes?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this2.clientes = response.data.length;
      });
    },
    getConfig: function getConfig() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'config?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this3.config = response.data[0];

        _this3.tempo_entrega = _this3.config.tempo_entrega;
        _this3.gravar = false;
      });
    },
    gravarEntrega: function gravarEntrega() {
      var _this4 = this;

      this.gravando = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.api + 'config/tempo-entrega', {
        'tempo_entrega': this.tempo_entrega,
        'empresa': this.$store.state.empresa_fb_id
      }).then(function (response) {
        if (response.data.success === 'true') {
          _this4.$swal({
            position: 'top-end',
            type: 'success',
            title: 'Gravado com Sucesso',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this4.$swal('Ops!', 'Problemas na gravação. Nenhuma alteração realizada.', 'error');
          _this4.getConfig();
        }
        _this4.gravar = false;
        _this4.gravando = false;
      });
    },
    endLoanding: function endLoanding() {
      this.loading = false;
    },
    verificaModulos: function verificaModulos() {
      var _this5 = this;

      var modulos = localStorage.getItem('modulos').split(',');
      console.log('modulos => ', modulos);
      modulos.forEach(function (element) {
        switch (element) {
          case 'delivery':
            _this5.getPedidos();
            _this5.possuiDelivery = true;
            _this5.getRanking();
            break;
          case 'assistencia':
            _this5.getAgendamentos();
            _this5.possuiAgendamento = true;
            _this5.possuiAssistencia = true;
            break;
          case 'agencia_turismo':
            _this5.getSolicitacoes();
            _this5.getRankingPacotes();
            _this5.getTagsPreferidas();
            _this5.possuiTurismo = true;
            break;
          default:
            break;
        }
      });
    },
    getRanking: function getRanking() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'ranking?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          _this6.rankingProdutos.push(response.data[i].produtos.nome);
          _this6.rankingSoma.push(response.data[i].soma);
        }
        var pieChartCanvas = document.getElementById('languagePie').getContext('2d');
        var pieConfig = {
          type: 'doughnut',
          data: {
            labels: _this6.rankingProdutos,
            datasets: [{
              data: _this6.rankingSoma,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this6.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };

        new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
      });
    },
    getRankingPacotes: function getRankingPacotes() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'pacotes/ranking?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].Pacotes) {
            _this7.rankingPacotes.push(response.data[i].Pacotes.titulo);
            _this7.rankingSomaPacotes.push(response.data[i].soma);
          }
        }
        var pieChartCanvas = document.getElementById('rankingPacotes').getContext('2d');
        var pieConfig = {
          type: 'doughnut',
          data: {
            labels: _this7.rankingPacotes,
            datasets: [{
              data: _this7.rankingSomaPacotes,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this7.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        };

        new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
      });
    },
    getTagsPreferidas: function getTagsPreferidas() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'solicitacoes/tags-preferidas?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i]) {
            _this8.labelTags.push(response.data[i].resposta);
            _this8.qtdeTags.push(response.data[i].count);
          }
        }
        console.log('tags => ', _this8.labelTags);
        console.log('qtde => ', _this8.qtdeTags);
        var pieChartCanvas = document.getElementById('tagsPreferidas').getContext('2d');
        var pieConfig = {
          type: 'bar',
          data: {
            labels: _this8.labelTags,
            datasets: [{
              data: _this8.qtdeTags,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !_this8.isMobile,
            legend: {
              position: 'bottom',
              display: false
            },
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            }
          }
        };
        new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
      });
    },
    getSolicitacoes: function getSolicitacoes() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'solicitacoes?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this9.todasSolicitacoes = response.data.length;
        var pendentes = response.data.filter(function (element) {
          return element.statusid === 2;
        });
        console.log('pendentes => ', pendentes);
        _this9.solicitacoesPendentes = pendentes.length;
        setTimeout(function () {
          _this9.getSolicitacoes();
        }, 20000);
      });
    },
    getAgendamentos: function getAgendamentos() {
      var _this10 = this;

      var currentDate = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format().split('T');
      var data = currentDate[0];
      var hr = currentDate[1].substring(0, 5);

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'agenda/next?empresa=' + this.$store.state.empresa_fb_id + '&data=' + data + '&hr=' + hr).then(function (response) {
        _this10.agendamentos = response.data;
        _this10.todosAgendamentos = _this10.agendamentos.length;
        _this10.getAgendamentoHoje();
        setTimeout(function () {
          _this10.getAgendamentos();
        }, 20000);
      });
    },
    getAgendamentoHoje: function getAgendamentoHoje() {
      var _this11 = this;

      this.agendamentosHoje = 0;
      var currentDate = new Date();
      var year = currentDate.getFullYear(),
          month = (currentDate.getMonth() + 1).toString(),
          day = currentDate.getDate();
      this.agendamentos.forEach(function (agendamento) {
        console.log(year + '-' + (month.length == 1 ? '0' + month : month) + '-' + day);
        console.log('agendamento => ', agendamento.data);
        if (agendamento.data === year + '-' + (month.length == 1 ? '0' + month : month) + '-' + day) _this11.agendamentosHoje++;
      });
    },
    getAtendimentos: function getAtendimentos() {
      var _this12 = this;

      var starCountRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.database().ref('logs/require/' + localStorage.getItem('FB_ID'));
      starCountRef.on('value', function (snapshot) {
        var val = snapshot.val();
        console.log('val ===>', val);
        _this12.atendimentos = 0;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val).forEach(function (element) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val[element]).forEach(function (msg) {
            if (val[element][msg]['newOrder']) _this12.atendimentos++;
          });
        });
      });
    }
  },
  computed: {
    coPilotNumbers: function coPilotNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    personalNumbers: function personalNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  mounted: function mounted() {
    this.endLoanding();
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      mostrarBtn: true,
      filtros: [],
      idExcluir: null,
      dialogDel: false,
      editId: null,
      headers: ['ID', 'Descricao', 'Tipo', 'Posicao', 'Ativo', 'Ações'],
      loading: true
    };
  },
  created: function created() {
    this.getFiltros();
  },

  methods: {
    getFiltros: function getFiltros() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */].getListaFiltros(this.id).then(function (response) {
        _this.filtros = response.data;
        _this.loading = false;
      }).catch(function (err) {
        console.log('erro => ', err);
        _this.loading = false;
      });
    },
    showConfirmDel: function showConfirmDel(id) {
      this.idExcluir = id;
      this.dialogDel = true;
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */].dellFiltros(id).then(function (res) {
            _this2.getFiltros();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Servicos_resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_s3__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_timers__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_5__Box___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_6_vue_search_select__["MultiSelect"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      lastSelectItem: {},
      dialog: false,
      filtro: {},
      loading: false,
      dialogErro: false,
      erro: false,
      servicos: [],
      alteracao: false,
      idEditar: 0
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'filtro', {
      descricao: '',
      tipo: '',
      posicao: 0,
      ativo: true,
      opcoes: [{
        opcao: '',
        imagem: ''
      }]
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ativo', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'gravando', false), _ref;
  },
  created: function created() {
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.idEditar = this.$route.params.id;
      this.getFiltro(this.idEditar);
    }
  },

  computed: {
    nome: function nome() {
      if (this.alteracao) return 'alteracao Funcionário';else return 'Novo Funcionário';
    },
    habilitaGravar: function habilitaGravar() {
      return this.filtro.descricao;
    }
  },
  methods: {
    onSelect: function onSelect(items, lastSelectItem) {
      this.filtro.funcao = items;
      this.lastSelectItem = lastSelectItem;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
        $('.delete').removeClass('detele').addClass('fa fa-trash');
      }, 100);
    },
    adicionarOpcao: function adicionarOpcao() {
      this.filtro.opcoes.push({ opcao: '' });
    },
    removerOpcao: function removerOpcao(index) {
      this.filtro.opcoes.splice(index, 1);
    },
    reset: function reset() {
      this.items = [];
    },
    selectFromParentComponent: function selectFromParentComponent() {
      this.items = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.unionWith(this.items, [this.options[0]], __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEqual);
    },
    gravar: function gravar() {
      var _this = this;

      this.gravando = true;
      if (this.filtro.tipo === 'card') {
        var files = this.filtro.opcoes.map(function (element, index) {
          return { index: index, img: document.getElementById('file-filtro-' + index).files[0] };
        });
        files = files.filter(function (el) {
          return el != null && el != undefined;
        });
        console.log('files => ', files);
        if (files.length > 0) {
          files.forEach(function (file, index) {
            if (file.img) {
              __WEBPACK_IMPORTED_MODULE_8__services_s3__["a" /* default */].getSignedRequest(file.img).then(function (res) {
                _this.filtro.opcoes[index].imagem = res.url;
                console.log('filtro ==> ', _this.filtro.opcoes[index]);
              }).catch(function (err) {
                console.log('erro => ', err);
                _this.erro = true;
                alert('Erro ao salvar imagem');
              });
            }
          });
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
          if (!_this.erro) {
            _this.submit();
          }
        }, files.length * 1500);
      } else {
        this.submit();
      }
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('gravar => ', _this2.filtro);
                if (_this2.alteracao) {
                  __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].atualizaFiltro(_this2.filtro, _this2.idEditar).then(function (res) {
                    _this2.$swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Incluido com sucesso',
                      showConfirmButton: false,
                      timer: 1500
                    });
                    _this2.$router.go(-1);
                  }).catch(function (err) {
                    _this2.$swal('Ops!', 'O Filtro não foi gravado.', 'error');
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].gravarFiltro(_this2.filtro).then(function (res) {
                    _this2.$swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Incluido com sucesso',
                      showConfirmButton: false,
                      timer: 1500
                    });
                    _this2.$router.go(-1);
                  }).catch(function (err) {
                    _this2.$swal('Ops!', 'O Filtro não foi gravado.', 'error');
                  });
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getFiltro: function getFiltro() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].getFiltro(this.idEditar).then(function (res) {
        var data = res.data;
        _this3.filtro = {
          descricao: data.descricao,
          tipo: data.tipo,
          posicao: data.posicao,
          ativo: data.ativo,
          opcoes: data.OpcoesFiltros.map(function (opcao) {
            return {
              opcao: opcao.descricao,
              imagem: opcao.imagem
            };
          })
        };
        if (_this3.filtro.opcoes.length === 0) _this3.filtro.opcoes = [{ opcao: '', imagem: '' }];
        console.log('filtro => ', _this3.filtro);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
          $('.delete').removeClass('detele').addClass('fa fa-trash');
        }, 100);
      });
    },
    close: function close() {
      this.setFuncionarioNull();
      this.dialog = false;
      this.$emit('close');
    },
    setFuncionarioNull: function setFuncionarioNull() {
      this.debito = {
        qtde_parcelas: null,
        honorarios: null,
        url_documento: null,
        total_debito: null,
        parcelas: [{
          data_vencimento: null,
          valor: null,
          juros: null,
          correcao: null
        }]
      };
    }
  }
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoFuncionario__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoFuncionario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__novoFuncionario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    appNovoFuncionario: __WEBPACK_IMPORTED_MODULE_0__novoFuncionario___default.a,
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      mostrarBtn: true,
      funcionarios: [],
      idExcluir: null,
      dialogDel: false,
      editId: null,
      headers: ['ID', 'Nome', 'Foto', 'Horário de Entrada', 'Horário de Saída', 'Horário de Entrada (Intervalo)', 'Horário de Saída (Intervalo)', 'Ações'],
      id: this.$route.params.devedorId,
      loading: true
    };
  },
  created: function created() {
    this.getFuncionarios();
  },

  methods: {
    getFuncionarios: function getFuncionarios() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getListaFuncionarios(this.id).then(function (response) {
        _this.funcionarios = response.data;
        _this.loading = false;
      }).catch(function (err) {
        console.log('erro => ', err);
        _this.loading = false;
      });
    },
    editFuncionario: function editFuncionario(id) {
      this.editId = id;
    },
    showConfirmDel: function showConfirmDel(id) {
      this.idExcluir = id;
      this.dialogDel = true;
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].dellFuncionario(id).then(function (res) {
            _this2.getFuncionarios();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Servicos_resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_s3__ = __webpack_require__(29);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_5_vue_search_select__["MultiSelect"]
  },
  data: function data() {
    return {
      lastSelectItem: {},
      dialog: false,
      funcionario: {},
      loading: false,
      dialogErro: false,
      erro: '',
      servicos: [],
      alteracao: false,
      idEditar: 0,
      funcionarioLocal: {
        nome: '',
        hr_entrada: null,
        hr_saida: null,
        hr_inicio_intervalo: null,
        hr_fim_intervalo: null,
        imagem: '',
        funcao: [],
        ativo: false
      },
      ativo: false,
      gravando: false
    };
  },
  created: function created() {
    this.getServicos();
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.idEditar = this.$route.params.id;
      this.getFuncionario(this.idEditar);
    }
  },

  computed: {
    nome: function nome() {
      if (this.alteracao) return 'alteracao Funcionário';else return 'Novo Funcionário';
    },
    habilitaGravar: function habilitaGravar() {
      return this.funcionarioLocal.nome && this.funcionarioLocal.hr_entrada && this.funcionarioLocal.hr_saida && this.funcionarioLocal.hr_inicio_intervalo && this.funcionarioLocal.hr_fim_intervalo && this.funcionarioLocal.funcao;
    }
  },
  methods: {
    onSelect: function onSelect(items, lastSelectItem) {
      this.funcionarioLocal.funcao = items;
      this.lastSelectItem = lastSelectItem;
      setTimeout(function () {
        $('.delete').removeClass('detele').addClass('fa fa-trash');
      }, 100);
    },
    reset: function reset() {
      this.items = [];
    },
    selectFromParentComponent: function selectFromParentComponent() {
      this.items = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.unionWith(this.items, [this.options[0]], __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEqual);
    },
    getServicos: function getServicos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__Servicos_resource__["a" /* default */].getListaServicos().then(function (res) {
        res.data.forEach(function (element, index) {
          _this.servicos.push({
            id: element.id,
            text: element.nome,
            value: index
          });
        });
        _this.dialog = true;
        console.log('servicos ==> ', _this.servicos);
      });
    },
    gravar: function gravar() {
      var _this2 = this;

      this.gravando = true;
      var files = document.getElementById('file-input').files;
      var file = files[0];

      if (file != null) {
        __WEBPACK_IMPORTED_MODULE_7__services_s3__["a" /* default */].getSignedRequest(file).then(function (res) {
          _this2.funcionarioLocal.imagem = res.url;
          _this2.submit();
        }).catch(function (err) {
          alert('Erro ao salvar imagem');
        });
      } else {
        if (this.alteracao) {
          this.submit();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.gravando = false;
        }
      }
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var funcionario;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.pickBy(_this3.funcionarioLocal, function (a) {
                  return a !== null;
                });

              case 2:
                funcionario = _context.sent;

                if (_this3.alteracao) {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].atualizaFuncionario(funcionario, _this3.idEditar).then(function (res) {
                    _this3.dialog = false;
                    _this3.idEditar = null;
                    _this3.alteracao = false;
                    _this3.$router.go(-1);
                  }).catch(function (responseError) {
                    _this3.dialogErro = true;
                    _this3.erro = responseError.response.data.message;
                    _this3.loading = false;
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].gravaFuncionario(_this3.funcionarioLocal).then(function (res) {
                    _this3.dialog = false;
                    _this3.idEditar = null;
                    _this3.alteracao = false;
                    _this3.$router.go(-1);
                  }).catch(function (responseError) {
                    _this3.dialogErro = true;
                    _this3.erro = responseError.response.data.message;
                    _this3.loading = false;
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getFuncionario: function getFuncionario() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getFuncionario(this.idEditar).then(function (res) {
        var data = res.data;
        _this4.funcionarioLocal = {
          id: data.id,
          nome: data.nome,
          hr_entrada: data.hr_entrada,
          hr_saida: data.hr_saida,
          hr_inicio_intervalo: data.hr_inicio_intervalo,
          hr_fim_intervalo: data.hr_fim_intervalo,
          imagem: data.imagem,
          ativo: data.ativo,
          funcao: data.funcoes.map(function (element, index) {
            return { id: element.id, text: element.nome, value: index };
          })
        };
        console.log('funcionario => ', _this4.funcionarioLocal);
        setTimeout(function () {
          $('.delete').removeClass('detele').addClass('fa fa-trash');
        }, 100);
      });
    },
    close: function close() {
      this.setFuncionarioNull();
      this.dialog = false;
      this.$emit('close');
    },
    setFuncionarioNull: function setFuncionarioNull() {
      this.debito = {
        qtde_parcelas: null,
        honorarios: null,
        url_documento: null,
        total_debito: null,
        parcelas: [{
          data_vencimento: null,
          valor: null,
          juros: null,
          correcao: null
        }]
      };
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Help'

});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_s3__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_timers__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_timers__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovaCategoria',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      categorias: [{
        nome: '',
        permitemeia: false,
        adicionais: false,
        imagem: ''
      }],
      categoria_pai: null,
      subnivel: false,
      gravando: false,
      editar: false,
      ativo: true,
      erro: false
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id);
      this.editar = true;
    }
  },

  methods: {
    gravar: function gravar() {
      var _this = this;

      this.gravando = true;
      var files = this.categorias.map(function (element, index) {
        return document.getElementById('file-input-' + index).files[0];
      });
      files = files.filter(function (el) {
        return el != null && el != undefined;
      });
      console.log('files => ', files);
      if (files.length > 0) {
        files.forEach(function (file, index) {
          var blob = file.slice(0, file.size, file.type);
          var newFile = new File([blob], _this.$store.state.empresa_id + '_categoria_' + Date.now() + '_' + file.name, { type: file.type });
          __WEBPACK_IMPORTED_MODULE_2__services_s3__["a" /* default */].getSignedRequest(newFile).then(function (res) {
            _this.categorias[index].imagem = res.url;
          }).catch(function (err) {
            console.log('erro => ', err);
            _this.erro = true;
            alert('Erro ao salvar imagem');
          });
        });
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_timers__["setTimeout"])(function () {
        if (!_this.erro) {
          _this.gravarCategoria();
        }
      }, files.length * 1500);
    },
    removerCategoria: function removerCategoria(index) {
      this.categorias.splice(index, 1);
    },
    gravarCategoria: function gravarCategoria() {
      var _this2 = this;

      this.categorias.forEach(function (categoria) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.api + 'categorias/insert', {
          'nome': categoria.nome,

          'imagem': categoria.imagem,
          'alteracao': false,
          'id_categoria': _this2.$route.params.id,
          'permitemeia': categoria.permitemeia,
          'adicionais': categoria.adicionais,
          'ativo': true,
          'empresa': _this2.$store.state.empresa_fb_id
        }).then(function (response) {
          if (!response.data.success) {
            _this2.erro = true;
          }
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_timers__["setTimeout"])(function () {
          if (_this2.erro) {
            _this2.$swal('Ops!', 'A categoria não foi gravada.', 'error');
          } else {
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Criada com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
            _this2.$router.push('categorias');
          }
        }, _this2.categorias.length * 2000);
      });
    },
    adicionarCategoria: function adicionarCategoria() {
      this.categorias.push({
        nome: '',
        permitemeia: false,
        adicionais: false
      });
    },
    getCategoriaById: function getCategoriaById(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias/' + id).then(function (response) {
        console.log('categorias -> ', response.data);
        _this3.nome = response.data.nome, _this3.imagem = response.data.url_imagem;
        _this3.permitemeia = response.data.permitemeia;
        _this3.adicionais = response.data.adicionais;
        _this3.ativo = response.data.ativo;
      });
    }
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_s3__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timers__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovoProduto',
  directives: { money: __WEBPACK_IMPORTED_MODULE_2_v_money__["VMoney"] },
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      erro: false,
      categories: [],
      produtos: [{
        formularioPreco: [{
          preco: 0,
          id_cardapio: 0
        }],
        nome: '',
        descricao: '',
        preco: 0,
        imagem: '',
        ativo: true,
        permiteadicionais: false,
        adicional: null
      }],
      allCategories: [],
      gravando: false,
      money: {
        thousands: ',',
        decimal: '.',

        precision: 2
      }
    };
  },
  created: function created() {
    this.getCategories();
  },

  computed: {
    habilitaGravar: function habilitaGravar() {
      if (this.nome != '' && this.descricao != '' && !this.gravando) {
        for (var i in this.formularioPreco) {
          if (this.formularioPreco[i].id_cardapio === 0) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  },
  methods: {
    adicionaPreco: function adicionaPreco(iProd) {
      this.produtos[iProd].formularioPreco.push({
        preco: 0,
        categoria: 0
      });
    },
    removerPreco: function removerPreco(index, iProd) {
      this.produtos[iProd].formularioPreco.splice(index, 1);
    },
    removerProduto: function removerProduto(iProd) {
      this.produtos.splice(iProd, 1);
    },
    adicionarCategoria: function adicionarCategoria() {
      this.produtos.push({
        formularioPreco: [{
          preco: 0,
          id_cardapio: 0
        }],
        nome: '',
        descricao: '',
        preco: 0,
        imagem: '',
        ativo: true,
        permiteadicionais: false,
        adicional: null
      });
    },
    getCategories: function getCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.categories = response.data;
      });
    },
    ajustaCategorias: function ajustaCategorias() {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (this.verificaFolha(this.allCategories[i].id)) {
          this.categories.push(this.allCategories[i]);
        } else {
          if (this.allCategories[i].children.length > 0) {
            for (var j = 0; j < this.allCategories[i].children.length; j++) {
              if (this.verificaFolha(this.allCategories[i].children[j].id)) {
                this.categories.push(this.allCategories[i].children[j]);
              }
            }
          }
        }
      }
    },
    verificaFolha: function verificaFolha(id) {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (id === this.allCategories[i].pai) {
          return false;
        } else {
          for (var j = 0; j < this.allCategories[i].children.length; j++) {
            if (id === this.allCategories[i].children[j].pai) {
              return false;
            }
          }
        }
      }
      return true;
    },
    gravar: function gravar() {
      var _this2 = this;

      this.gravando = true;
      var files = this.produtos.map(function (element, index) {
        return document.getElementById('file-input-' + index).files[0];
      });
      files = files.filter(function (el) {
        return el != null && el != undefined;
      });
      console.log('files => ', files);
      if (files.length > 0) {
        files.forEach(function (file, index) {
          var blob = file.slice(0, file.size, file.type);
          var newFile = new File([blob], _this2.$store.state.empresa_id + '_produto_' + Date.now() + '_' + file.name, { type: file.type });
          __WEBPACK_IMPORTED_MODULE_3__services_s3__["a" /* default */].getSignedRequest(newFile).then(function (res) {
            _this2.produtos[index].imagem = res.url;
          }).catch(function (err) {
            console.log('erro => ', err);
            _this2.erro = true;
            alert('Erro ao salvar imagem');
          });
        });
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
        if (!_this2.erro) {
          _this2.gravarProduto();
        }
      }, files.length * 1500);
    },
    getObjEnvio: function getObjEnvio(index) {
      var objRetorno = [],
          campos = {};
      campos.nome = this.produtos[index].nome;
      campos.descricao = this.produtos[index].descricao;
      campos.url_imagem = this.produtos[index].imagem;
      campos.permiteadicionais = this.produtos[index].permiteadicionais;
      campos.ativo = this.produtos[index].ativo;
      if (this.produtos[index].adicional) campos.adicional = this.produtos[index].adicional;
      campos.alteracao = this.produtos[index].alteracao;
      campos.id = this.produtos[index].id_alteracao;
      campos.tabelapreco = [];
      for (var i in this.produtos[index].formularioPreco) {
        var tabelapreco = {};
        tabelapreco.preco = parseFloat(this.produtos[index].formularioPreco[i].preco);
        tabelapreco.categoria = this.produtos[index].formularioPreco[i].id_cardapio;
        campos.tabelapreco.push(tabelapreco);
      }
      campos.empresa = this.$store.state.empresa_fb_id;
      objRetorno.push(campos);
      return objRetorno;
    },
    gravarProduto: function gravarProduto() {
      var _this3 = this;

      this.produtos.forEach(function (produto, index) {
        var objRetorno = _this3.getObjEnvio(index);
        console.log(objRetorno);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.$store.state.api + 'produtos/insert', objRetorno).then(function (response) {
          if (!response.data.success) {
            _this3.erro = true;
          }
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
          if (!_this3.erro) {
            _this3.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Incluido com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
            _this3.$router.push('produtos');
          } else {
            _this3.$swal('Ops!', 'O produto não foi gravado.', 'error');
          }
        }, _this3.produtos.length * 2000);
      });
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBox',
  props: ['icon', 'colorIcon']
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MinhaConta',
    components: {
        'box': __WEBPACK_IMPORTED_MODULE_0__Box___default.a
    },
    data: function data() {
        return {
            fullName: this.$store.state.nome_completo,
            userName: this.$store.state.nome_usuario,
            url_foto: this.$store.state.foto === 'https://wordsandvideos.com/wp-content/uploads/2016/12/common.png' ? '' : this.$store.state.foto,
            email: this.$store.state.email,
            password: window.localStorage.getItem('senha'),
            gravando: false
        };
    },

    methods: {
        gravar: function gravar() {
            this.gravando = true;

            var files = document.getElementById('file-input').files;
            var file = files[0];
            if (file != null) {
                this.getSignedRequest(file);
            } else {
                this.url_foto = this.$store.state.foto;
                console.log(this.url_foto);
                this.gravarUsuario();
            }
        },
        getSignedRequest: function getSignedRequest(file) {
            var _this = this;

            var xhr = new XMLHttpRequest();
            console.log(file.name);
            xhr.open('GET', this.$store.state.api + ('s3/sign-s3?file-name=' + file.name + '&file-type=' + file.type));
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        _this.uploadFile(file, response.signedRequest, response.url);
                    } else {
                        alert('Could not get signed URL.');
                    }
                }
            };
            xhr.send();
        },
        uploadFile: function uploadFile(file, signedRequest, url) {
            var _this2 = this;

            console.log('signed: ', signedRequest);
            console.log('url: ', url);
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', signedRequest);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        _this2.url_foto = url;

                        _this2.gravarUsuario();
                    } else {
                        alert('Por favor, selecione uma imagem.');
                        _this2.gravando = false;
                    }
                }
            };
            xhr.send(file);
        },
        gravarUsuario: function gravarUsuario() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://dashboard-sev.herokuapp.com/usuarios/alter', {
                'nome_usuario': this.userName,
                'nome_completo': this.fullName,
                'foto': this.url_foto,
                'email': this.email
            }).then(function (response) {
                if (response.data.success) {
                    _this3.$swal({
                        position: 'top-end',
                        type: 'success',
                        title: 'Gravado com sucesso',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    _this3.$router.push('dashboard');
                } else {
                    _this3.$swal('Ops!', 'O usuário não foi gravado.', 'error');
                }
            });
        }
    }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['index', 'linha'],
    data: function data() {
        return {
            colunas_impressao: ['Qtd', 'Item', 'Preco'],
            colunas_pagamento: ['Formas Pagamento', '']
        };
    },
    created: function created() {
        console.log('pedidos -> ', this.linha);
    },

    filters: {
        trataData: function trataData(value) {
            if (value) {
                var data = new Date(value);
                var dia = data.getDate();
                var mes = data.getMonth() + 1;
                var ano = data.getFullYear();
                var hr = data.getHours();
                var min = data.getMinutes();
                return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min;
            }
        }
    }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ordenarprodutos',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      clientes: [],
      notificar: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      filter1: '',
      filter2: '',
      msg: '',
      enviarReplies: false,
      replies: []
    };
  },
  created: function created() {
    console.log('CREATEEE ==> ', this.$route.params);
    this.clientes = this.$route.params.clientes;
    if (this.$route.params.cupom) {
      var tipoDesc = this.$route.params.tipo === 'frete' ? 'Frete grátis' : this.$route.params.tipo === 'porcentagem' ? this.$route.params.desconto + '% de desconto' : 'R$' + this.$route.params.desconto + ' de desconto';
      this.msg = 'Utilize o cupom \'' + this.$route.params.cupom.toUpperCase() + '\' para receber ' + tipoDesc;
    }
  },

  methods: {
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    nome: function nome(_nome, sobrenome) {
      return _nome + ' ' + sobrenome;
    },
    selecionarTodos: function selecionarTodos() {
      var _this = this;

      this.clientes.forEach(function (element) {
        _this.notificar.push(element);
      });
      this.clientes = [];
    },
    removerTodos: function removerTodos() {
      var _this2 = this;

      this.notificar.forEach(function (element) {
        _this2.clientes.push(element);
      });
      this.notificar = [];
    },
    selecionar: function selecionar(cliente) {
      var _this3 = this;

      var cliente_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      this.clientes.forEach(function (element, index) {
        var fb_id = element.fb_id ? element.fb_id : element.facebook_id;
        if (fb_id === cliente_id) {
          _this3.notificar.push(cliente);
          _this3.clientes.splice(index, 1);
          return;
        }
      });
    },
    remover: function remover(cliente) {
      var _this4 = this;

      var cliente_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      this.notificar.forEach(function (element, index) {
        var fb_id = element.fb_id ? element.fb_id : element.facebook_id;
        if (fb_id === cliente_id) {
          _this4.clientes.push(cliente);
          _this4.notificar.splice(index, 1);
          return;
        }
      });
    },
    notificarClientes: function notificarClientes() {
      if (!this.enviarReplies) this.replies = [];
      var url = this.$store.state.api_bot + 'notificar';
      var ids = this.notificar.map(function (el) {
        return el.id;
      });
      console.log('notificar => ', ids);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        ids: ids,
        'msg': this.msg,
        'replies': this.replies
      });

      this.$swal({
        position: 'top-end',
        type: 'success',
        title: 'Clientes Notificados',
        showConfirmButton: false,
        timer: 1500
      });
      this.$router.go(-1);
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
    usersFiltered1: function usersFiltered1() {
      var _this5 = this;

      return _.filter(this.clientes, function (item) {
        var nome = item.nome.toUpperCase() + ' ' + item.sobrenome.toUpperCase();
        return nome.indexOf(_this5.filter1.toUpperCase()) >= 0;
      });
    },
    usersFiltered2: function usersFiltered2() {
      var _this6 = this;

      return _.filter(this.notificar, function (item) {
        var nome = item.nome.toUpperCase() + ' ' + item.sobrenome.toUpperCase();
        return nome.indexOf(_this6.filter2.toUpperCase()) >= 0;
      });
    }
  },
  watch: {
    isDragging: function isDragging(newValue) {
      var _this7 = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this7.delayedDragging = false;
      });
    }
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_s3__ = __webpack_require__(29);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovaCategoria',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_3__Box___default.a
  },
  data: function data() {
    return {
      nome: '',
      allCategories: [],
      categories: [],
      categoria_pai: null,
      subnivel: false,
      gravando: false,
      imagem: '',
      editar: false,
      permitemeia: false,
      adicionais: false,
      ativo: true
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id);
      this.editar = true;
    }
  },

  methods: {
    gravar: function gravar() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var files, file, blob, newFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.gravando = true;
                files = document.getElementById('file-input').files;
                file = files[0];


                if (file != null) {
                  blob = file.slice(0, file.size, file.type);

                  console.log('blob => ', blob);
                  newFile = new File([blob], _this.$store.state.empresa_id + '_categoria_' + Date.now() + '_' + file.name.replace(' ', '_'), { type: file.type });


                  __WEBPACK_IMPORTED_MODULE_4__services_s3__["a" /* default */].getSignedRequest(newFile).then(function (res) {
                    _this.imagem = res.url;
                    _this.gravarCategoria();
                  }).catch(function (err) {
                    console.log(err);
                    alert('Erro ao salvar imagem');
                  });
                } else {
                  if (_this.editar) {
                    _this.gravarCategoria();
                  } else {
                    alert('É necessário selecionar uma imagem.');
                    _this.gravando = false;
                  }
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    gravarCategoria: function gravarCategoria() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$store.state.api + 'categorias/insert', {
        'nome': this.nome,

        'imagem': this.imagem,
        'alteracao': this.editar,
        'id_categoria': this.$route.params.id,
        'permitemeia': this.permitemeia,
        'adicionais': this.adicionais,
        'ativo': this.ativo,
        'empresa': this.$store.state.empresa_fb_id
      }).then(function (response) {
        if (response.data.success) {
          _this2.$swal({
            position: 'top-end',
            type: 'success',
            title: 'Criada com sucesso',
            showConfirmButton: false,
            timer: 1500
          });
          _this2.$router.go(-1);
        } else {
          _this2.$swal('Ops!', 'A categoria não foi gravada.', 'error');
        }
      });
    },
    getCategoriaById: function getCategoriaById(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'categorias/' + id).then(function (response) {
        console.log('categorias -> ', response.data);
        _this3.nome = response.data.nome, _this3.imagem = response.data.url_imagem;
        _this3.permitemeia = response.data.permite_meia;
        _this3.adicionais = response.data.adicionais;
        _this3.ativo = response.data.ativo;
      });
    }
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovaCondPagto',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      nome: '',
      gravando: false
    };
  },
  created: function created() {},

  methods: {
    gravar: function gravar() {
      var _this = this;

      this.gravando = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.api + 'pagamentos/insert', {
        'nome': this.nome
      }).then(function (response) {
        if (response.data.success === 'true') {
          _this.$swal({
            position: 'top-end',
            type: 'success',
            title: 'Condição de Pagamento criada com sucesso',
            showConfirmButton: false,
            timer: 1500
          });
          _this.$router.push('condpagto');
        } else {
          _this.$swal('Ops!', 'A categoria não foi gravada.', 'error');
        }
      });
    }
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_s3__ = __webpack_require__(29);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovoProduto',
  directives: { money: __WEBPACK_IMPORTED_MODULE_2_v_money__["VMoney"] },
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      possuiFuncionamento: false,
      funcionamento: [{
        ativo: true,
        dia: 'domingo',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'segunda',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'terca',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'quarta',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'quinta',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'sexta',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }, {
        ativo: true,
        dia: 'sabado',
        hr_abertura_1: '00:00',
        hr_abertura_2: '00:00',
        hr_fechamento_1: '00:00',
        hr_fechamento_2: '00:00'
      }],
      tabAtiva: 'dados',
      allCategories: [],
      formularioPreco: [{
        preco: 0,
        id_cardapio: 0
      }],
      categories: [],
      nome: '',
      descricao: '',
      codigo_interno: null,
      categoria_selecionada: '',
      preco: 0,
      imagem: '',
      alteracao: false,
      id_alteracao: 0,
      gravando: false,
      money: {
        thousands: ',',
        decimal: '.',

        precision: 2
      },
      permiteadicionais: false,
      ativo: true,
      adicional: null,
      adicionais: [{
        categoria: null,
        qtde: 0,
        exigido: false
      }]
    };
  },
  created: function created() {
    console.log('ativo ', this.tabAtiva);
    this.getCategories();
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.id_alteracao = this.$route.params.id;
      this.getProdutos(this.id_alteracao);
      this.getTabelaPreco(this.id_alteracao);
      this.getFuncionamento(this.id_alteracao);
    }
  },

  computed: {
    habilitaGravar: function habilitaGravar() {
      if (this.nome != '' && this.descricao != '' && !this.gravando) {
        for (var i in this.formularioPreco) {
          if (this.formularioPreco[i].id_cardapio === 0) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  },
  methods: {
    mudarAtivo: function mudarAtivo(id) {
      console.log('id => ', id);
      $('.active').removeClass('active');
      document.getElementById(id).className = 'active';
      this.tabAtiva = id;
    },
    adicionaPreco: function adicionaPreco() {
      this.formularioPreco.push({
        preco: 0,
        categoria: 0
      });
    },
    removerPreco: function removerPreco(index) {
      this.formularioPreco.splice(index, 1);
    },
    addAdicionais: function addAdicionais() {
      this.adicionais.push({
        categoria: null,
        qtde: 0,
        exigido: false
      });
    },
    removerAdicional: function removerAdicional(index) {
      this.adicionais.splice(index, 1);
    },
    getCategories: function getCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.categories = response.data;
      });
    },
    ajustaCategorias: function ajustaCategorias() {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (this.verificaFolha(this.allCategories[i].id)) {
          this.categories.push(this.allCategories[i]);
        } else {
          if (this.allCategories[i].children.length > 0) {
            for (var j = 0; j < this.allCategories[i].children.length; j++) {
              if (this.verificaFolha(this.allCategories[i].children[j].id)) {
                this.categories.push(this.allCategories[i].children[j]);
              }
            }
          }
        }
      }
    },
    verificaFolha: function verificaFolha(id) {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (id === this.allCategories[i].pai) {
          return false;
        } else {
          for (var j = 0; j < this.allCategories[i].children.length; j++) {
            if (id === this.allCategories[i].children[j].pai) {
              return false;
            }
          }
        }
      }
      return true;
    },
    getFuncionamento: function getFuncionamento(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'produtos/funcionamento/' + id).then(function (response) {
        console.log('funcionamento ', response);
        if (response.data.length > 0) {
          _this2.possuiFuncionamento = true;
          _this2.funcionamento = response.data;
        }
      });
    },
    getTabelaPreco: function getTabelaPreco(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'tabelapreco/' + id).then(function (response) {
        _this3.formularioPreco = [];
        for (var i in response.data) {
          response.data[i].preco = response.data[i].preco.toFixed(2);
          if (response.data[i].id_categoria) response.data[i].id_cardapio = response.data[i].id_categoria;
          _this3.formularioPreco.push(response.data[i]);
        }
        console.log('tabela preco -> ', _this3.formularioPreco);
      });
    },
    getProdutos: function getProdutos(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'produtos/' + id).then(function (response) {
        var products = response.data[0];

        _this4.nome = products.nome;
        _this4.descricao = products.descricao;
        _this4.imagem = products.url_imagem;
        _this4.codigo_interno = products.codigo_interno, _this4.permiteadicionais = products.permiteadicionais, _this4.ativo = products.ativo;
        _this4.adicional = products.adicionais;
        if (products.ProdutosAdicionais && products.ProdutosAdicionais.length > 0) {
          _this4.adicionais = products.ProdutosAdicionais.map(function (element) {
            return { categoria: element.cardapio_id.toString(), exigido: element.exigido, qtde: parseInt(element.qtde_permitida) };
          });
        }

        _this4.$store.commit('SET_ID_ALTERACAO', 0);
      });
    },
    gravar: function gravar() {
      var _this5 = this;

      this.gravando = true;
      var files = document.getElementById('file-input').files;
      var file = files[0];

      if (file != null) {
        var blob = file.slice(0, file.size, file.type);
        var newFile = new File([blob], this.$store.state.empresa_id + '_produto_' + Date.now() + '_' + file.name.replace(' ', '_'), { type: file.type });
        console.log('new file ==> ', newFile);
        __WEBPACK_IMPORTED_MODULE_3__services_s3__["a" /* default */].getSignedRequest(newFile).then(function (res) {
          _this5.imagem = res.url;
          _this5.gravarProduto();
        }).catch(function (err) {
          alert('Erro ao salvar imagem');
        });
      } else {
        this.gravarProduto();
      }
    },
    getObjEnvio: function getObjEnvio() {
      var objRetorno = [],
          campos = {};
      campos.nome = this.nome;
      campos.descricao = this.descricao;
      campos.url_imagem = this.imagem;
      campos.permiteadicionais = this.permiteadicionais;
      campos.ativo = this.ativo;
      if (this.codigo_interno !== '') campos.codigo_interno = this.codigo_interno;

      if (this.permiteadicionais) campos.adicionais = this.adicionais;
      campos.alteracao = this.alteracao;
      campos.id = this.id_alteracao;
      campos.tabelapreco = [];
      for (var i in this.formularioPreco) {
        var tabelapreco = {};
        tabelapreco.preco = parseFloat(this.formularioPreco[i].preco);
        tabelapreco.categoria = this.formularioPreco[i].id_cardapio;
        campos.tabelapreco.push(tabelapreco);
      }
      campos.empresa = this.$store.state.empresa_fb_id;
      objRetorno.push(campos);
      return objRetorno;
    },
    gravarProduto: function gravarProduto() {
      var _this6 = this;

      var objRetorno = this.getObjEnvio();
      console.log(objRetorno);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.api + 'produtos/insert', objRetorno).then(function (response) {
        console.log('response ==> ', response);
        if (response.data.success) {
          if (_this6.possuiFuncionamento) {
            if (_this6.alteracao) {
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this6.$store.state.api + 'produtos/funcionamento', {
                produto: response.data.produto,
                funcionamento: _this6.funcionamento
              }).then(function (res) {
                _this6.atualizarCron();
                _this6.$swal({
                  position: 'top-end',
                  type: 'success',
                  title: 'Incluido com sucesso',
                  showConfirmButton: false,
                  timer: 1500
                });
                _this6.$router.go(-1);
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this6.$store.state.api + 'produtos/funcionamento', {
                produto: response.data.produto,
                funcionamento: _this6.funcionamento
              }).then(function (res) {
                _this6.atualizarCron();
                _this6.$swal({
                  position: 'top-end',
                  type: 'success',
                  title: 'Incluido com sucesso',
                  showConfirmButton: false,
                  timer: 1500
                });
                _this6.$router.go(-1);
              });
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(_this6.$store.state.api + 'produtos/funcionamento/' + response.data.produto, {}).then(function (res) {
              _this6.atualizarCron();
              _this6.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Incluido com sucesso',
                showConfirmButton: false,
                timer: 1500
              });
              _this6.$router.go(-1);
            });
          }
        } else {
          _this6.$swal('Ops!', 'O produto não foi gravado.', 'error');
        }
      });
    },
    atualizarCron: function atualizarCron() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://senhor-destino.herokuapp.com/restart');
    }
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_decrypt_js__ = __webpack_require__(242);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NovoUsuario',
    components: {
        'modal': __WEBPACK_IMPORTED_MODULE_3__Modal___default.a,
        'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a,
        MultiSelect: __WEBPACK_IMPORTED_MODULE_6_vue_search_select__["MultiSelect"]
    },
    data: function data() {
        return {
            email_atual: window.localStorage.getItem('usuario'),
            senha_atual: __WEBPACK_IMPORTED_MODULE_8__services_decrypt_js__["a" /* default */].descriptografar(localStorage.getItem('password')),
            options: [],
            gravando: false,
            mostrandoSenha: false,
            dadosPessoais: {
                fullName: '',
                userName: '',
                img: ''
            },
            dadosLogin: {
                email: '',
                password: '',
                itens: []
            },
            rules: {
                fullName: [{
                    required: true,
                    message: 'Por favor informe o nome completo',
                    trigger: 'blur' }],
                userName: [{
                    required: true,
                    message: 'Por favor Informe o nome de usuário',
                    trigger: 'blur'
                }]
            },
            rulesLogin: {
                email: [{
                    required: true,
                    message: 'Por favor informe o email',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: 'Por favor informe a senha',
                    trigger: 'blur'
                }, {
                    min: 6,
                    max: 15,
                    message: 'Senha deve ter entre 6 e 15 caracteres',
                    trigger: 'change'
                }],
                itens: [{
                    required: true,
                    message: 'Por favor informe as empresas que terá acesso',
                    trigger: 'blur'
                }]

            }
        };
    },

    computed: {
        empresas: function empresas() {
            var empresas = '';
            for (var i in this.dadosLogin.itens) {
                if (empresas === '') empresas = this.dadosLogin.itens[i].text;else empresas += '/ ' + this.dadosLogin.itens[i].text;
            }
            return empresas;
        }
    },
    created: function created() {
        this.ajusteOptions(this.$store.state.empresas);
    },

    methods: {
        onSelect: function onSelect(itens, lastSelectItem) {
            this.dadosLogin.itens = itens;
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.delete').removeClass('detele').addClass('fa fa-trash');
            }, 100);
        },
        reset: function reset() {
            this.dadosLogin.itens = [];
        },
        ajusteOptions: function ajusteOptions(empresas) {
            for (var i = 0; i < empresas.length; i++) {
                this.options.push({ text: empresas[i].nome, value: i, id: empresas[i].id });
            }
        },

        onComplete: function onComplete() {
            this.gravando = true;
            this.newUsuario();
        },
        newUsuario: function newUsuario() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().createUserWithEmailAndPassword(this.dadosLogin.email, this.dadosLogin.password).then(function () {
                var files = document.getElementById('file-input').files;
                var file = files[0];
                if (file != null) {
                    _this.getSignedRequest(file);
                } else {
                    _this.gravarUsuario();
                }
            }).catch(function (error) {
                var errorMessage = error.message;
                document.getElementById('error').textContent = errorMessage;
                this.gravando = false;
            });
        },
        getSignedRequest: function getSignedRequest(file) {
            var _this2 = this;

            var xhr = new XMLHttpRequest();
            console.log(file.name);
            xhr.open('GET', this.$store.state.api + ('s3/sign-s3?file-name=' + file.name + '&file-type=' + file.type));
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        _this2.uploadFile(file, response.signedRequest, response.url);
                    } else {
                        _this2.gravando = false;
                        alert('Could not get signed URL.');
                    }
                }
            };
            xhr.send();
        },
        uploadFile: function uploadFile(file, signedRequest, url) {
            var _this3 = this;

            var xhr = new XMLHttpRequest();
            xhr.open('PUT', signedRequest);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        _this3.dadosPessoais.img = url;

                        _this3.gravarUsuario();
                    } else {
                        alert('Por favor, selecione uma imagem.');
                        _this3.gravando = false;
                    }
                }
            };
            xhr.send(file);
        },
        gravarUsuario: function gravarUsuario() {
            var _this4 = this;

            if (!this.dadosPessoais.img) this.dadosPessoais.img = 'https://wordsandvideos.com/wp-content/uploads/2016/12/common.png';
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://sev-delivery.herokuapp.com/api/usuarios/insert', {
                'nome_usuario': this.dadosPessoais.userName,
                'email': this.dadosLogin.email,
                'foto': this.dadosPessoais.img,
                'empresas': this.dadosLogin.itens
            }).then(function (response) {
                if (response.data.success) {
                    _this4.dadosLogin.itens.forEach(function (empresa) {
                        var url = _this4.$store.state.empresas[empresa.value].api;

                        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + 'usuarios', {
                            'email': _this4.dadosLogin.email
                        }).catch(function (err) {
                            console.log('Usu\xE1rio n\xE3o foi gravado na empresa ' + empresa.nome + '.');
                        });
                    });

                    __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().signInWithEmailAndPassword(_this4.email_atual, _this4.senha_atual).then(function (user) {
                        _this4.$router.push('dashboard');
                        _this4.$swal({
                            position: 'top-end',
                            type: 'success',
                            title: 'Gravado com sucesso',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }, function (Error) {
                        console.log(Error.message);
                    });
                } else {
                    _this4.$swal('Ops!', 'Usuário não foi gravado.', 'error');
                    _this4.gravando = false;
                }
            });
        },
        validateFirstStep: function validateFirstStep() {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this5.$refs.ruleForm.validate(function (valid) {
                    resolve(valid);
                    document.addEventListener;
                });
            });
        },
        validateSecondStep: function validateSecondStep() {
            var _this6 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this6.$refs.ruleFormLogin.validate(function (valid) {
                    if (_this6.dadosLogin.itens.length === 0) valid = false;
                    resolve(valid);
                });
            });
        },
        mostrarSenha: function mostrarSenha(change) {
            if (change === 'mostrar') {
                document.getElementById('password').type = 'text';
                this.mostrandoSenha = true;
            } else {
                document.getElementById('password').type = 'password';
                this.mostrandoSenha = false;
            }
        }
    }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrdenarCategorias',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      categorias: [],
      editable: true,
      isDragging: false,
      delayedDragging: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
      _this.categorias = _.orderBy(response.data, 'posicao', 'asc');
      console.log('categorias ==> ', _this.categorias);
      _this.categorias = _this.categorias.filter(function (el) {
        return !el.adicionais;
      });
    });
  },

  methods: {
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      console.log('relatedElement => ', relatedElement);
      console.log('draggedElement => ', draggedElement);
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    gravarOrdem: function gravarOrdem() {
      var _this2 = this;

      this.categorias.forEach(function (element, index) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this2.$store.state.api + 'categorias/insert', {
          'alteracao': true,
          'id_categoria': element.id,
          'posicao': index,
          'empresa': _this2.$store.state.empresa_fb_id
        });
      });
      this.$swal({
        position: 'top-end',
        type: 'success',
        title: 'Ordem Salva',
        showConfirmButton: false,
        timer: 1500
      });
      this.$router.go(-1);
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    isDragging: function isDragging(newValue) {
      var _this3 = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this3.delayedDragging = false;
      });
    }
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ordenarprodutos',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      categorias: [],
      editable: true,
      ordenados: [],
      isDragging: false,
      delayedDragging: false
    };
  },
  created: function created() {
    this.getCategories();
  },

  methods: {
    getCategories: function getCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'produtos/ordem?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.categorias = response.data;
        console.log('categorias ==> ', _this.produtos);
        _this.categorias = _this.categorias.filter(function (el) {
          return !el.adicionais;
        });
      });
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      console.log('relatedElement => ', relatedElement);
      console.log('draggedElement => ', draggedElement);
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    gravarOrdem: function gravarOrdem() {
      var _this2 = this;

      this.categorias.forEach(function (element) {
        element.OrdemProdutos.forEach(function (produto, index) {
          console.log('gravar => ', index);
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this2.$store.state.api + 'produtos/ordem', {
            'id': produto.ordem_produtos.id,
            'posicao': index
          });
        });
      });
      this.$swal({
        position: 'top-end',
        type: 'success',
        title: 'Ordem Salva',
        showConfirmButton: false,
        timer: 1500
      });
      this.$router.go(-1);
    },
    ajustarCollapse: function ajustarCollapse(index) {
      var size = this.categorias.length;
      console.log('index => ', index);
      for (var i = 0; i < size; i++) {
        console.log('#collapse' + i);
        if (i !== index) __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#collapse' + i).removeClass("in");
      }
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    isDragging: function isDragging(newValue) {
      var _this3 = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this3.delayedDragging = false;
      });
    }
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoPacote__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoPacote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__novoPacote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      pacotes: [],
      idExcluir: null,
      editId: null,
      headers: ['ID', 'Titulo', 'Descricao', 'Hotel', 'Preço', 'Ativo', 'Ações'],
      loading: true
    };
  },
  created: function created() {
    this.getPacotes();
  },

  methods: {
    getPacotes: function getPacotes() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getListaPacotes().then(function (response) {
        _this.pacotes = response.data;
      }).catch(function (err) {
        console.log('erro => ', err);
      });
    },
    editServico: function editServico(id) {
      this.editId = id;
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].dellPacote(id).then(function (res) {
            _this2.getPacotes();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_money__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_s3__ = __webpack_require__(29);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NovoPacote',
    directives: { money: __WEBPACK_IMPORTED_MODULE_7_v_money__["VMoney"] },
    components: {
        'modal': __WEBPACK_IMPORTED_MODULE_3__Modal___default.a,
        'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a,
        MultiSelect: __WEBPACK_IMPORTED_MODULE_5_vue_search_select__["MultiSelect"]
    },
    data: function data() {
        return {
            items: [],
            lastSelectItem: {},
            money: {
                thousands: '.',
                decimal: ',',

                precision: 2
            },
            tagsParaPacote: [],
            tagsParaHotel: [],
            gravando: false,
            mostrandoSenha: false,
            informacoesPacote: {
                titulo: '',
                descricao: '',
                preco: 0,
                quantidadePassageiros: 0,
                permiteCrianca: false,
                descontoCrianca: 0,
                tags: [],
                ativo: true
            },
            informacoesHotel: {
                nome: '',
                endereco: '',
                tags: []
            },
            informacoesVoo: [{
                companhia: '',
                localSaida: '',
                localChegada: '',
                horaSaida: '',
                horaChegada: '',
                tipo: 'ida'
            }],
            imagensPacote: [],
            imagensHotel: [],
            empresa: window.localStorage.getItem('FB_ID'),
            alteracao: false,
            id_alteracao: null
        };
    },
    created: function created() {
        this.getTagsPacote();
        this.getTagsHoteis();
        if (this.$route.params.id) {
            console.log('alterando');
            this.alteracao = true;
            this.id_alteracao = this.$route.params.id;
            this.getPacote(this.id_alteracao);
        }
    },

    methods: {
        getTagsPacote: function getTagsPacote() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_8__resource__["a" /* default */].getTagsPacote('pacote').then(function (res) {
                _this.tagsParaPacote = res.data.map(function (element, index) {
                    return { text: element.descricao, value: index, id: element.id };
                });
            }).catch(function (err) {
                console.log('erro tagspacote => ', err);
            });
        },
        getTagsHoteis: function getTagsHoteis() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_8__resource__["a" /* default */].getTagsPacote('hotel').then(function (res) {
                _this2.tagsParaHotel = res.data.map(function (element, index) {
                    return { text: element.descricao, value: index, id: element.id };
                });
            }).catch(function (err) {
                console.log('erro tagshoteis => ', err);
            });
        },
        getPacote: function getPacote(id) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_8__resource__["a" /* default */].getPacote(id).then(function (res) {
                console.log('res => ', res.data);
                _this3.informacoesPacote = {
                    titulo: res.data.titulo,
                    descricao: res.data.descricao,
                    preco: res.data.preco.toFixed(2),
                    quantidadePassageiros: res.data.qtdepessoas,
                    permiteCrianca: res.data.permitecrianca,
                    descontoCrianca: res.data.descontocrianca,
                    tags: res.data.Tags.map(function (element, index) {
                        return { text: element.tag, value: index, id: element.id };
                    }),
                    ativo: res.data.ativo
                };
                _this3.informacoesHotel = {
                    nome: res.data.nomehotel,
                    endereco: res.data.enderecohotel,
                    tags: res.data.TagsHoteis.map(function (element, index) {
                        return { text: element.tag, value: index, id: element.id };
                    })
                };
                _this3.informacoesVoo = res.data.InformacoesPassagens.map(function (element, index) {
                    return {
                        companhia: element.companhia,
                        localSaida: element.localsaida,
                        localChegada: element.localchegada,
                        horaSaida: element.datahorasaida.substring(0, 16),
                        horaChegada: element.datahorachegada.substring(0, 16),
                        tipo: element.tipo,
                        id: element.id
                    };
                });
                _this3.imagensPacote = res.data.Imagens.map(function (element) {
                    return element.url;
                });
                _this3.imagensHotel = res.data.ImagensHotel.map(function (element) {
                    return element.url;
                });
            });
        },
        adicionarVoo: function adicionarVoo() {
            this.informacoesVoo.push({
                companhia: '',
                localSaida: '',
                localChegada: '',
                horaSaida: '',
                horaChegada: '',
                tipo: 'ida'
            });
        },
        removerVoo: function removerVoo(index) {
            this.informacoesVoo.splice(index, 1);
        },
        onSelectPacote: function onSelectPacote(itens, lastSelectItem) {
            this.informacoesPacote.tags = itens;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.delete').removeClass('detele').addClass('fa fa-trash');
            }, 100);
        },
        onSelectHotel: function onSelectHotel(itens, lastSelectItem) {
            this.informacoesHotel.tags = itens;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.delete').removeClass('detele').addClass('fa fa-trash');
            }, 100);
        },
        reset: function reset() {
            this.dadosLogin.itens = [];
        },

        onComplete: function onComplete() {
            this.gravando = true;
            this.gravarPacote();
        },
        gravarPacote: function gravarPacote() {
            var _this4 = this;

            this.gravando = true;
            var filesPacote = document.getElementById('file-input-pacote').files;
            var filesHotel = document.getElementById('file-input-hotel').files;
            console.log(filesPacote);
            if (filesPacote && filesPacote.length > 0) {
                for (var i = 0; i < filesPacote.length; i++) {
                    __WEBPACK_IMPORTED_MODULE_10__services_s3__["a" /* default */].getSignedRequest(filesPacote[i]).then(function (res) {
                        _this4.imagensPacote.push(res.url);
                    }).catch(function (err) {
                        _this4.gravando = false;
                        alert('Erro ao salvar imagem');
                    });
                };
            } else {
                if (!this.alteracao) {
                    this.gravando = false;
                    alert('É necessário selecionar uma imagem.');
                }
            }

            if (filesHotel && filesHotel.length > 0) {
                for (var _i = 0; _i < filesHotel.length; _i++) {
                    __WEBPACK_IMPORTED_MODULE_10__services_s3__["a" /* default */].getSignedRequest(filesHotel[_i]).then(function (res) {
                        _this4.imagensHotel.push(res.url);
                    }).catch(function (err) {
                        _this4.gravando = false;
                        alert('Erro ao salvar imagem');
                    });
                };
            } else {
                if (!this.alteracao) {
                    this.gravando = false;
                    alert('É necessário selecionar uma imagem.');
                }
            }

            if (this.gravando) {
                var temp = (filesPacote.length + filesHotel.length) * 1000;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_timers__["setTimeout"])(function () {
                    if (_this4.gravando) {
                        _this4.finalizarGravacao();
                    }
                }, temp);
            }
        },
        finalizarGravacao: function finalizarGravacao() {
            var _this5 = this;

            var objEnvio = {
                pacote: this.informacoesPacote,
                hotel: this.informacoesHotel,
                voo: this.informacoesVoo
            };

            objEnvio.pacote.imagens = this.imagensPacote;
            objEnvio.hotel.imagens = this.imagensHotel;
            objEnvio.empresa = this.empresa;

            var preco = this.informacoesPacote.preco.replace('.', '');
            delete objEnvio.pacote.preco;
            preco = preco.replace(',', '.');

            objEnvio.pacote.preco = parseFloat(preco);

            console.log('gravar => ', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(objEnvio));
            if (this.alteracao) {
                __WEBPACK_IMPORTED_MODULE_8__resource__["a" /* default */].atualizaPacote(objEnvio, this.id_alteracao).then(function (res) {
                    console.log('gravação concluida  => ', res);
                    _this5.$router.go(-1);
                }).catch(function (err) {
                    console.log('erro na gravação  => ', err);
                    _this5.gravando = false;
                    _this5.$swal('Ops!', 'O Pacote não foi gravado.', 'error');
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_8__resource__["a" /* default */].gravarPacote(objEnvio).then(function (res) {
                    console.log('gravação concluida  => ', res);
                    _this5.$router.go(-1);
                }).catch(function (err) {
                    console.log('erro na gravação  => ', err);
                    _this5.gravando = false;
                    _this5.$swal('Ops!', 'O Pacote não foi gravado.', 'error');
                });
            }
        },
        getSignedRequest: function getSignedRequest(file) {
            var _this6 = this;

            var xhr = new XMLHttpRequest();
            console.log(file.name);
            xhr.open('GET', this.$store.state.api + ('s3/sign-s3?file-name=' + file.name + '&file-type=' + file.type));
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        _this6.uploadFile(file, response.signedRequest, response.url);
                    } else {
                        _this6.gravando = false;
                        alert('Could not get signed URL.');
                    }
                }
            };
            xhr.send();
        },
        uploadFile: function uploadFile(file, signedRequest, url) {
            var _this7 = this;

            var xhr = new XMLHttpRequest();
            xhr.open('PUT', signedRequest);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        _this7.informacoesPacote.img = url;
                    } else {
                        alert('Por favor, selecione uma imagem.');
                        _this7.gravando = false;
                    }
                }
            };
            xhr.send(file);
        },
        validateFirstStep: function validateFirstStep() {
            var _this8 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this8.$refs.ruleForm.validate(function (valid) {
                    resolve(valid);
                    document.addEventListener;
                });
            });
        },
        validateSecondStep: function validateSecondStep() {
            var _this9 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this9.$refs.ruleFormLogin.validate(function (valid) {
                    resolve(valid);
                });
            });
        }
    }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_Large__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_Large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal_Large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_json_excel__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_json_excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_json_excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pedidos',
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_1__Modal_Large___default.a,
    'downloadExcel': __WEBPACK_IMPORTED_MODULE_2_vue_json_excel___default.a,
    'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a
  },
  data: function data() {
    return {
      artCasa: localStorage.getItem('FB_ID') === '373108266747843' ? true : false,
      imprimir: false,
      order: {
        keys: 'estado.id',
        sort: 'asc'
      },
      filter: '',
      filter_name: '',
      filter_status: ['em espera'],
      pagamento: [],
      endereco: null,
      filtro: 'ID',
      colunas_pagamento: ['Formas Pagamento', ''],
      colunas: [{
        name: 'cliente',
        json: 'cliente.nome'
      }, {
        name: 'total',
        json: 'preco_total'
      }, {
        name: 'data hora',
        json: 'data_hora'
      }, {
        name: 'estado',
        json: 'estado.id'
      }, {
        name: 'Ações',
        json: 'acoes'
      }],
      colunas_itens: ['quantidade', 'nome', 'preco'],
      colunas_itens2: ['Foto', 'quantidade', 'nome', 'preco'],
      colunas_impressao: ['Qtd', 'Item', 'Preco'],
      pedidos: [],
      estados: [],
      pedido_id: 0,
      nome_cliente: '',
      contato: '',
      itens_pedido: [],
      config: [],
      total_pedido: 0,
      dataInicial: '',
      dataFinal: '',
      hoje: false,
      ontem: false,
      pedidosFiltrados: [],
      statuspedido: 0,
      desconto: 0
    };
  },
  created: function created() {
    this.getPedido();
    this.getEstado();
    this.getConfig();
  },

  methods: {
    filtraEstado: function filtraEstado(estado) {
      for (var index in this.filter_status) {
        if (this.filter_status[index] === estado) {
          this.filter_status.splice(index, 1);
          return;
        }
      }
      this.filter_status.push(estado);
    },
    filtrarData: function filtrarData(dia) {

      var hoje = new Date();

      var ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate() - 1);

      console.log(dia);
      if (dia === 'ontem') {
        if (this.ontem) {
          this.ontem = false;
          this.dataInicial = '';
          this.dataFinal = '';
          console.log('remove calsse');
          setTimeout(function () {
            var element = document.getElementById("radioOntem");
            element.classList.remove("active");
          }, 100);
          return;
        }
        this.ontem = true;
        this.hoje = false;
        this.dataFinal = this.getData(ontem);
        this.dataInicial = this.dataFinal;
      } else if (dia === 'hoje') {
        if (this.hoje) {
          this.hoje = false;
          this.dataInicial = '';
          this.dataFinal = '';
          console.log('remove calsse');
          setTimeout(function () {
            var element = document.getElementById("radioHoje");
            element.classList.remove("active");
          }, 100);
          return;
        }
        this.ontem = false;
        this.hoje = true;
        this.dataFinal = this.getData(hoje);
        this.dataInicial = this.dataFinal;
      } else {
        console.log(this.dataFinal);
        this.ontem = false;
        this.hoje = false;
        setTimeout(function () {
          var element = document.getElementById("radioOntem");
          var element2 = document.getElementById("radioHoje");
          element.classList.remove("active");
          element2.classList.remove("active");
        }, 100);
      }
    },
    getData: function getData(data) {
      var year = data.getFullYear().toString();
      var month = (data.getMonth() + 1).toString();
      var day = data.getDate().toString();
      return year + '-' + (month.length < 2 ? '0' + month : month) + '-' + (day.length < 2 ? '0' + day : day);
    },
    getPedido: function getPedido() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'pedidos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.pedidos = response.data;
        for (var pedido in _this.pedidos) {
          if (_this.pedidos[pedido].data_hora_conclusao) _this.pedidos[pedido].data_hora = _this.pedidos[pedido].data_hora_conclusao;
          _this.pedidos[pedido].cliente.nome = _this.pedidos[pedido].cliente.nome + ' ' + _this.pedidos[pedido].cliente.sobrenome;
        }
        console.log('get pedido -> ', _this.pedidos);
      });
    },
    getPagamento: function getPagamento(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.api + 'pagamentos', {
        'pedidos_id': id
      }).then(function (response) {
        _this2.pagamento = response.data;
      });
    },
    getEndereco: function getEndereco(cliente_fb_id, pedido) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.api + 'enderecos', {
        'cliente_fb_id': cliente_fb_id,
        'pedido': pedido
      }).then(function (response) {
        console.log('endereço ==> ', response);
        if (response.data) {
          _this3.endereco = response.data.enderecos ? response.data.enderecos : response.data[0];
        } else _this3.endereco = null;
      });
    },
    getEstado: function getEstado() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'estados').then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].id !== 4 && response.data[i].id !== 5) _this4.estados.push(response.data[i]);
        }
      });
    },
    getConfig: function getConfig() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'config?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this5.config = response.data[0];
      });
    },
    itens: function itens(index, id, nome, contato, cliente, desconto) {
      var _this6 = this;

      console.log('clientes ===> ', cliente);
      var clientes_fb_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      this.total_pedido = this.pedidosFiltered[index].preco_total ? this.pedidosFiltered[index].preco_total : 0;
      this.dataPedido = this.pedidosFiltered[index].data_hora_conclusao ? this.pedidosFiltered[index].data_hora_conclusao : this.pedidosFiltered[index].data_hora;
      this.getPagamento(id);
      this.getEndereco(clientes_fb_id, id);
      this.pedido_id = id;
      this.nome_cliente = nome;
      this.contato = contato;
      this.desconto = desconto;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'pedidos/itens/' + id).then(function (response) {
        _this6.ordenaItens(response.data);
      });
    },
    ordenaItens: function ordenaItens(itens) {
      console.log('itens-> ', itens);
      this.itens_pedido = [];
      var prodName = '';
      var qtde = 0;
      var obs = '';
      var img = '';
      for (var i = 0; i < itens.length; i++) {
        for (var j = 0; j < itens[i].itens.length; j++) {
          if (prodName != '') prodName += '/ \n' + itens[i].itens[j].produtos.nome;else prodName = itens[i].itens[j].produtos.nome;

          if (obs != '') obs += '/ ' + itens[i].itens[j].observacao;else obs = itens[i].itens[j].observacao;

          img = itens[i].itens[j].produtos.url_imagem;
        }
        if (j > 1) qtde = 1;else qtde = itens[i].itens[j - 1].quantidade;

        var massa = '';
        if (itens[i].tipo_massa) massa = ' - ' + itens[i].tipo_massa;
        if (itens[i].tipo_borda) massa += ' / ' + itens[i].tipo_borda;

        if (obs !== '') obs += massa;else obs = massa;
        if (obs !== '') prodName += ' (' + obs + ')';

        var nomeProduto = void 0;

        if (itens[i].cardapio && itens[i].cardapio.nome.indexOf('Pizza') != -1) nomeProduto = itens[i].cardapio.nome + ' - ' + prodName;else nomeProduto = prodName;

        var descricao = itens[i].itens[0].produtos.descricao ? itens[i].itens[0].produtos.descricao.split('.')[0] : '';

        var total = 0;

        itens[i].adicionais.forEach(function (adicional) {
          total += adicional.preco * adicional.qtde;
        });

        total += itens[i].preco_item;

        this.itens_pedido.push({ nome: nomeProduto, descricao: descricao, img: img, qtde: qtde, observacao: obs, total: total, preco: itens[i].preco_item, adicionais: itens[i].adicionais ? itens[i].adicionais : null });
        console.log('itens pedido => ', this.itens_pedido);
        prodName = '';
        obs = '';
      }
    },
    orderPedidos: function orderPedidos(coluna) {
      console.log('ordenar coluna => ', coluna);
      if (coluna !== 'observacao') {
        this.order.keys = coluna;
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
      }
    },
    btnImprime: function btnImprime() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'pedidos/imprimiu?id=' + this.pedido_id);
      this.imprimir = true;
      setTimeout(function () {
        var title = document.getElementById('titlePedido').innerHTML,
            endereco = document.getElementById('endereco').innerHTML,
            itens = document.getElementById('itensTable').innerHTML,
            pagamento = document.getElementById('pagamento').innerHTML,
            tela_impressao = window.open('about:blank');

        tela_impressao.document.write(title);
        tela_impressao.document.write('<br>');
        tela_impressao.document.write(endereco);
        tela_impressao.document.write('<br><br>');
        tela_impressao.document.write(itens);
        tela_impressao.document.write('<br><br>');
        tela_impressao.document.write(pagamento);
        tela_impressao.document.write('<br><br>');
        tela_impressao.document.write('<style> table {text-align: center} .lblEnd{margin-top:-1%} label {font-size: 12px!important;} tr {font-size: 12px;} th{font-size: 12px;} h4 {font-size: 12px; margin-bottom: 1%} p {font-size: 12px;} h5 {margin: 0px} .adicionais { font-size: 11px; margin: 0 } .bordaItem{ border-bottom: 1px dotted }</style>');
        tela_impressao.window.print();
        tela_impressao.window.close();
        _this7.imprimir = false;
      }, 2000);
    },
    gravarEstado: function gravarEstado(id, estado, cliente, nome, sobrenome, preco_total, estadoAtual) {
      var _this8 = this;

      console.log('**** gravar estado');
      var fb_id = cliente.fb_id ? cliente.fb_id : cliente.facebook_id;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$store.state.api + 'pedidos/alter-status', {
        'id_estado': estado,
        'id_pedido': id
      }).then(function (response) {
        if (response.data.success === 'true') {
          _this8.getPedido();
          var textarea;
          if (estado === 2) textarea = _this8.config.texto_padrao_aprovado;else if (estado === 3) textarea = _this8.config.texto_padrao_reprovado;else if (estado === 5) textarea = _this8.config.texto_padrao_cancelado;else if (estado === 6) textarea = _this8.config.texto_padrao_entrega;

          textarea = textarea.split('#NOME').join(nome);
          textarea = textarea.split('#SOBRENOME').join(sobrenome);
          textarea = textarea.split('#IDPEDIDO').join(id);
          textarea = textarea.split('#FACEID').join(fb_id);
          textarea = textarea.split('#PRECOTOTAL').join(preco_total);
          textarea = textarea.split('#TEMPOENTREGA').join(_this8.config.tempo_entrega);
          _this8.getPedido();
          _this8.notifca_cliente(textarea, estado, fb_id);
        } else {
          _this8.$swal('Ops!', 'Não foi possivel alterar o status. Nenhuma alteração foi realizada.', 'error');
        }
      });
    },
    notifca_cliente: function notifca_cliente(msg, estado, fb_id) {
      var url = this.$store.state.api_bot + 'pedidos/estado_pedido?fb_id=' + fb_id + '&estado=' + estado + '&msg=' + msg;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {});
    }
  },
  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    upperCase: function upperCase(value) {
      return value.toUpperCase();
    },
    data: function data(value) {
      var data = new Date(value);
      var dia = data.getDate();
      var mes = data.getMonth() + 1;
      var ano = data.getFullYear();
      var hr = data.getHours();
      var min = data.getMinutes();
      return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min;
    }
  },
  computed: {
    pedidosFiltered: function pedidosFiltered() {
      var _this9 = this;

      console.log('estado pedido ==> ', this.statuspedido);
      var pedidosAjustados = this.pedidos;
      this.filter_name = this.filter_name.toLowerCase();
      var colecao = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(pedidosAjustados, this.order.keys, this.order.sort);

      if (this.dataInicial && this.dataFinal) {

        this.pedidosFiltrados = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(colecao, function (item) {
          console.log('itens ==> ', item);
          return item.id.indexOf(_this9.filter) >= 0 && item.cliente.nome.indexOf(_this9.filter_name) >= 0 && item.data_hora.split('T')[0] <= _this9.dataFinal && item.data_hora.split('T')[0] >= _this9.dataInicial && (_this9.statuspedido !== 0 ? item.estadospedidos_id === _this9.statuspedido : true);
        });
        return this.pedidosFiltrados;
      }

      this.pedidosFiltrados = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(colecao, function (item) {
        console.log('itens ==> ', item);
        return item.id.indexOf(_this9.filter) >= 0 && item.cliente.nome.toLowerCase().indexOf(_this9.filter_name) >= 0 && (_this9.statuspedido !== 0 ? item.estadospedidos_id === _this9.statuspedido : true);
      });
      return this.pedidosFiltrados;
    },
    totalPedidos: function totalPedidos() {
      var total = 0;
      this.pedidosFiltrados.forEach(function (pedido) {
        total += pedido.preco_total;
      });
      return total.toFixed(2);
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Relatórios',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      tipoRelatorio: 'regiao',
      pedidos: [],
      colunas: ['Bairro', 'Quantidade'],
      enderecos: [],
      labelTags: [],
      qtdeTags: []
    };
  },
  created: function created() {
    this.getPedido();
  },

  methods: {
    orderPedidos: function orderPedidos(coluna) {
      if (coluna !== 'observacao') {
        this.order.keys = coluna;
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
      }
    },
    getPedido: function getPedido() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.$store.state.api + 'pedidos/endereco?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.pedidos = response.data;
        _this.ajusteEndereco();
      });
    },
    ajusteEndereco: function ajusteEndereco() {
      for (var i = 0; i < this.pedidos.length; i++) {
        var bairro = this.pedidos[i].bairro.replace(/ /g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        console.log('bairro => ', bairro);

        if (this.enderecos.length > 0) {
          var adicionou = false;
          for (var j = 0; j < this.enderecos.length; j++) {
            if (this.enderecos[j].key === bairro) {
              this.enderecos[j].qtde++;
              adicionou = true;
              console.log('somou mais um no bairro ', bairro);
              break;
            }
          };
          if (!adicionou) {
            console.log('primeiro do bairro ', bairro);
            this.enderecos.push({
              bairro: this.pedidos[i].bairro,
              qtde: 1,
              key: bairro
            });
          }
        } else {
          console.log('endereços vazio, iniciou com ', bairro);
          this.enderecos.push({
            bairro: this.pedidos[i].bairro,
            qtde: 1,
            key: bairro
          });
        }
      };
      this.enderecos.sort(function (a, b) {
        return a.qtde > b.qtde ? -1 : a.qtde < b.qtde ? 1 : 0;
      });
      console.log('enderecos => ', this.enderecos);
      this.getRegioesPreferidas();
    },
    getRegioesPreferidas: function getRegioesPreferidas() {
      for (var i = 0; i < 4; i++) {
        this.labelTags.push(this.enderecos[i].bairro);
        this.qtdeTags.push(this.enderecos[i].qtde);
      }
      console.log('tags => ', this.labelTags);
      console.log('qtde => ', this.qtdeTags);
      var pieChartCanvas = document.getElementById('regioesPreferidas').getContext('2d');
      var pieConfig = {
        type: 'bar',
        data: {
          labels: this.labelTags,
          datasets: [{
            data: this.qtdeTags,
            backgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD'],
            hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: false
          },
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      };
      new Chart(pieChartCanvas, pieConfig);
    }
  },
  computed: {
    pedidosFiltered: function pedidosFiltered() {
      console.log('keys => ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.enderecos));
      return [];
    }
  },
  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      perguntas: [],
      idExcluir: null,
      editId: null,
      headers: ['ID', 'Pergunta', 'Tipo', 'Posição', 'Ações'],
      loading: true
    };
  },
  created: function created() {
    this.getPerguntas();
  },

  methods: {
    getPerguntas: function getPerguntas() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */].getListaPerguntas().then(function (response) {
        _this.perguntas = response.data;
        console.log('perguntas => ', _this.perguntas);
      }).catch(function (err) {
        console.log('erro => ', err);
      });
    },
    editServico: function editServico(id) {
      this.editId = id;
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */].dellPergunta(id).then(function (res) {
            _this2.getPerguntas();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Servicos_resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_s3__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_timers__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_4__Box___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_5_vue_search_select__["MultiSelect"]
  },
  data: function data() {
    return {
      lastSelectItem: {},
      dialog: false,
      loading: false,
      dialogErro: false,
      erro: false,
      servicos: [],
      alteracao: false,
      idEditar: 0,
      pergunta: {
        descricao: '',
        tipo: '',
        posicao: 0,
        ativo: true,
        opcoes: [{
          opcao: ''
        }]
      },
      ativo: false,
      gravando: false
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.idEditar = this.$route.params.id;
      this.getPergunta(this.idEditar);
    }
  },

  computed: {
    nome: function nome() {
      if (this.alteracao) return 'alteracao Funcionário';else return 'Novo Funcionário';
    },
    habilitaGravar: function habilitaGravar() {
      return this.pergunta.descricao;
    }
  },
  methods: {
    onSelect: function onSelect(items, lastSelectItem) {
      this.pergunta.funcao = items;
      this.lastSelectItem = lastSelectItem;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_timers__["setTimeout"])(function () {
        $('.delete').removeClass('detele').addClass('fa fa-trash');
      }, 100);
    },
    adicionarOpcao: function adicionarOpcao() {
      console.log('adicionar');
      this.pergunta.opcoes.push({ opcao: '' });
    },
    removerOpcao: function removerOpcao(index) {
      this.pergunta.opcoes.splice(index, 1);
    },
    reset: function reset() {
      this.items = [];
    },
    selectFromParentComponent: function selectFromParentComponent() {
      this.items = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.unionWith(this.items, [this.options[0]], __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEqual);
    },
    gravar: function gravar() {
      var _this = this;

      this.gravando = true;
      if (this.pergunta.tipo === 'card') {
        var files = this.pergunta.opcoes.map(function (element, index) {
          return document.getElementById('file-pergunta-' + index).files[0];
        });
        files = files.filter(function (el) {
          return el != null && el != undefined;
        });
        console.log('files => ', files);
        if (files.length > 0) {
          files.forEach(function (file, index) {
            __WEBPACK_IMPORTED_MODULE_7__services_s3__["a" /* default */].getSignedRequest(file).then(function (res) {
              _this.pergunta.opcoes[index].imagem = res.url;
            }).catch(function (err) {
              console.log('erro => ', err);
              _this.erro = true;
              alert('Erro ao salvar imagem');
            });
          });
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_timers__["setTimeout"])(function () {
          if (!_this.erro) {
            _this.submit();
          }
        }, files.length * 1500);
      } else {
        this.submit();
      }
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('gravar => ', _this2.pergunta);
                if (_this2.alteracao) {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].atualizaPergunta(_this2.pergunta, _this2.idEditar).then(function (res) {
                    _this2.$swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Incluido com sucesso',
                      showConfirmButton: false,
                      timer: 1500
                    });
                    _this2.$router.go(-1);
                  }).catch(function (err) {
                    _this2.$swal('Ops!', 'O Pergunta não foi gravado.', 'error');
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].gravarPergunta(_this2.pergunta).then(function (res) {
                    _this2.$swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Incluido com sucesso',
                      showConfirmButton: false,
                      timer: 1500
                    });
                    _this2.$router.go(-1);
                  }).catch(function (err) {
                    _this2.$swal('Ops!', 'O Pergunta não foi gravado.', 'error');
                  });
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getPergunta: function getPergunta() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getPergunta(this.idEditar).then(function (res) {
        var data = res.data;
        _this3.pergunta = {
          descricao: data.pergunta,
          tipo: data.tipo,
          posicao: data.posicao,
          ativo: data.ativo,
          opcoes: [{
            opcao: ''
          }]
        };
        if (data.tipo === 'options') {
          _this3.pergunta.opcoes = data.OpcoesPerguntas.map(function (opcao) {
            return {
              opcao: opcao.opcao
            };
          });
        }
        console.log('pergunta => ', _this3.pergunta);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_timers__["setTimeout"])(function () {
          $('.delete').removeClass('detele').addClass('fa fa-trash');
        }, 100);
      });
    },
    close: function close() {
      this.setFuncionarioNull();
      this.dialog = false;
      this.$emit('close');
    },
    setFuncionarioNull: function setFuncionarioNull() {
      this.debito = {
        qtde_parcelas: null,
        honorarios: null,
        url_documento: null,
        total_debito: null,
        parcelas: [{
          data_vencimento: null,
          valor: null,
          juros: null,
          correcao: null
        }]
      };
    }
  }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoProblema__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoProblema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__novoProblema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      servicos: [],
      idExcluir: null,
      editId: null,
      headers: ['ID', 'Descrição', ''],
      loading: true
    };
  },
  created: function created() {
    this.getProblemas();
  },

  methods: {
    getProblemas: function getProblemas() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getListaProblemas().then(function (response) {
        _this.servicos = response.data;
      }).catch(function (err) {
        console.log('erro => ', err);
      });
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].dellProblema(id).then(function (res) {
            _this2.getProblemas();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Box__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_3__Box___default.a
  },
  data: function data() {
    return {
      alteracao: false,
      idEditar: 0,
      problema: {
        descricao: '',
        solucao: [{
          descricao: ''
        }]
      },
      gravando: false
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.idEditar = this.$route.params.id;
      this.getProblema(this.idEditar);
    }
  },

  computed: {
    nome: function nome() {
      if (this.alteracao) return 'alteracao Funcionário';else return 'Novo Funcionário';
    },
    habilitaGravar: function habilitaGravar() {
      return this.problema.descricao && this.problema.solucao.length > 0;
    }
  },
  methods: {
    getProblema: function getProblema() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getProblema(this.idEditar).then(function (res) {
        console.log('res => ', res.data);
        _this.problema = res.data;
      });
    },
    adicionarSolucao: function adicionarSolucao() {
      this.problema.solucao.push({
        descricao: ''
      });
    },
    removerSolucao: function removerSolucao(i) {
      this.problema.solucao.splice(i, 1);
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.problema.empresa = localStorage.getItem('FB_ID');

                if (_this2.alteracao) {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].atualizaProblema(_this2.problema, _this2.idEditar).then(function (res) {
                    _this2.alteracao = false;
                    _this2.$router.go(-1);
                  }).catch(function (responseError) {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].gravaProblema(_this2.problema).then(function (res) {
                    _this2.alteracao = false;
                    _this2.$router.go(-1);
                  }).catch(function (responseError) {});
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Produtos',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      products: [],
      order: {
        keys: '',
        sort: ''
      },
      colunas: ['id', 'nome', 'descricao', 'preco', 'imagem', 'ativo', ''],
      filter: '',
      categorias: [],
      cardapio: ''
    };
  },
  created: function created() {
    this.getProducts();
    this.getCategorias();
  },

  methods: {
    novoProduto: function novoProduto(id) {
      this.$store.commit('SET_ID_ALTERACAO', id);
      this.$router.push({ name: 'Novo Produto' });
    },
    getProducts: function getProducts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'produtos?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.products = response.data;
      });
    },
    getCategorias: function getCategorias() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.api + 'categorias?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this2.categorias = response.data;
      });
    },
    excluir: function excluir(id) {
      var _this3 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.$store.state.api + 'produtos/delete', {
            'id': id
          }).then(function (response) {
            if (response.data.success) {
              _this3.getProducts();
              _this3.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Produto Deletado',
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              _this3.$swal('Ops!', 'Não foi possivel deletar o produto.', 'error');
            }
          });
        }
      });
    },
    orderProduto: function orderProduto(coluna) {
      if (coluna === 'preco') {
        this.order.keys = 'Cardapios[0].tabela_preco.preco';
      } else {
        this.order.keys = coluna;
      }
      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
    },
    filterCategoria: function filterCategoria(item) {
      var _this4 = this;

      if (!this.cardapio || this.cardapio === 'todos') return true;
      if (item.Categorias) return item.Categorias.find(function (element) {
        return element.id === _this4.cardapio;
      }) ? true : false;else return item.Cardapios.find(function (element) {
        return element.id === _this4.cardapio;
      }) ? true : false;
    },
    getPreco: function getPreco(prod) {
      var _this5 = this;

      if (!this.cardapio || this.cardapio === 'todos') {
        if (prod.Categorias) {
          return prod.Categorias[0].tabela_preco.preco.toFixed(2);
        } else {
          return prod.Cardapios[0].tabela_preco ? prod.Cardapios[0].tabela_preco.preco.toFixed(2) : prod.Cardapios[0].tabela_precos.preco.toFixed(2);
        }
      } else {
        var ret = prod.Categorias ? prod.Categorias.filter(function (element) {
          return element.id == _this5.cardapio;
        }) : prod.Cardapios.filter(function (element) {
          return element.id == _this5.cardapio;
        });
        return ret[0].tabela_preco ? ret[0].tabela_preco.preco.toFixed(2) : ret[0].tabela_precos.preco.toFixed(2);
      }
    }
  },
  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    productsFiltered: function productsFiltered() {
      var _this6 = this;

      var colecao = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.products, this.order.keys, this.order.sort);
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(colecao, function (item) {
        return _this6.filterCategoria(item) && (item.nome.toLowerCase().indexOf(_this6.filter.toLowerCase()) >= 0 || item.descricao.toLowerCase().indexOf(_this6.filter.toLowerCase()) >= 0);
      });
    }
  }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Repository',
  data: function data() {
    return {
      githubUrl: 'https://api.github.com/search/repositories?q=language%3Ajavascript&sort=stars',
      response: null,
      error: null
    };
  },

  methods: {
    callGitHub: function callGitHub() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.githubUrl).then(function (response) {
        console.log('GitHub Response:', response);

        if (response.status !== 200) {
          _this.error = response.statusText;
          return;
        }

        _this.response = response.data.items;
      }).catch(function (error) {
        console.log('error', error.response);
        _this.error = error.response.statusText;
      });
    }
  },
  mounted: function mounted() {
    this.callGitHub();
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(147);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CategoriasServico',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      categorias: [],
      allCategories: [],
      colunas: ['id', 'descricao', 'imagem', 'ativo', ''],
      order: {
        keys: '',
        sort: ''
      }
    };
  },
  created: function created() {
    this.getCategorias();
  },

  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    categoriasFiltered: function categoriasFiltered() {
      var colecao = _.orderBy(this.categorias, this.order.keys, this.order.sort);
      return colecao;
    }
  },
  methods: {
    getCategorias: function getCategorias() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getListaCategorias().then(function (res) {
        _this.categorias = res.data.map(function (categoria) {
          return {
            id: categoria.id,
            descricao: categoria.descricao,
            imagem: categoria.url_imagem,
            ativo: categoria.ativo
          };
        });
      });
    },
    ajustarCategorias: function ajustarCategorias() {
      for (var i = 0; i < this.allCategories.length; i++) {
        this.categorias.push({ name: this.allCategories[i].nome, id: this.allCategories[i].id });
      }
    },
    excluirCategoria: function excluirCategoria(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__resource__["b" /* resourceCategorias */].dellCategoria(id).then(function (res) {
            for (var i = 0; i < _this2.categorias.length; i++) {
              if (id === _this2.categorias[i].id) {
                _this2.categorias.splice(i, 1);
                break;
              }
            }
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    },
    orderCategoria: function orderCategoria(coluna) {
      this.order.keys = coluna;

      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
    }
  }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_s3__ = __webpack_require__(29);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NovaCategoriaServico',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_1__Box___default.a
  },
  data: function data() {
    return {
      nome: '',
      categories: {
        descricao: '',
        ativo: false,
        url_imagem: ''
      },
      gravando: false,
      imagem: '',
      editar: false
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id);
      this.editar = true;
    }
  },

  methods: {
    gravar: function gravar() {
      var _this = this;

      this.gravando = true;
      var files = document.getElementById('file-input').files;
      var file = files[0];

      if (file != null) {
        __WEBPACK_IMPORTED_MODULE_3__services_s3__["a" /* default */].getSignedRequest(file).then(function (res) {
          _this.categories.url_imagem = res.url;
          _this.gravarCategoria();
        }).catch(function (err) {
          alert('Erro ao salvar imagem');
        });
      } else {
        if (this.editar) {
          this.gravarCategoria();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.gravando = false;
        }
      }
    },
    gravarCategoria: function gravarCategoria() {
      var _this2 = this;

      this.categories.empresa = localStorage.getItem('FB_ID');

      if (this.editar) {
        __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].atualizarCategoria(this.categories, this.$route.params.id).then(function (res) {
          console.log('res => ', res);
          _this2.$router.go(-1);
        }).catch(function (err) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].gravarCategoria(this.categories).then(function (res) {
          console.log('res => ', res);
          _this2.$router.go(-1);
        }).catch(function (err) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
        });
      }
    },
    getCategoriaById: function getCategoriaById(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getCategoriaById(id).then(function (res) {
        _this3.categories = res.data;
      });
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoServico__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__novoServico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__novoServico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    appNovoServico: __WEBPACK_IMPORTED_MODULE_0__novoServico___default.a,
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      search: '',
      servicos: [],
      idExcluir: null,
      editId: null,
      headers: ['ID', 'Imagem', 'Nome', 'Descricao', 'Tempo', 'Preço', 'Ativo', 'Ações'],
      loading: true
    };
  },
  created: function created() {
    this.getServicos();
  },

  methods: {
    getServicos: function getServicos() {
      var _this = this;

      this.editId = null;
      this.idExcluir = null;
      __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getListaServicos().then(function (response) {
        _this.servicos = response.data;
      }).catch(function (err) {
        console.log('erro => ', err);
      });
    },
    editServico: function editServico(id) {
      this.editId = id;
    },
    excluir: function excluir(id) {
      var _this2 = this;

      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].dellServico(id).then(function (res) {
            _this2.getServicos();
            _this2.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(function (err) {
            _this2.$swal('Ops', 'Ocorreu um erro na exclusão da categoria.', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ServicoCategorias_resource__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_s3__ = __webpack_require__(29);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Novo Serviço',

  components: {
    'box': __WEBPACK_IMPORTED_MODULE_3__Box___default.a,
    Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"]
  },
  data: function data() {
    return {
      dialog: false,
      idEditar: false,
      categories: [],
      servico: {
        nome: '',
        descricao: '',
        tempo: 0,
        preco: 0,
        ativo: false,
        categorias_id: 0
      },
      loading: false,
      dialogErro: false,
      erro: '',
      alteracao: false
    };
  },
  computed: {
    habilitaGravar: function habilitaGravar() {
      return this.servico.nome && this.servico.descricao && this.servico.tempo;
    }
  },
  created: function created() {
    this.getCategorias();
    if (this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true;
      this.idEditar = this.$route.params.id;
      this.getServico(this.idEditar);
    }
  },

  methods: {
    gravar: function gravar() {
      var _this = this;

      this.loading = true;
      var files = document.getElementById('file-input').files;
      var file = files[0];

      if (file != null) {
        __WEBPACK_IMPORTED_MODULE_6__services_s3__["a" /* default */].getSignedRequest(file).then(function (res) {
          _this.servico.imagem = res.url;
          _this.submit();
        }).catch(function (err) {
          alert('Erro ao salvar imagem');
        });
      } else {
        if (this.alteracao) {
          this.submit();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.loading = false;
        }
      }
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var serv;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return _.pickBy(_this2.servico, function (a) {
                  return a !== null;
                });

              case 3:
                serv = _context.sent;

                if (_this2.idEditar) {
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].atualizaServico(serv, _this2.idEditar).then(function (res) {
                    _this2.idEditar = null;
                    _this2.idEditar = false;
                    _this2.$router.go(-1);
                  }).catch(function (responseError) {
                    _this2.dialogErro = true;
                    _this2.erro = responseError.response.data.message;
                    _this2.loading = false;
                  });
                } else {
                  _this2.servico.empresa = localStorage.getItem('FB_ID');
                  __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].gravaServico(_this2.servico).then(function (res) {
                    _this2.idEditar = false;
                    _this2.$router.go(-1);
                  }).catch(function (responseError) {
                    _this2.dialogErro = true;
                    _this2.erro = responseError.response.data.message;
                    _this2.loading = false;
                  });
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getServico: function getServico() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["a" /* default */].getServico(this.idEditar).then(function (res) {
        _this3.servico = res.data;
      });
    },
    getCategorias: function getCategorias() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__ServicoCategorias_resource__["b" /* resourceCategorias */].getListaCategorias().then(function (res) {
        _this4.categories = res.data;
      }).catch(function (err) {
        console.log('erro ao buscar categorias ', err);
      });
    },
    close: function close() {
      this.dialog = false;
      this.$emit('close');
    }
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__ = __webpack_require__(430);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a,
    Circle8: __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__["a" /* Circle8 */]
  },
  data: function data() {
    return {
      sorter: {
        "segunda": 1,
        "terca": 2,
        "quarta": 3,
        "quinta": 4,
        "sexta": 5,
        "sabado": 6,
        "domingo": 7
      },
      ativo: 'empresa',
      config: [],
      permite_email: this.$store.state.permite_email,
      permite_impressao: this.$store.state.permite_impressao,
      funcionamento: [],
      gravando: false,
      optradio1: '',
      optradio2: '',
      optradio3: '',
      promocao: [],
      rua: '',
      numero: 0,
      cidade: '',
      estado: 'SP',
      cep: 0,
      complemento: '',
      bairro: '',
      loading: true,
      frete: []
    };
  },

  watch: {
    'config.funcionamento': function configFuncionamento(val) {
      if (val === 'auto' && this.funcionamento.length === 0) {
        this.Funcionamento();
      }
    }
  },
  created: function created() {
    this.getConfig();
    this.getPromocao();
    this.getEmpresa();
    this.getFrete();
    this.Funcionamento();
  },

  methods: {
    getConfig: function getConfig() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.api + 'config?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this.config = response.data[0];
        console.log('config:', _this.config);
      });
    },
    Funcionamento: function Funcionamento() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.api + 'funcionamento?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this2.funcionamento = response.data;
        _this2.funcionamento.sort(function (a, b) {
          var day1 = a.dia.toLowerCase();
          var day2 = b.dia.toLowerCase();
          return _this2.sorter[day1] - _this2.sorter[day2];
        });
        console.log('week = > ', _this2.funcionamento);
      });
    },
    getPromocao: function getPromocao() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.api + 'promocao?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        console.log('promocao', response.data);
        if (response.data.length > 0) {
          _this3.promocao = response.data;
          _this3.optradio1 = _this3.promocao[0].tipo;
          _this3.optradio2 = _this3.promocao[2].tipo;
          _this3.optradio3 = _this3.promocao[1].tipo;
        }
      });
    },
    getEmpresa: function getEmpresa() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://sev-delivery.herokuapp.com/api/empresas', {
        'empresa': this.$store.state.empresa_fb_id
      }).then(function (response) {
        if (response.data.endereco) {
          var endereco = response.data.endereco.split(',');

          _this4.rua = endereco[0];
          _this4.numero = Number(endereco[1]);
          _this4.bairro = endereco[2];
          _this4.cidade = endereco[4];
          _this4.estado = endereco[5].replace(' ', '').substring(0, 2);
          _this4.cep = Number(endereco[6]);
          _this4.complemento = endereco[3];
        }
        _this4.loading = false;
      });
    },
    getFrete: function getFrete() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$store.state.api + 'frete?empresa=' + this.$store.state.empresa_fb_id).then(function (response) {
        _this5.frete = response.data;
      });
    },
    adicionarFrete: function adicionarFrete() {
      console.log('adicionar');
      this.frete.push({
        valor: 0,
        distancia: 0
      });
    },
    removerFrete: function removerFrete(index) {
      this.frete.splice(index, 1);
    },
    mudarAtivo: function mudarAtivo(id) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.active').removeClass('active');
      document.getElementById(id).className = 'active';
      this.ativo = id;
    },
    buscaCEP: function buscaCEP() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://viacep.com.br/ws/' + this.cep + '/json/').then(function (response) {
        var endereco = response.data;
        _this6.rua = endereco.logradouro;
        _this6.cidade = endereco.localidade;
        _this6.estado = endereco.uf;
      });
    },
    atualizarCron: function atualizarCron() {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://senhor-destino.herokuapp.com/restart');
    },
    gravarConfig: function gravarConfig() {
      var _this7 = this;

      this.gravando = true;

      var url = 'https://sev-delivery.herokuapp.com/api/usuarios/' + this.$store.state.email;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
        'permite_impressao': this.permite_impressao,
        'permite_email': this.permite_email
      }).then(function (res) {
        console.log(res);

        window.localStorage.removeItem('response');
      });

      if (this.frete.length > 0) __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.api + 'frete', { frete: this.frete, empresa: this.$store.state.empresa_fb_id });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$store.state.api + 'config/save-config', this.montarConfig()).then(function (response) {
        if (response.data.success) {
          _this7.gravarEmpresa().then(function (response) {
            if (response) {
              _this7.gravarFuncionamento().then(function (response) {
                if (response) {
                  _this7.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Configurações Salvas',
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this7.atualizarCron();
                  _this7.gravando = false;
                } else {
                  _this7.$swal('Ops!', 'Problemas na gravação da Funcionalidade.', 'error');
                  _this7.gravando = false;
                }
              });
            } else {
              _this7.$swal('Ops!', 'Problemas na gravação da empresa.', 'error');
              _this7.gravando = false;
            }
          });
        } else {
          _this7.$swal('Ops!', 'Problemas na gravação. Nenhuma alteração realizada.', 'error');
          _this7.gravando = false;
        }
      });
    },
    montarConfig: function montarConfig() {
      var config = {};
      config['notifica_cliente'] = this.config.notifica_cliente;
      config['texto_padrao_aprovado'] = this.config.texto_padrao_aprovado;
      config['texto_padrao_reprovado'] = this.config.texto_padrao_reprovado;
      config['texto_padrao_cancelado'] = this.config.texto_padrao_cancelado;
      config['texto_padrao_entrega'] = this.config.texto_padrao_entrega;
      config['imprimir_descricao'] = this.config.imprimir_descricao;
      if (this.frete.length === 0) {
        config['taxa_entrega'] = this.config.taxa_entrega;
        config['raio_entrega'] = parseInt(this.config.raio_entrega);
      }
      config['funcionamento'] = this.config.funcionamento;
      config['empresa'] = this.$store.state.empresa_fb_id;
      config['pedido_minimo'] = this.config.pedido_minimo;

      return config;
    },
    gravarEmpresa: function gravarEmpresa() {
      var endereco = this.rua + ',' + this.numero + ',' + this.bairro + ',' + this.complemento + ',' + this.cidade + ',' + this.estado + ',' + this.cep;
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://sev-delivery.herokuapp.com/api/empresas/save', {
        'endereco': endereco,
        'id': this.$store.state.empresa_id
      }).then(function (response) {
        if (response.data.success) {
          return true;
        } else {
          return false;
        }
      });
    },
    gravarFuncionamento: function gravarFuncionamento() {
      var segunda = void 0,
          terca = void 0,
          quarta = void 0,
          quinta = void 0,
          sexta = void 0,
          sabado = void 0,
          domingo = void 0;
      this.funcionamento.forEach(function (element, index, array) {
        switch (element.dia) {
          case 'segunda':
            segunda = index;
            break;
          case 'terca':
            terca = index;
            break;
          case 'quarta':
            quarta = index;
            break;
          case 'quinta':
            quinta = index;
            break;
          case 'sexta':
            sexta = index;
            break;
          case 'sabado':
            sabado = index;
            break;
          case 'domingo':
            domingo = index;
            break;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(this.$store.state.api + 'funcionamento', {
        'empresa': this.$store.state.empresa_fb_id,
        'segunda': this.funcionamento[segunda].aberto,
        'hr_abertura_segunda_1': this.funcionamento[segunda].hr_abertura_1,
        'hr_abertura_segunda_2': this.funcionamento[segunda].hr_abertura_2,
        'hr_fechamento_segunda_1': this.funcionamento[segunda].hr_fechamento_1,
        'hr_fechamento_segunda_2': this.funcionamento[segunda].hr_fechamento_2,
        'terca': this.funcionamento[terca].aberto,
        'hr_abertura_terca_1': this.funcionamento[terca].hr_abertura_1,
        'hr_abertura_terca_2': this.funcionamento[terca].hr_abertura_2,
        'hr_fechamento_terca_1': this.funcionamento[terca].hr_fechamento_1,
        'hr_fechamento_terca_2': this.funcionamento[terca].hr_fechamento_2,
        'quarta': this.funcionamento[quarta].aberto,
        'hr_abertura_quarta_1': this.funcionamento[quarta].hr_abertura_1,
        'hr_abertura_quarta_2': this.funcionamento[quarta].hr_abertura_2,
        'hr_fechamento_quarta_1': this.funcionamento[quarta].hr_fechamento_1,
        'hr_fechamento_quarta_2': this.funcionamento[quarta].hr_fechamento_2,
        'quinta': this.funcionamento[quinta].aberto,
        'hr_abertura_quinta_1': this.funcionamento[quinta].hr_abertura_1,
        'hr_abertura_quinta_2': this.funcionamento[quinta].hr_abertura_2,
        'hr_fechamento_quinta_1': this.funcionamento[quinta].hr_fechamento_1,
        'hr_fechamento_quinta_2': this.funcionamento[quinta].hr_fechamento_2,
        'sexta': this.funcionamento[sexta].aberto,
        'hr_abertura_sexta_1': this.funcionamento[sexta].hr_abertura_1,
        'hr_abertura_sexta_2': this.funcionamento[sexta].hr_abertura_2,
        'hr_fechamento_sexta_1': this.funcionamento[sexta].hr_fechamento_1,
        'hr_fechamento_sexta_2': this.funcionamento[sexta].hr_fechamento_2,
        'sabado': this.funcionamento[sabado].aberto,
        'hr_abertura_sabado_1': this.funcionamento[sabado].hr_abertura_1,
        'hr_abertura_sabado_2': this.funcionamento[sabado].hr_abertura_2,
        'hr_fechamento_sabado_1': this.funcionamento[sabado].hr_fechamento_1,
        'hr_fechamento_sabado_2': this.funcionamento[sabado].hr_fechamento_2,
        'domingo': this.funcionamento[domingo].aberto,
        'hr_abertura_domingo_1': this.funcionamento[domingo].hr_abertura_1,
        'hr_abertura_domingo_2': this.funcionamento[domingo].hr_abertura,
        'hr_fechamento_domingo_1': this.funcionamento[domingo].hr_fechamento_1,
        'hr_fechamento_domingo_2': this.funcionamento[domingo].hr_fechamento_2
      }).then(function (response) {
        if (response.data.success) {
          return true;
        } else {
          return false;
        }
      });
    },
    tabelaVariaveis: function tabelaVariaveis() {
      this.$swal({
        title: 'Variáveis',
        html: '<div style="text-align: left">' + '#NOME = Primeiro nome do cliente <br><br>' + '#SOBRENOME = Sobrenome do cliente <br><br>' + '#IDPEDIDO = ID do Pedido <br><br>' + '#FACEID = ID do Facebook do cliente <br><br>' + '#PRECOTOTAL = Preço Total do pedido <br><br>' + '#TEMPOENTREGA = Tempo de entrega informado na tela inicial' + '</div>'
      });
    }
  }
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource__ = __webpack_require__(241);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pedidos',
  components: {
    'box': __WEBPACK_IMPORTED_MODULE_2__Box___default.a
  },
  data: function data() {
    return {
      imprimir: false,
      order: {
        keys: 'estado.id',
        sort: 'asc'
      },
      filter: '',
      filter_name: '',
      pagamento: [],
      endereco: null,
      filtro: 'ID',
      colunas_pagamento: ['Formas Pagamento', ''],
      colunas: [{
        name: 'id',
        json: 'id'
      }, {
        name: 'Cliente',
        json: 'Clientes.nome'
      }, {
        name: 'Pacote',
        json: 'Pacotes.titulo'
      }, {
        name: 'total',
        json: 'Pacotes.preco'
      }, {
        name: 'data hora',
        json: 'datahora'
      }, {
        name: 'estado',
        json: 'statusid'
      }],
      solicitacoes: [],
      estados: [],
      solicitacoes_id: 0,
      nome_cliente: '',
      contato: '',
      itens_pedido: [],
      config: [],
      total_pedido: 0,
      dataInicial: '',
      dataFinal: '',
      hoje: false,
      ontem: false,
      solicitacoesFiltradas: [],
      status: 0,
      desconto: 0
    };
  },
  created: function created() {
    this.getSolicitacoes();
    this.getEstados();
  },

  methods: {
    filtrarData: function filtrarData(dia) {

      var hoje = new Date();

      var ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate() - 1);

      console.log(dia);
      if (dia === 'ontem') {
        if (this.ontem) {
          this.ontem = false;
          this.dataInicial = '';
          this.dataFinal = '';
          console.log('remove calsse');
          setTimeout(function () {
            var element = document.getElementById("radioOntem");
            element.classList.remove("active");
          }, 100);
          return;
        }
        this.ontem = true;
        this.hoje = false;
        this.dataFinal = this.getData(ontem);
        this.dataInicial = this.dataFinal;
      } else if (dia === 'hoje') {
        if (this.hoje) {
          this.hoje = false;
          this.dataInicial = '';
          this.dataFinal = '';
          console.log('remove calsse');
          setTimeout(function () {
            var element = document.getElementById("radioHoje");
            element.classList.remove("active");
          }, 100);
          return;
        }
        this.ontem = false;
        this.hoje = true;
        this.dataFinal = this.getData(hoje);
        this.dataInicial = this.dataFinal;
      } else {
        console.log(this.dataFinal);
        this.ontem = false;
        this.hoje = false;
        setTimeout(function () {
          var element = document.getElementById("radioOntem");
          var element2 = document.getElementById("radioHoje");
          element.classList.remove("active");
          element2.classList.remove("active");
        }, 100);
      }
    },
    getData: function getData(data) {
      var year = data.getFullYear().toString();
      var month = (data.getMonth() + 1).toString();
      var day = data.getDate().toString();
      return year + '-' + (month.length < 2 ? '0' + month : month) + '-' + day;
    },
    getSolicitacoes: function getSolicitacoes() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].getListaSolicitacoes().then(function (response) {
        _this.solicitacoes = response.data;
        for (var solicitacao in _this.solicitacoes) {
          _this.solicitacoes[solicitacao].Clientes.nome = _this.solicitacoes[solicitacao].Clientes.nome + ' ' + _this.solicitacoes[solicitacao].Clientes.sobrenome;
        }
        console.log('get solicitacao -> ', _this.solicitacoes);
      });
    },
    getEstados: function getEstados() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].getEstados().then(function (res) {
        _this2.estados = res.data.filter(function (element) {
          return element.id != 1 && element.id != 5;
        });
      }).catch(function (err) {
        alert(err);
      });
    },
    orderPedidos: function orderPedidos(coluna) {
      if (coluna !== 'observacao') {
        this.order.keys = coluna;
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc';
      }
    },
    detalheSolicitacao: function detalheSolicitacao(id) {
      this.$router.go('/solicitacoes/' + id);
    },
    gravarEstado: function gravarEstado(id, estado) {
      var _this3 = this;

      console.log('estado => ', estado);
      __WEBPACK_IMPORTED_MODULE_3__resource__["a" /* default */].atualizaEstado(id, { estado: estado }).then(function (response) {
        if (response.data.success) {
          _this3.getSolicitacoes();
          if (estado !== 1 && _this3.config.notifica_cliente) {
            var textarea;

            _this3.$swal({
              title: 'Mensagem de Notificação',
              html: '<textarea class="form-control textarea" rows="3" id="txtArea" >' + textarea + '</textarea>',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Enviar'
            }).then(function (result) {
              if (result.value) {
                textarea = document.getElementById('txtArea').value;
                _this3.notifca_cliente(textarea, estado, fb_id);
              }
            });
          }
        } else {
          _this3.$swal('Ops!', 'Não foi possivel alterar o status. Nenhuma alteração foi realizada.', 'error');
        }
      });
    },
    notifca_cliente: function notifca_cliente(msg, estado, fb_id) {
      var _this4 = this;

      var url = this.$store.state.api_bot + 'pedidos/estado_pedido?fb_id=' + fb_id + '&estado=' + estado + '&msg=' + msg;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        _this4.$swal({
          position: 'top-end',
          type: 'success',
          title: 'Cliente Notificado',
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  },

  filters: {
    ucwords: function ucwords(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    upperCase: function upperCase(value) {
      return value.toUpperCase();
    },
    data: function data(value) {
      var data = new Date(value);
      var dia = data.getDate();
      var mes = data.getMonth() + 1;
      var ano = data.getFullYear();
      var hr = data.getHours();
      var min = data.getMinutes();
      return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min;
    }
  },
  computed: {
    solicitacoesFiltered: function solicitacoesFiltered() {
      var _this5 = this;

      console.log('estado pedido ==> ', this.status);
      var solicitacoesAjustadas = this.solicitacoes;
      this.filter_name = this.filter_name.toLowerCase();
      var colecao = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(solicitacoesAjustadas, this.order.keys, this.order.sort);

      if (this.dataInicial && this.dataFinal) {

        this.solicitacoesFiltradas = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(colecao, function (item) {
          console.log('itens ==> ', item);
          return item.id.indexOf(_this5.filter) >= 0 && item.Clientes.nome.indexOf(_this5.filter_name) >= 0 && item.datahora.split('T')[0] <= _this5.dataFinal && item.datahora.split('T')[0] >= _this5.dataInicial && (_this5.status !== 0 ? item.statusid === _this5.status : true);
        });
        return this.solicitacoesFiltradas;
      }

      this.solicitacoesFiltradas = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(colecao, function (item) {
        return item.id.indexOf(_this5.filter) >= 0 && item.Clientes.nome.toLowerCase().indexOf(_this5.filter_name) >= 0 && (_this5.status !== 0 ? item.statusid === _this5.status : true);
      });
      console.log('solicitacoesFiltradas ==> ', this.solicitacoesFiltradas);
      return this.solicitacoesFiltradas;
    },
    totalPedidos: function totalPedidos() {
      var total = 0;
      this.solicitacoesFiltradas.forEach(function (solicitacao) {
        total += solicitacao.Pacotes ? solicitacao.Pacotes.preco : 0;
      });
      return total.toFixed(2);
    }
  }
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(241);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Pedidos',
    components: {
        'box': __WEBPACK_IMPORTED_MODULE_0__Box___default.a
    },
    data: function data() {
        return {
            solicitacao: null,
            carregou: false,
            colunas: ['id', 'Título', 'Descricao', 'Quantidade de Passageiros', 'Preço'],
            colunasPgto: ['Nome', 'Número do cartão', 'Vencimento', 'CVV'],
            colunasPassageiros: ['Nome', 'CPF', 'Contato', 'E-mail']
        };
    },
    created: function created() {
        this.getSolicitacao(this.$route.params.id);
    },

    methods: {
        getSolicitacao: function getSolicitacao(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */].getSolicitacao(id).then(function (res) {
                _this.solicitacao = res.data;
                console.log('solicitacao ==> ', _this.solicitacao);
                _this.carregou = true;
            });
        }
    }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_datatables_net_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_datatables_net_bs__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tables',
  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#example1').DataTable();
    });
  }
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_beautiful_chat__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_sweetalert2__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_form_wizard__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_toggle_button__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css__);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_beautiful_chat__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_5__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_5__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_5__filters__["d" /* pluralize */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_sweetalert2__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_form_wizard___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_js_toggle_button___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui___default.a);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);


var config = {
  apiKey: 'AIzaSyC5Welq568peSY-wE5vgUhg8Jsns6eq0zE',
  authDomain: 'sev-delivery.firebaseapp.com',
  databaseURL: 'https://sev-delivery.firebaseio.com',
  projectId: 'sev-delivery',
  storageBucket: 'sev-delivery.appspot.com',
  messagingSenderId: '677498504965'
};
__WEBPACK_IMPORTED_MODULE_7_firebase___default.a.initializeApp(config);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#root',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__components_App_vue___default.a);
  },
  VueSweetalert2: __WEBPACK_IMPORTED_MODULE_9_vue_sweetalert2__["a" /* default */]
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RedefinirSenha_vue__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RedefinirSenha_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_RedefinirSenha_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home_vue__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Dashboard_vue__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Tables_vue__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Tables_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Tables_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Setting_vue__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Repos_vue__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_Repos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_Repos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Clientes_vue__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Clientes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_Clientes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Produtos_vue__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Produtos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Produtos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_NovoProduto_vue__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_NovoProduto_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_NovoProduto_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_NovaCategoria_vue__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_NovaCategoria_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_NovaCategoria_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Categorias_vue__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Categorias_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Categorias_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Pedidos_Pedidos_vue__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Pedidos_Pedidos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Pedidos_Pedidos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Pedidos_Relatorios_vue__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Pedidos_Relatorios_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_Pedidos_Relatorios_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_NovoUsuario_vue__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_NovoUsuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_NovoUsuario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_MinhaConta_vue__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_MinhaConta_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_MinhaConta_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_AlterarEmail_vue__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_AlterarEmail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_AlterarEmail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_AlterarSenha_vue__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_AlterarSenha_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_AlterarSenha_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_CondPagto__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_CondPagto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_CondPagto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_NovaCondPagto__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_NovaCondPagto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_NovaCondPagto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_OrderCategoria__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_OrderCategoria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_OrderCategoria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_OrderProduto__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_OrderProduto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_OrderProduto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_NotificarClientes__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_NotificarClientes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_NotificarClientes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Calendario__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Calendario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_Calendario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Servicos_Servicos__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Servicos_Servicos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_Servicos_Servicos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Servicos_novoServico__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Servicos_novoServico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_Servicos_novoServico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_ServicoCategorias_ServicoCategorias__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_ServicoCategorias_ServicoCategorias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_ServicoCategorias_ServicoCategorias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Funcionarios_Funcionarios__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Funcionarios_Funcionarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_Funcionarios_Funcionarios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Funcionarios_novoFuncionario_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Funcionarios_novoFuncionario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_Funcionarios_novoFuncionario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_ServicoCategorias_novaCategoria__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_ServicoCategorias_novaCategoria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_ServicoCategorias_novaCategoria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Problemas_Problemas__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Problemas_Problemas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_Problemas_Problemas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Problemas_novoProblema__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Problemas_novoProblema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_views_Problemas_novoProblema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Help_help__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Help_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_views_Help_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Solicitacoes_Solicitacoes__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Solicitacoes_Solicitacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_views_Solicitacoes_Solicitacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_PacotesViagens_PacotesViagens__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_PacotesViagens_PacotesViagens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_views_PacotesViagens_PacotesViagens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_PacotesViagens_novoPacote__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_PacotesViagens_novoPacote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_views_PacotesViagens_novoPacote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_PerguntasPersonalizadas_PerguntasPersonalizadas__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_PerguntasPersonalizadas_PerguntasPersonalizadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_views_PerguntasPersonalizadas_PerguntasPersonalizadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_PerguntasPersonalizadas_novaPergunta__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_PerguntasPersonalizadas_novaPergunta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_views_PerguntasPersonalizadas_novaPergunta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Filtros_Filtros__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Filtros_Filtros___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_views_Filtros_Filtros__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Filtros_novoFiltro__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Filtros_novoFiltro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_views_Filtros_novoFiltro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Solicitacoes_detalhe__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Solicitacoes_detalhe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_views_Solicitacoes_detalhe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_InclusaoRapida_InclusaoRapidaProdutos__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_InclusaoRapida_InclusaoRapidaProdutos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_views_InclusaoRapida_InclusaoRapidaProdutos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_InclusaoRapida_InclusaoRapidaCategorias__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_InclusaoRapida_InclusaoRapidaCategorias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_views_InclusaoRapida_InclusaoRapidaCategorias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_Campanhas_Campanhas__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_Campanhas_Campanhas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_views_Campanhas_Campanhas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Campanhas_novaCampanha__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Campanhas_novaCampanha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_views_Campanhas_novaCampanha__);

















































var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/redefinir-senha',
  component: __WEBPACK_IMPORTED_MODULE_3__components_RedefinirSenha_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Dashboard_vue___default.a,
    name: 'Pagina Inicial',
    meta: { requiresAuth: true }
  }, {
    path: 'tables',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Tables_vue___default.a,
    name: 'Tables',
    meta: { requiresAuth: true }
  }, {
    path: 'setting',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Setting_vue___default.a,
    name: 'Configurações',
    meta: { requiresAuth: true }
  }, {
    path: 'repos',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_Repos_vue___default.a,
    name: 'Repository',
    meta: { requiresAuth: true }
  }, {
    path: 'clientes',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_Clientes_vue___default.a,
    name: 'Clientes',
    meta: { requiresAuth: true }
  }, {
    path: 'clientes/notificar',
    component: __WEBPACK_IMPORTED_MODULE_24__components_views_NotificarClientes___default.a,
    name: 'NotificarClientes',
    meta: { requiresAuth: true }
  }, {
    path: 'produtos',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_Produtos_vue___default.a,
    name: 'Produtos',
    meta: { requiresAuth: true }
  }, {
    path: 'novo-produto',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_NovoProduto_vue___default.a,
    name: 'Novo Produto',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'produtos/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_NovoProduto_vue___default.a,
    name: 'editarProduto',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'produtos/ordem',
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_OrderProduto___default.a,
    name: 'orderProduto',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'categorias',
    component: __WEBPACK_IMPORTED_MODULE_13__components_views_Categorias_vue___default.a,
    name: 'Categorias',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'nova-categoria',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_NovaCategoria_vue___default.a,
    name: 'NovaCategoria',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'categorias/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_NovaCategoria_vue___default.a,
    name: 'editarCategoria',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'categorias/ordem',
    component: __WEBPACK_IMPORTED_MODULE_22__components_views_OrderCategoria___default.a,
    name: 'orderCategoria',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'pedidos',
    component: __WEBPACK_IMPORTED_MODULE_14__components_views_Pedidos_Pedidos_vue___default.a,
    name: 'Pedidos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'pedidos/relatorios',
    component: __WEBPACK_IMPORTED_MODULE_15__components_views_Pedidos_Relatorios_vue___default.a,
    name: 'Relatório de Pedidos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-usuario',
    component: __WEBPACK_IMPORTED_MODULE_16__components_views_NovoUsuario_vue___default.a,
    name: 'Novo Usuario',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'minha-conta',
    component: __WEBPACK_IMPORTED_MODULE_17__components_views_MinhaConta_vue___default.a,
    name: 'Minha Conta',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'alterar-email',
    component: __WEBPACK_IMPORTED_MODULE_18__components_views_AlterarEmail_vue___default.a,
    name: 'Alterar Email',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'alterar-senha',
    component: __WEBPACK_IMPORTED_MODULE_19__components_views_AlterarSenha_vue___default.a,
    name: 'Alterar Senha',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'condpagto',
    component: __WEBPACK_IMPORTED_MODULE_20__components_views_CondPagto___default.a,
    name: 'Condição de Pagamento',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'nova-condpagto',
    component: __WEBPACK_IMPORTED_MODULE_21__components_views_NovaCondPagto___default.a,
    name: 'Nova Condição de Pagamento',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'calendario',
    component: __WEBPACK_IMPORTED_MODULE_25__components_views_Calendario___default.a,
    name: 'Calendário',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'servicos',
    component: __WEBPACK_IMPORTED_MODULE_26__components_views_Servicos_Servicos___default.a,
    name: 'Servicos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-servico',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Servicos_novoServico___default.a,
    name: 'Novo Serviço',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'servicos/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Servicos_novoServico___default.a,
    name: 'Editar Serviço',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'categorias-servicos',
    component: __WEBPACK_IMPORTED_MODULE_28__components_views_ServicoCategorias_ServicoCategorias___default.a,
    name: 'Categoria de Servicos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'nova-categoriaservicos',
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_ServicoCategorias_novaCategoria___default.a,
    name: 'Nova Categoria de Servicos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'categoria-servicos/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_ServicoCategorias_novaCategoria___default.a,
    name: 'editarCategoriadeServicos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'colaborador',
    component: __WEBPACK_IMPORTED_MODULE_29__components_views_Funcionarios_Funcionarios___default.a,
    name: 'Colaborador',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-colaborador',
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_Funcionarios_novoFuncionario_vue___default.a,
    name: 'Novo Colaborador',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'colaborador/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_Funcionarios_novoFuncionario_vue___default.a,
    name: 'Editar Colaborador',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'problemas',
    component: __WEBPACK_IMPORTED_MODULE_32__components_views_Problemas_Problemas___default.a,
    name: 'Problemas e Soluções',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-problema',
    component: __WEBPACK_IMPORTED_MODULE_33__components_views_Problemas_novoProblema___default.a,
    name: 'Novo Problema e Soluções',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'problemas/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_33__components_views_Problemas_novoProblema___default.a,
    name: 'Editar Problema',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'help',
    component: __WEBPACK_IMPORTED_MODULE_34__components_views_Help_help___default.a,
    name: 'Ajuda',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'solicitacoes',
    component: __WEBPACK_IMPORTED_MODULE_35__components_views_Solicitacoes_Solicitacoes___default.a,
    name: 'Solicitacoes',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'solicitacoes/:id',
    component: __WEBPACK_IMPORTED_MODULE_42__components_views_Solicitacoes_detalhe___default.a,
    name: 'Detalhe Solicitação',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'pacotes',
    component: __WEBPACK_IMPORTED_MODULE_36__components_views_PacotesViagens_PacotesViagens___default.a,
    name: 'Pacotes',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-pacote',
    component: __WEBPACK_IMPORTED_MODULE_37__components_views_PacotesViagens_novoPacote___default.a,
    name: 'Novo Pacote',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'pacotes/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_37__components_views_PacotesViagens_novoPacote___default.a,
    name: 'Editar Pacote',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'filtros',
    component: __WEBPACK_IMPORTED_MODULE_40__components_views_Filtros_Filtros___default.a,
    name: 'Filtros',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'novo-filtro',
    component: __WEBPACK_IMPORTED_MODULE_41__components_views_Filtros_novoFiltro___default.a,
    name: 'Novo Filtro',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'filtros/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_41__components_views_Filtros_novoFiltro___default.a,
    name: 'Editar Filtro',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'perguntas',
    component: __WEBPACK_IMPORTED_MODULE_38__components_views_PerguntasPersonalizadas_PerguntasPersonalizadas___default.a,
    name: 'Perguntas Personalizadas',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'nova-pergunta',
    component: __WEBPACK_IMPORTED_MODULE_39__components_views_PerguntasPersonalizadas_novaPergunta___default.a,
    name: 'Nova Pergunta',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'perguntas/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_39__components_views_PerguntasPersonalizadas_novaPergunta___default.a,
    name: 'Editar Pergunta',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'inclusao-rapida-produtos',
    component: __WEBPACK_IMPORTED_MODULE_43__components_views_InclusaoRapida_InclusaoRapidaProdutos___default.a,
    name: 'Inclusão Rádida de Produtos',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'inclusao-rapida-categorias',
    component: __WEBPACK_IMPORTED_MODULE_44__components_views_InclusaoRapida_InclusaoRapidaCategorias___default.a,
    name: 'Inclusão Rádida de Categorias',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'campanhas',
    component: __WEBPACK_IMPORTED_MODULE_45__components_views_Campanhas_Campanhas___default.a,
    name: 'Campanhas',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'nova-campanha',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Campanhas_novaCampanha___default.a,
    name: 'Nova Campanha',
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'campanhas/:id/editar',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Campanhas_novaCampanha___default.a,
    name: 'Editar Campanha',
    meta: {
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jwt_token__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);





var _this = this;





__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (config) {
  var token = localStorage.getItem('token');
  if (token) {
    config.headers.token = token.substr(1, token.length - 2);
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(function (data) {
  return data;
}, function (responseError) {
  console.log('error inteceptor => ', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(responseError));
  if (responseError.response && responseError.response.status === 401 || responseError.response.status === 403) {
    var email = localStorage.getItem('usuario'),
        password = localStorage.getItem('password');
    __WEBPACK_IMPORTED_MODULE_4__jwt_token__["a" /* default */].accessToken(email, password).then(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setToken', res.data);
                responseError.config.headers.token = res.data.token;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.request(responseError.config);

              case 4:
                window.location.reload(true);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(responseError);
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Jwt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decrypt__ = __webpack_require__(242);





__webpack_require__(781);

var Jwt = function () {
    function Jwt() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Jwt);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Jwt, null, [{
        key: 'accessToken',
        value: function accessToken(email, password) {
            var response = JSON.parse(localStorage.getItem('response'));
            var urlsApi = response ? response.Empresas[localStorage.getItem('INDEXEMPRESA')].api : '';

            var descpass = __WEBPACK_IMPORTED_MODULE_3__decrypt__["a" /* default */].descriptografar(password);
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(urlsApi + 'login', { email: email, password: descpass });
        }
    }]);

    return Jwt;
}();

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_jwt_token__ = __webpack_require__(243);



/* harmony default export */ __webpack_exports__["a"] = ({
    autenticacaoUsuario: function autenticacaoUsuario(context, _ref) {
        var user = _ref.user,
            password = _ref.password;

        return __WEBPACK_IMPORTED_MODULE_1__services_jwt_token__["a" /* default */].accessToken(user, password).then(function (response) {
            if (response.status === 201 || response.status === 200) {
                context.commit('SET_USERTOKEN', response.data);
            }
        });
    },
    logout: function logout(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_1__services_jwt_token__["a" /* default */].logout();
            return resolve({});
        });
    }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_session_storage__ = __webpack_require__(244);


/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_ID_ALTERACAO: function SET_ID_ALTERACAO(state, id) {
    state.id_alteracao = id;
  },
  SET_FULLNAME: function SET_FULLNAME(state, name) {
    state.nome_completo = name;
  },
  SET_USERNAME: function SET_USERNAME(state, name) {
    state.nome_usuario = name;
  },
  SET_EMPRESAS: function SET_EMPRESAS(state, empresas) {
    state.empresas = empresas;
  },
  SET_EMPRESA: function SET_EMPRESA(state, empresa) {
    state.empresa_nome = empresa;
  },
  SET_EMPRESA_ID: function SET_EMPRESA_ID(state, id) {
    state.empresa_id = id;
  },
  SET_EMAIL: function SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_API: function SET_API(state, api) {
    state.api = api;
  },
  SET_APIBOT: function SET_APIBOT(state, api) {
    state.api_bot = api;
  },
  SET_FOTO: function SET_FOTO(state, foto) {
    state.foto = foto;
  },
  SET_LOGO: function SET_LOGO(state, logo) {
    state.logo = logo;
  },
  SHOW_EMPRESA: function SHOW_EMPRESA(state) {
    state.show_empresa = true;
  },
  HIDDEN_EMPRESA: function HIDDEN_EMPRESA(state) {
    state.show_empresa = false;
  },
  ACTIVE_BOT: function ACTIVE_BOT(state, status) {
    state.bot_ativo = status;
  },
  SET_INDEXEMPRESA: function SET_INDEXEMPRESA(state, index) {
    localStorage.setItem('INDEXEMPRESA', index);
    state.empresa_ativa = index;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.fb_page_token = token;
  },
  SET_PERMITE_IMPRESSAO: function SET_PERMITE_IMPRESSAO(state, permiteImpressao) {
    state.permite_impressao = permiteImpressao;
  },
  SET_PERMITE_EMAIL: function SET_PERMITE_EMAIL(state, permiteEmail) {
    state.permite_email = permiteEmail;
  },
  SET_FB_ID_EMPRESA: function SET_FB_ID_EMPRESA(state, fbId) {
    localStorage.setItem('FB_ID', fbId);
    state.empresa_fb_id = fbId;
  },
  SET_MODULOS_EMPRESA: function SET_MODULOS_EMPRESA(state, modulos) {
    if (modulos) {
      var mod = modulos.map(function (modulo) {
        return modulo.descricao;
      });
      localStorage.setItem('modulos', mod);
      state.modulos = mod;
    }
  },
  SET_USERTOKEN: function SET_USERTOKEN(state, response) {
    __WEBPACK_IMPORTED_MODULE_0__services_session_storage__["a" /* default */].setObject('token', response.token);
    state.auth.token = response.token;
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  id_alteracao: 0,
  nome_completo: '',
  nome_usuario: '',
  empresas: [],
  empresa_ativa: parseInt(localStorage.getItem('INDEXEMPRESA')),
  empresa_nome: '',
  empresa_id: '',
  email: '',
  api: '',
  api_bot: '',
  foto: '',
  logo: '',
  show_empresa: true,
  bot_ativo: undefined,
  fb_page_token: '',
  permite_impressao: null,
  permite_email: null,
  empresa_fb_id: '',
  modulos: [],
  token: ''
});

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","C:\\Users\\joaop\\workspace\\sev\\sev-site"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"C:\\Users\\joaop\\workspace\\sev\\sev-site","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 936 */,
/* 937 */,
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 282,
	"./af.js": 282,
	"./ar": 289,
	"./ar-dz": 283,
	"./ar-dz.js": 283,
	"./ar-kw": 284,
	"./ar-kw.js": 284,
	"./ar-ly": 285,
	"./ar-ly.js": 285,
	"./ar-ma": 286,
	"./ar-ma.js": 286,
	"./ar-sa": 287,
	"./ar-sa.js": 287,
	"./ar-tn": 288,
	"./ar-tn.js": 288,
	"./ar.js": 289,
	"./az": 290,
	"./az.js": 290,
	"./be": 291,
	"./be.js": 291,
	"./bg": 292,
	"./bg.js": 292,
	"./bm": 293,
	"./bm.js": 293,
	"./bn": 294,
	"./bn.js": 294,
	"./bo": 295,
	"./bo.js": 295,
	"./br": 296,
	"./br.js": 296,
	"./bs": 297,
	"./bs.js": 297,
	"./ca": 298,
	"./ca.js": 298,
	"./cs": 299,
	"./cs.js": 299,
	"./cv": 300,
	"./cv.js": 300,
	"./cy": 301,
	"./cy.js": 301,
	"./da": 302,
	"./da.js": 302,
	"./de": 305,
	"./de-at": 303,
	"./de-at.js": 303,
	"./de-ch": 304,
	"./de-ch.js": 304,
	"./de.js": 305,
	"./dv": 306,
	"./dv.js": 306,
	"./el": 307,
	"./el.js": 307,
	"./en-SG": 308,
	"./en-SG.js": 308,
	"./en-au": 309,
	"./en-au.js": 309,
	"./en-ca": 310,
	"./en-ca.js": 310,
	"./en-gb": 311,
	"./en-gb.js": 311,
	"./en-ie": 312,
	"./en-ie.js": 312,
	"./en-il": 313,
	"./en-il.js": 313,
	"./en-nz": 314,
	"./en-nz.js": 314,
	"./eo": 315,
	"./eo.js": 315,
	"./es": 318,
	"./es-do": 316,
	"./es-do.js": 316,
	"./es-us": 317,
	"./es-us.js": 317,
	"./es.js": 318,
	"./et": 319,
	"./et.js": 319,
	"./eu": 320,
	"./eu.js": 320,
	"./fa": 321,
	"./fa.js": 321,
	"./fi": 322,
	"./fi.js": 322,
	"./fo": 323,
	"./fo.js": 323,
	"./fr": 326,
	"./fr-ca": 324,
	"./fr-ca.js": 324,
	"./fr-ch": 325,
	"./fr-ch.js": 325,
	"./fr.js": 326,
	"./fy": 327,
	"./fy.js": 327,
	"./ga": 328,
	"./ga.js": 328,
	"./gd": 329,
	"./gd.js": 329,
	"./gl": 330,
	"./gl.js": 330,
	"./gom-latn": 331,
	"./gom-latn.js": 331,
	"./gu": 332,
	"./gu.js": 332,
	"./he": 333,
	"./he.js": 333,
	"./hi": 334,
	"./hi.js": 334,
	"./hr": 335,
	"./hr.js": 335,
	"./hu": 336,
	"./hu.js": 336,
	"./hy-am": 337,
	"./hy-am.js": 337,
	"./id": 338,
	"./id.js": 338,
	"./is": 339,
	"./is.js": 339,
	"./it": 341,
	"./it-ch": 340,
	"./it-ch.js": 340,
	"./it.js": 341,
	"./ja": 342,
	"./ja.js": 342,
	"./jv": 343,
	"./jv.js": 343,
	"./ka": 344,
	"./ka.js": 344,
	"./kk": 345,
	"./kk.js": 345,
	"./km": 346,
	"./km.js": 346,
	"./kn": 347,
	"./kn.js": 347,
	"./ko": 348,
	"./ko.js": 348,
	"./ku": 349,
	"./ku.js": 349,
	"./ky": 350,
	"./ky.js": 350,
	"./lb": 351,
	"./lb.js": 351,
	"./lo": 352,
	"./lo.js": 352,
	"./lt": 353,
	"./lt.js": 353,
	"./lv": 354,
	"./lv.js": 354,
	"./me": 355,
	"./me.js": 355,
	"./mi": 356,
	"./mi.js": 356,
	"./mk": 357,
	"./mk.js": 357,
	"./ml": 358,
	"./ml.js": 358,
	"./mn": 359,
	"./mn.js": 359,
	"./mr": 360,
	"./mr.js": 360,
	"./ms": 362,
	"./ms-my": 361,
	"./ms-my.js": 361,
	"./ms.js": 362,
	"./mt": 363,
	"./mt.js": 363,
	"./my": 364,
	"./my.js": 364,
	"./nb": 365,
	"./nb.js": 365,
	"./ne": 366,
	"./ne.js": 366,
	"./nl": 368,
	"./nl-be": 367,
	"./nl-be.js": 367,
	"./nl.js": 368,
	"./nn": 369,
	"./nn.js": 369,
	"./pa-in": 370,
	"./pa-in.js": 370,
	"./pl": 371,
	"./pl.js": 371,
	"./pt": 373,
	"./pt-br": 372,
	"./pt-br.js": 372,
	"./pt.js": 373,
	"./ro": 374,
	"./ro.js": 374,
	"./ru": 375,
	"./ru.js": 375,
	"./sd": 376,
	"./sd.js": 376,
	"./se": 377,
	"./se.js": 377,
	"./si": 378,
	"./si.js": 378,
	"./sk": 379,
	"./sk.js": 379,
	"./sl": 380,
	"./sl.js": 380,
	"./sq": 381,
	"./sq.js": 381,
	"./sr": 383,
	"./sr-cyrl": 382,
	"./sr-cyrl.js": 382,
	"./sr.js": 383,
	"./ss": 384,
	"./ss.js": 384,
	"./sv": 385,
	"./sv.js": 385,
	"./sw": 386,
	"./sw.js": 386,
	"./ta": 387,
	"./ta.js": 387,
	"./te": 388,
	"./te.js": 388,
	"./tet": 389,
	"./tet.js": 389,
	"./tg": 390,
	"./tg.js": 390,
	"./th": 391,
	"./th.js": 391,
	"./tl-ph": 392,
	"./tl-ph.js": 392,
	"./tlh": 393,
	"./tlh.js": 393,
	"./tr": 394,
	"./tr.js": 394,
	"./tzl": 395,
	"./tzl.js": 395,
	"./tzm": 397,
	"./tzm-latn": 396,
	"./tzm-latn.js": 396,
	"./tzm.js": 397,
	"./ug-cn": 398,
	"./ug-cn.js": 398,
	"./uk": 399,
	"./uk.js": 399,
	"./ur": 400,
	"./ur.js": 400,
	"./uz": 402,
	"./uz-latn": 401,
	"./uz-latn.js": 401,
	"./uz.js": 402,
	"./vi": 403,
	"./vi.js": 403,
	"./x-pseudo": 404,
	"./x-pseudo.js": 404,
	"./yo": 405,
	"./yo.js": 405,
	"./zh-cn": 406,
	"./zh-cn.js": 406,
	"./zh-hk": 407,
	"./zh-hk.js": 407,
	"./zh-tw": 408,
	"./zh-tw.js": 408
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;

/***/ }),
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAMAAACxiD++AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////////////////////////////////////////////3EAnbYAAAAOdFJOUwADZ66SoQjEhnS7/gsNGQL7+wAAAKtJREFUKM+F01sOhCAQRNESFV/I/pc70Og0YJfyJbmHhBAbGGYHstw8IPV4EOGOmERYIhGpxyUAJxHSz/xlC+1FxE64qB1yj1ZID7oXsel+63ovnj2JXUXue+hvrcLugL+EdG+9XBG8X+Kl34J3YM1g/egvIvdx5EK691RIz78YEXdnQrst6m6JqemXmNo+D/WJNAyVePZWWL0WdlfB+l+UAQQReaAc65DB/wGsZgzLN0IQWAAAAABJRU5ErkJggg=="

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDcuOTcxIDQ3Ljk3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuOTcxIDQ3Ljk3MTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZD0iTTI4LjIyOCwyMy45ODZMNDcuMDkyLDUuMTIyYzEuMTcyLTEuMTcxLDEuMTcyLTMuMDcxLDAtNC4yNDJjLTEuMTcyLTEuMTcyLTMuMDctMS4xNzItNC4yNDIsMEwyMy45ODYsMTkuNzQ0TDUuMTIxLDAuODgNCgkJYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJsMTguODY1LDE4Ljg2NEwwLjg3OSw0Mi44NWMtMS4xNzIsMS4xNzEtMS4xNzIsMy4wNzEsMCw0LjI0Mg0KCQlDMS40NjUsNDcuNjc3LDIuMjMzLDQ3Ljk3LDMsNDcuOTdzMS41MzUtMC4yOTMsMi4xMjEtMC44NzlsMTguODY1LTE4Ljg2NEw0Mi44NSw0Ny4wOTFjMC41ODYsMC41ODYsMS4zNTQsMC44NzksMi4xMjEsMC44NzkNCgkJczEuNTM1LTAuMjkzLDIuMTIxLTAuODc5YzEuMTcyLTEuMTcxLDEuMTcyLTMuMDcxLDAtNC4yNDJMMjguMjI4LDIzLjk4NnoiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(941)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1194),
  /* scopeId */
  "data-v-00a6d6ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1031)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1291),
  /* scopeId */
  "data-v-ae216818",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(961)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1216),
  /* scopeId */
  "data-v-232176dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(968)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1225),
  /* scopeId */
  "data-v-322a38c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1266),
  /* scopeId */
  "data-v-723b8193",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(949)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1202),
  /* scopeId */
  "data-v-0e033bc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(962)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1217),
  /* scopeId */
  "data-v-24daacc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1037)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1299),
  /* scopeId */
  "data-v-fd7dc8ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(997)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(943)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(978)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1235),
  /* scopeId */
  "data-v-44bc891a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(948)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1201),
  /* scopeId */
  "data-v-0d7b5f9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(952)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1205),
  /* scopeId */
  "data-v-1218e36f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1010)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(956)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1210),
  /* scopeId */
  "data-v-1c4e64e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(975)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1232),
  /* scopeId */
  "data-v-400081aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(974)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1231),
  /* scopeId */
  "data-v-3fe452a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(982)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1239),
  /* scopeId */
  "data-v-49588d56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(983)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1240),
  /* scopeId */
  "data-v-4966a4d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(984)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1241),
  /* scopeId */
  "data-v-4974bc58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(985)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1242),
  /* scopeId */
  "data-v-4982d3d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(986)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1243),
  /* scopeId */
  "data-v-4990eb5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(987)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1244),
  /* scopeId */
  "data-v-499f02db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(988)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1245),
  /* scopeId */
  "data-v-49ad1a5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(989)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1246),
  /* scopeId */
  "data-v-49bb31dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(979)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1236),
  /* scopeId */
  "data-v-4556d1f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1011)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1269),
  /* scopeId */
  "data-v-7566ef70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1015)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1274),
  /* scopeId */
  "data-v-7ce87216",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(976)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1233),
  /* scopeId */
  "data-v-402d7726",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(990)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1247),
  /* scopeId */
  "data-v-4ee2db16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(953)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1206),
  /* scopeId */
  "data-v-16615714",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(999)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1256),
  /* scopeId */
  "data-v-5fc70428",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1009)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1267),
  /* scopeId */
  "data-v-729bf5ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(966)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1222),
  /* scopeId */
  "data-v-30208097",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1004)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1262),
  /* scopeId */
  "data-v-6d322a92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1288),
  /* scopeId */
  "data-v-a89e095e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(950)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1203),
  /* scopeId */
  "data-v-0e8bfad0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1000)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1258),
  /* scopeId */
  "data-v-64413749",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(972)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1229),
  /* scopeId */
  "data-v-3925a174",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1013)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1271),
  /* scopeId */
  "data-v-76f36450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(992)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1249),
  /* scopeId */
  "data-v-50035414",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1024)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1284),
  /* scopeId */
  "data-v-9f025064",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1023)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1283),
  /* scopeId */
  "data-v-9ee62162",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1022)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1282),
  /* scopeId */
  "data-v-9ec9f260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1021)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1281),
  /* scopeId */
  "data-v-9eadc35e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(958)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1213),
  /* scopeId */
  "data-v-1fc88140",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(970)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1227),
  /* scopeId */
  "data-v-35ec26af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1014)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1272),
  /* scopeId */
  "data-v-782c9012",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(947)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1200),
  /* scopeId */
  "data-v-0c4b0f3f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1035)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1296),
  /* scopeId */
  "data-v-e561e50e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1286),
  /* scopeId */
  "data-v-9ff1fee2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1027)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1287),
  /* scopeId */
  "data-v-a5c2f608",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1030)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1290),
  /* scopeId */
  "data-v-ad3c25d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(946)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1199),
  /* scopeId */
  "data-v-0aeda035",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1012)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(995)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1017)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(967)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1019)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(969)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(959)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1029)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1289),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(942)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(940)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1038)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1300),
  /* scopeId */
  "data-v-feb415d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(963)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1218),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(971)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(939)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(954)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1032)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1293),
  /* scopeId */
  "data-v-d10b0a0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(944)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1197),
  /* scopeId */
  "data-v-05f306be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(964)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1219),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1003)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1261),
  /* scopeId */
  "data-v-6ceab4fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1025)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1005)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(977)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(980)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1001)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(973)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1020)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1007)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1034)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1295),
  /* scopeId */
  "data-v-dc72093e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1006)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1264),
  /* scopeId */
  "data-v-6fa90fbf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1002)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1018)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1278),
  /* scopeId */
  "data-v-899d6f16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(998)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1255),
  /* scopeId */
  "data-v-5ed32276",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(996)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(945)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1224),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(960)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1215),
  /* scopeId */
  "data-v-21fda9a1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(991)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1248),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1016)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(951)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1204),
  /* scopeId */
  "data-v-0ef79b60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(955)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Descrição ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/nova-condpagto"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Nova Condição de Pagamento")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCondPagto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.condPagtoFiltered), function(p) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(p.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(p.nome))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger ",
      on: {
        "click": function($event) {
          return _vm.excluir(p.id)
        }
      }
    }, [_vm._v("Excluir")])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCondPagto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/nova-campanha"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Nova Campanha")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                              ")])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.campanhas.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.campanhas), function(c, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("Cupom")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verificarPremio(c)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.codigo))]), _vm._v(" "), _c('td', [_c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      on: {
        "change": function($event) {
          return _vm.changeStatus(c.ativo, c.id)
        }
      },
      model: {
        value: (c.ativo),
        callback: function($$v) {
          _vm.$set(c, "ativo", $$v)
        },
        expression: "c.ativo"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Campanha',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])])
  })], 2), _vm._v(" "), _c('tfoot')])])])])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-chat-window",
    class: {
      opened: _vm.isOpen, closed: !_vm.isOpen
    }
  }, [_c('ListUsers', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.escolheuCliente),
      expression: "!escolheuCliente"
    }],
    attrs: {
      "clientes": _vm.mensagens
    },
    on: {
      "selectedCliente": _vm.selectedCliente,
      "atualizarImagem": _vm.atualizarImagem
    }
  }), _vm._v(" "), (_vm.escolheuCliente) ? _c('Header', {
    attrs: {
      "teamName": _vm.clienteEscolhido.nome,
      "imageUrl": _vm.clienteEscolhido.img,
      "onClose": _vm.onClose
    },
    on: {
      "back": _vm.backChat
    }
  }) : _vm._e(), _vm._v(" "), (_vm.escolheuCliente) ? _c('MessageList', {
    attrs: {
      "messages": _vm.messageList,
      "imageUrl": _vm.clienteEscolhido.img,
      "chatImageUrl": _vm.clienteEscolhido.img
    }
  }) : _vm._e(), _vm._v(" "), _c('UserInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.escolheuCliente),
      expression: "escolheuCliente"
    }],
    attrs: {
      "showEmoji": _vm.showEmoji,
      "onSubmit": _vm.onUserInputSubmit,
      "showFile": _vm.showFile,
      "placeholder": _vm.placeholder
    },
    on: {
      "sendMsg": _vm.sendMsg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 control-section"
  }, [(_vm.carregou) ? _c('ejs-schedule', {
    ref: "ScheduleObj",
    attrs: {
      "id": "Schedule",
      "height": "950px",
      "currentView": _vm.currentView,
      "selectedDate": _vm.selectedDate,
      "eventSettings": _vm.eventSettings,
      "eventRendered": _vm.oneventRendered,
      "startHour": _vm.startHour,
      "endHour": _vm.endHour,
      "popupOpen": _vm.onPopupOpen,
      "created": _vm.onCreate,
      "actionComplete": _vm.onActionComplete,
      "agendaDaysCount": 30
    }
  }, [_c('e-views', [_c('e-view', {
    attrs: {
      "option": "Day",
      "startHour": "07:00",
      "endHour": "18:00"
    }
  }), _vm._v(" "), _c('e-view', {
    attrs: {
      "option": "Week",
      "startHour": "09:00",
      "endHour": "19:00",
      "timeScale": _vm.timeScale,
      "showWeekend": _vm.showWeekend
    }
  }), _vm._v(" "), _c('e-view', {
    attrs: {
      "option": "Month",
      "group": _vm.group,
      "eventTemplate": _vm.monthEventTemplate
    }
  })], 1), _vm._v(" "), _c('e-resources', [_c('e-resource', {
    attrs: {
      "field": "GroupId",
      "title": "Funcionário",
      "name": "Owners",
      "dataSource": _vm.groupData,
      "textField": "GroupText",
      "idField": "GroupId",
      "colorField": "GroupColor"
    }
  })], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message"
  }, [_c('div', {
    staticClass: "sc-message--content",
    class: {
      sent: _vm.message.author === 'me', received: _vm.message.author !== 'me'
    }
  }, [_c('div', {
    staticClass: "sc-message--avatar",
    style: ({
      backgroundImage: ("url(" + _vm.chatImageUrl + ")")
    })
  }), (_vm.message.type === 'text') ? _c('TextMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : (_vm.message.type === 'emoji') ? _c('EmojiMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : (_vm.message.type === 'file') ? _c('FileMessage', {
    attrs: {
      "data": _vm.message.data
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do Colaborador ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-colaborador"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Colaborador")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.funcionarios), function(f) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(f.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(f.nome))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": f.imagem
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.hr_entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.hr_saida))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.hr_inicio_intervalo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.hr_fim_intervalo))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + f.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Colaborador',
          params: {
            id: f.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(f.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'Nova Categoria de Servicos'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-plus paddingRight"
  }), _vm._v("Nova Categoria\n                  ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'orderCategoria',
        params: {
          categoriasFiltered: _vm.categoriasFiltered
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-list-ol paddingRight"
  }), _vm._v("Ordenar Categorias\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categoriasFiltered), function(c) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(c.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(c.descricao))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": c.imagem
      }
    })]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + c.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'editarCategoriadeServicos',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluirCategoria(c.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--wave",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--square-grid",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sc-user-input--send-icon-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_c('svg', {
    staticClass: "sc-user-input--send-icon",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "37.393px",
      "height": "37.393px",
      "viewBox": "0 0 37.393 37.393",
      "enableBackground": "new 0 0 37.393 37.393"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.511,17.594L2.371,2.932c-0.374-0.161-0.81-0.079-1.1,0.21C0.982,3.43,0.896,3.865,1.055,4.241l5.613,13.263\n        L2.082,32.295c-0.115,0.372-0.004,0.777,0.285,1.038c0.188,0.169,0.427,0.258,0.67,0.258c0.132,0,0.266-0.026,0.392-0.08\n        l33.079-14.078c0.368-0.157,0.607-0.519,0.608-0.919S36.879,17.752,36.511,17.594z M4.632,30.825L8.469,18.45h8.061\n        c0.552,0,1-0.448,1-1s-0.448-1-1-1H8.395L3.866,5.751l29.706,12.757L4.632,30.825z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message--file"
  }, [_c('div', {
    staticClass: "sc-message--file-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.file.url || '#',
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(424),
      "alt": "generic file icon",
      "height": "60"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sc-message--file-name"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.file.url ? _vm.data.file.url : '#',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.data.file.name || ''))])]), _vm._v(" "), _c('div', {
    staticClass: "sc-message--file-text"
  }, [_vm._v(_vm._s(_vm.data.text)), (_vm.data.meta) ? _c('p', {
    staticClass: "sc-message--meta"
  }, [_vm._v(_vm._s(_vm.data.meta))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner-origami",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner loading",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.carregou) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados do Cliente"
    }
  }, [_c('div', {
    staticClass: "bodyBox",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cliente: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.nome) + " " + _vm._s(_vm.solicitacao.Clientes.sobrenome) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.email) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.contato) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Preferência de contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Preferencias[0].tipo) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horário para contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Preferencias[0].horario) + " "), _c('br')])])])], 1)]), _vm._v(" "), (_vm.solicitacao.tipo === 'personalizado') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Interesses"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.solicitacao.SolicitacoesHasFiltros), function(pergunta) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "1em",
        "display": "flex"
      }
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(pergunta.Filtros.descricao) + ": ")]), _c('h4', {
      staticClass: "resposta"
    }, [_vm._v(_vm._s(pergunta.filtrosid === _vm.solicitacao.RespostasAdicionais[0].filtrosid ? ((pergunta.resposta) + " (" + (_vm.solicitacao.RespostasAdicionais[0].resposta) + ")") : pergunta.resposta) + " ")])])
  }), 0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Pacote de Viagem"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.qtdepessoas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.preco))])])]), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados Pagamento"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunasPgto), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].vencimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].codigo))])])]), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados Passageiros"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunasPassageiros), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacao.DadosPassageiros), function(passageiro) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(passageiro.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.cpf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.contato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.email))])])
  }), 0), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message--text"
  }, [_vm._v(_vm._s(_vm.data.text)), (_vm.data.meta) ? _c('p', {
    staticClass: "sc-message--meta"
  }, [_vm._v(_vm._s(_vm.data.meta))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hexagon",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hexagon-container"
  }, [_c('li', {
    staticClass: "hexagon hex_1"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_2"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_3"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_4"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_5"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_6"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_7"
  })])
}]}

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/pedidos"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-purple",
      "icon": "ion ion-alert"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("PEDIDOS NOVOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.novosPedidos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/pedidos"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-aqua",
      "icon": "ion ion-ios-cart-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODOS OS PEDIDOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.totalPedidos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/calendario"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-calendar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("AGENDAMENTOS DE HOJE")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.agendamentosHoje))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/calendario"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-calendar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODOS AGENDAMENTOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.todosAgendamentos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/solicitacoes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-alert"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("SOLICITAÇÕES PENDENTES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.solicitacoesPendentes))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/solicitacoes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-ios-cart-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODAS SOLICITAÇÕES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.todasSolicitacoes))])])], 1) : _vm._e(), _vm._v(" "), _c('info-box', {
    staticClass: "offset-md-3",
    attrs: {
      "colorIcon": "bg-green",
      "icon": "ion-chatbubbles"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.atendimentos))])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/clientes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-yellow",
      "icon": "ion ion-ios-people-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("CLIENTES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.clientes) + " ")])])], 1)], 1), _vm._v(" "), (_vm.possuiDelivery) ? _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [(_vm.config.notifica_cliente) ? _c('div', {
    staticClass: "col-sm-6 col-xs-12 previsaoEntrega"
  }, [_c('p', {
    staticClass: "text-center paragrafo"
  }, [_c('strong', [_vm._v("Previsao de entrega")])]), _vm._v(" "), _c('div', {
    staticClass: "row slider"
  }, [_c('vue-slider', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.tempo_entrega),
      callback: function($$v) {
        _vm.tempo_entrega = $$v
      },
      expression: "tempo_entrega"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row btnEntrega"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravar && !_vm.gravando),
      expression: "gravar && !gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarEntrega
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary disabled"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  }), _vm._v(" "), _c('div', {
    class: [_vm.config.notifica_cliente ? 'col-sm-6 col-xs-12' : 'col-sm-6 col-xs-12 col-sm-offset-3']
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Ranking de Produtos")]), _c('br'), _vm._v("\n                Comparativo dos três produtos mais vendidos.\n              ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "languagePie"
    }
  })])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Escolhas Preferidas")]), _c('br'), _vm._v("\n                As principais respostas recebidas\n              ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "tagsPreferidas"
    }
  })])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.nome),
      expression: "funcionarioLocal.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Horário Entrada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_entrada),
      expression: "funcionarioLocal.hr_entrada"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_entrada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_entrada", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Horário Saída")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_saida),
      expression: "funcionarioLocal.hr_saida"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_saida)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_saida", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Inicio Intervalo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_inicio_intervalo),
      expression: "funcionarioLocal.hr_inicio_intervalo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_inicio_intervalo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_inicio_intervalo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Fim Intervalo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_fim_intervalo),
      expression: "funcionarioLocal.hr_fim_intervalo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_fim_intervalo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_fim_intervalo", $event.target.value)
      }
    }
  })])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.servicos,
      "selected-options": _vm.funcionarioLocal.funcao,
      "placeholder": "select item"
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.funcionarioLocal.ativo),
      callback: function($$v) {
        _vm.$set(_vm.funcionarioLocal, "ativo", $$v)
      },
      expression: "funcionarioLocal.ativo"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/colaborador"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.gravando),
      expression: "habilitaGravar && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Simple")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Striped Full Width Table")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', [_vm._v("Progress")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Label")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v("Update software")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "55%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-red"
  }, [_vm._v("55%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2.")]), _vm._v(" "), _c('td', [_vm._v("Clean database")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "width": "70%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-yellow"
  }, [_vm._v("70%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3.")]), _vm._v(" "), _c('td', [_vm._v("Cron job running")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary",
    staticStyle: {
      "width": "30%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-light-blue"
  }, [_vm._v("30%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.")]), _vm._v(" "), _c('td', [_vm._v("Fix and squish bugs")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-green"
  }, [_vm._v("90%")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Data tables")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Data Table With Full Features")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "167px"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "142px"
    },
    attrs: {
      "aria-label": "Engine version: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "101px"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("CSS grade")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Blink")]), _vm._v(" "), _c('td', [_vm._v("Iridium  54.0")]), _vm._v(" "), _c('td', [_vm._v("GNU/Linux")]), _vm._v(" "), _c('td', [_vm._v("54")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.5")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 2.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 3.0")]), _vm._v(" "), _c('td', [_vm._v("Win 2k+ / OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.9")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.0")]), _vm._v(" "), _c('td', [_vm._v("OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.5")]), _vm._v(" "), _c('td', [_vm._v("OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape 7.2")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / Mac OS 8.6-9.2")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Browser 8")]), _vm._v(" "), _c('td', [_vm._v("Win 98SE+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Navigator 9")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Mozilla 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / OSX.1+")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("A")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("CSS grade")])])])])])])])])])])])])
}]}

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle",
    style: (_vm.styles),
    attrs: {
      "viewBox": "0 0 66 66",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "square",
      "color": "#20a0ff",
      "error-color": "#ff4949",
      "title": "Cadastro de Pacote de Viagem",
      "subtitle": "Avance pelas guias para finalizar o cadastro"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Informações do Pacote",
      "icon": "fa fa-suitcase",
      "before-change": _vm.validateFirstStep
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.informacoesPacote,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Título"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.titulo),
      expression: "informacoesPacote.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.informacoesPacote.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "titulo", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Descrição"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.descricao),
      expression: "informacoesPacote.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.informacoesPacote.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "descricao", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Quantidade de Passageiros"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.quantidadePassageiros),
      expression: "informacoesPacote.quantidadePassageiros"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.informacoesPacote.quantidadePassageiros)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "quantidadePassageiros", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Preço"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.preco),
      expression: "informacoesPacote.preco"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control currency",
    attrs: {
      "value": "0",
      "min": "0",
      "step": "0.01",
      "data-number-to-fixed": "2",
      "data-number-stepfactor": "100"
    },
    domProps: {
      "value": (_vm.informacoesPacote.preco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "preco", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Imagens"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input-pacote",
      "multiple": ""
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Tags do Pacote",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.tagsParaPacote,
      "selected-options": _vm.informacoesPacote.tags,
      "placeholder": "Tags do Pacote"
    },
    on: {
      "select": _vm.onSelectPacote
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.informacoesPacote.ativo),
      callback: function($$v) {
        _vm.$set(_vm.informacoesPacote, "ativo", $$v)
      },
      expression: "informacoesPacote.ativo"
    }
  })], 1)])])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Informações do Hotel",
      "icon": "fa fa-bed",
      "before-change": _vm.validateSecondStep
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.informacoesHotel,
      "rules": _vm.rulesLogin
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Nome"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesHotel.nome),
      expression: "informacoesHotel.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.informacoesHotel.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesHotel, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Endereço"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesHotel.endereco),
      expression: "informacoesHotel.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.informacoesHotel.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesHotel, "endereco", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Tags do Hotel",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.tagsParaHotel,
      "selected-options": _vm.informacoesHotel.tags,
      "placeholder": "Tags do Hotel"
    },
    on: {
      "select": _vm.onSelectHotel
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Imagens"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input-hotel",
      "multiple": ""
    }
  })])], 1)])])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Informações Voo",
      "icon": "fa fa-plane"
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.informacoesVoo,
      "rules": _vm.rulesLogin
    }
  }, [_vm._l((_vm.informacoesVoo), function(voo, index) {
    return _c('div', {
      staticClass: "voosDiv"
    }, [_c('box', [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Companhia"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.companhia),
        expression: "voo.companhia"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.companhia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "companhia", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Tipo"
      }
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.tipo),
        expression: "voo.tipo"
      }],
      attrs: {
        "type": "radio",
        "value": "ida",
        "checked": ""
      },
      domProps: {
        "checked": _vm._q(voo.tipo, "ida")
      },
      on: {
        "change": function($event) {
          return _vm.$set(voo, "tipo", "ida")
        }
      }
    }), _vm._v("Ida")]), _vm._v(" "), _c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.tipo),
        expression: "voo.tipo"
      }],
      attrs: {
        "type": "radio",
        "value": "volta"
      },
      domProps: {
        "checked": _vm._q(voo.tipo, "volta")
      },
      on: {
        "change": function($event) {
          return _vm.$set(voo, "tipo", "volta")
        }
      }
    }), _vm._v("Volta")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 adicionaVoo"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerVoo(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Local Saída"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.localSaida),
        expression: "voo.localSaida"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.localSaida)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "localSaida", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Local Chegada"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.localChegada),
        expression: "voo.localChegada"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.localChegada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "localChegada", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Hora de Saída"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.horaSaida),
        expression: "voo.horaSaida"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "datetime-local",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.horaSaida)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "horaSaida", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Hora de Chegada"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.horaChegada),
        expression: "voo.horaChegada"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "datetime-local",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.horaChegada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "horaChegada", $event.target.value)
        }
      }
    })])], 1)])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 adicionaVoo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": _vm.adicionarVoo
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Adicionar Voo")])])])])], 2)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "prev",
      "type": "primary"
    },
    slot: "prev"
  }, [_vm._v("Anterior")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "next",
      "type": "primary"
    },
    slot: "next"
  }, [_vm._v("Próximo")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary"
    },
    slot: "finish"
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary",
      "disabled": ""
    },
    slot: "finish"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Confirmar")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.descricao),
      expression: "filtro.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtro.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filtro.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Posição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.posicao),
      expression: "filtro.posicao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtro.posicao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "posicao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Tipo")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "card",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "card")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "card")
      }
    }
  }), _vm._v("Card")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "quickyreply"
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "quickyreply")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "quickyreply")
      }
    }
  }), _vm._v("Botão Rápido")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "text")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "text")
      }
    }
  }), _vm._v("Texto")])])]), _c('br'), _vm._v(" "), _vm._l((_vm.filtro.opcoes), function(op, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filtro.tipo !== 'text'),
        expression: "filtro.tipo !== 'text'"
      }]
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Opção " + _vm._s(index + 1))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (op.opcao),
        expression: "op.opcao"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (op.opcao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(op, "opcao", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.filtro.tipo === 'card') ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Imagem")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "id": 'file-filtro-' + index
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3",
      staticStyle: {
        "margin-top": "3em",
        "cursor": "pointer"
      }
    }, [(index === _vm.filtro.opcoes.length - 1) ? _c('a', {
      on: {
        "click": _vm.adicionarOpcao
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Adicionar Opção")])]) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.removerOpcao(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Remover Opção")])])])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.filtro.ativo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "ativo", $$v)
      },
      expression: "filtro.ativo"
    }
  })], 1)]), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/filtros"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.gravando),
      expression: "habilitaGravar && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--scale-out",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Email Atual")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": this.$store.state.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Novo Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Confirmar Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmEmail),
      expression: "confirmEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.confirmEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongNewEmail),
      expression: "wrongNewEmail"
    }],
    staticClass: "col-sm-3 col-form-label lblWrong"
  }, [_vm._v("Email divergente")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/minha-conta"
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("CANCELAR")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" GRAVAR")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do serviço ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-servico"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Serviço")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.servicos), function(s) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(s.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(s.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.descricao))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": s.imagem
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.tempo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.preco))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + s.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Serviço',
          params: {
            id: s.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(s.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message--emoji"
  }, [_vm._v(_vm._s(_vm.data.emoji))])
},staticRenderFns: []}

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-header"
  }, [_c('div', {
    staticClass: "sc-header--close-button",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "margin-top": "25%",
      "font-size": "1.3em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sc-header--team-name"
  }, [_vm._v(" " + _vm._s(_vm.teamName) + " ")])])
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'NovaCategoria'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-plus paddingRight"
  }), _vm._v("Nova Categoria\n                ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'orderCategoria',
        params: {
          categoriasFiltered: _vm.categoriasFiltered
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-list-ol paddingRight"
  }), _vm._v("Ordenar Categorias\n                ")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "comum"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('comum')
      }
    }
  }, [_vm._v("Categorias de Produtos Comuns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "adicionais"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('adicionais')
      }
    }
  }, [_vm._v("Categoria de Adicionais")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva == 'comum'),
      expression: "tabAtiva == 'comum'"
    }]
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categoriasComunsFiltered), function(c) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(c.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(c.nome))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": c.url_imagem
      }
    })]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + c.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'editarCategoria',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluirCategoria(c.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva == 'adicionais'),
      expression: "tabAtiva == 'adicionais'"
    }]
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categoriasAdicionaisFiltered), function(c) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(c.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(c.nome))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + c.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'editarCategoria',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluirCategoria(c.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  })
},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            default header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printable"
    }
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("btn-confirm", [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-danger modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('confirmar')
      }
    }
  }, [_vm._v("\n              CONFIRMAR\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('cancelar')
      }
    }
  }, [_vm._v("\n              CANCELAR\n            ")])])]), _vm._v(" "), _vm._t("btn-msg", [_c('button', {
    staticClass: "btn btn-secondary modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_vm._v("\n              OK\n            ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.problema.descricao),
      expression: "problema.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.problema.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.problema, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.problema.solucao), function(linha, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Solução " + _vm._s(index + 1))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.descricao),
        expression: "linha.descricao"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (linha.descricao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "descricao", $event.target.value)
        }
      }
    })]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.adicionarSolucao
      }
    }, [_vm._v("Adicionar Solução")])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerSolucao(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/problemas"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.submit
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jumper",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center col-md-6 col-sm-offset-3"
  }, [_c('box', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.enviou),
      expression: "!enviou"
    }],
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.redefinir
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n                          Redefinir Senha\n                      ")]), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n                          Voltar para Login\n                      ")]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enviou),
      expression: "enviou"
    }],
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "text-black"
  }, [_c('p', [_vm._v("Email de redefinição de senha enviado para "), _c('b', [_vm._v(_vm._s(_vm.email))]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-3"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n                              Login\n                          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.enviou = false;
        _vm.title = 'Informe seu email para redefinir a senha de acesso'
      }
    }
  }, [_vm._v("Enviar Novamente?")])])])])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categories.descricao),
      expression: "categories.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.categories.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categories, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Ativo")]), _c('br'), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.categories.ativo),
      callback: function($$v) {
        _vm.$set(_vm.categories, "ativo", $$v)
      },
      expression: "categories.ativo"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/categorias-servicos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.categories.descricao != '' && !_vm.gravando),
      expression: "categories.descricao!='' && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "domNode",
    staticClass: "sc-emoji-picker",
    attrs: {
      "tabIndex": "0"
    },
    on: {
      "blur": _vm.onBlur
    }
  }, [_c('div', {
    staticClass: "sc-emoji-picker--content"
  }, _vm._l((_vm.emojiData), function(category) {
    return _c('div', {
      key: category.name,
      staticClass: "sc-emoji-picker--category"
    }, [_c('div', {
      staticClass: "sc-emoji-picker--category-title"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _vm._l((category.emojis), function(emoji) {
      return _c('span', {
        key: emoji,
        staticClass: "sc-emoji-picker--emoji",
        on: {
          "click": function($event) {
            return _vm.emojiClicked(emoji)
          }
        }
      }, [_vm._v("\n          " + _vm._s(emoji) + "\n        ")])
    })], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pagina Inicial")])])]), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/calendario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Calendário")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/pedidos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pedidos")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/clientes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Clientes")])])]), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/produtos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cubes",
    staticStyle: {}
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Produtos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/servicos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Servicos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorias"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias de Produtos")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorias-servicos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias de Serviços")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/campanhas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Campanhas")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/colaborador"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Colaborador")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiAssistencia) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/problemas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Problemas/Solução")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/solicitacoes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Solicitações")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/pacotes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-suitcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pacotes de Viagem")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/perguntas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Perguntas Personalizadas")])])]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/filtros"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Filtros")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/inclusao-rapida-produtos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Produtos (inclusão rápida)")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/inclusao-rapida-categorias"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias (inclusão rápida)")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("SETTINGS")]), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/setting"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Configurações")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/help"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ajuda")])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("EMPRESAS")]), _vm._v(" "), _vm._l((_vm.options), function(empresa, index) {
    return _c('li', {
      staticClass: "pageLink",
      attrs: {
        "tag": "li"
      }
    }, [_c('a', {
      class: [index === _vm.empresa_ativa ? 'empresaLink' : ''],
      on: {
        "click": function($event) {
          return _vm.changeEmpresa(index, empresa.fb_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o iconEmpresa"
    }), _vm._v(" "), _c('span', {
      staticClass: "page"
    }, [_vm._v(_vm._s(empresa.nome))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel center-gel"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c1 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c2 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c3 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c4 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c5 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c6 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c7 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c8 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c9 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c10 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c11 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c12 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c13 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c14 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c15 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c16 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c17 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c18 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c19 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c20 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c21 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c22 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c23 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c24 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c25 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c26 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c28 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c29 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c30 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c31 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c32 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c33 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c34 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c35 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c36 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c37 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
}]}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": {
        name: 'NotificarClientes',
        params: {
          clientes: _vm.users
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-comment paddingRight"
  }), _vm._v("Emitir notificações\n                ")])])], 1)]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCliente(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.usersFiltered), function(u) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(u.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.sobrenome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.sexo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.contato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ajusteData")(u.data_nascimento)))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "sync",
      on: {
        "click": function($event) {
          return _vm.syncClient(u.fb_id, u.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCliente(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--ping-pong",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "ball"
  })])
}]}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "square",
      "color": "#20a0ff",
      "error-color": "#ff4949",
      "title": "Cadastro de Novo Usuário",
      "subtitle": "Avance pelas guias para finalizar o cadastro"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Dados Pessoais",
      "icon": "fa fa-user",
      "before-change": _vm.validateFirstStep
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.dadosPessoais,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "User Name",
      "prop": "userName"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosPessoais.userName),
      expression: "dadosPessoais.userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome de usuário",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosPessoais.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosPessoais, "userName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Foto",
      "prop": "img"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  })])])], 1)], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Credenciais",
      "icon": "fa fa-lock",
      "before-change": _vm.validateSecondStep
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.dadosLogin,
      "rules": _vm.rulesLogin
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Email para Login",
      "prop": "email"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosLogin.email),
      expression: "dadosLogin.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosLogin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosLogin, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Senha de Acesso",
      "prop": "password"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosLogin.password),
      expression: "dadosLogin.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Senha de Acesso",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosLogin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosLogin, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Empresas",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.options,
      "selected-options": _vm.dadosLogin.itens,
      "placeholder": "Empresas com permissão"
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Confirmar Dados",
      "icon": "fa fa-check"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Nome de Usuário: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosPessoais.userName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Email: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosLogin.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Senha: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosLogin.password
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrandoSenha),
      expression: "!mostrandoSenha"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarSenha('mostrar')
      }
    }
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("Mostrar Senha")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrandoSenha),
      expression: "mostrandoSenha"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarSenha('')
      }
    }
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("Ocultar Senha")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Empresas: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.empresas
    }
  })])])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "prev",
      "type": "primary"
    },
    slot: "prev"
  }, [_vm._v("Anterior")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "next",
      "type": "primary"
    },
    slot: "next"
  }, [_vm._v("Próximo")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary"
    },
    slot: "finish"
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary",
      "disabled": ""
    },
    slot: "finish"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Confirmar")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-11",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-10",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "loader-xbox"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--gauge",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pedido"
    }
  }, [_c('div', {
    attrs: {
      "id": 'titlePedido' + _vm.index
    }
  }, [_c('label', [_vm._v("Pedido " + _vm._s(_vm.linha.id) + " - " + _vm._s(_vm._f("trataData")(_vm.linha.data_hora_conclusao)))]), _c('br'), _vm._v(" "), _vm._v("\r\n        " + _vm._s(_vm.linha.cliente.nome.toUpperCase()) + " "), _c('br'), _vm._v("\r\n        " + _vm._s(_vm.linha.cliente.contato)), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": 'bodyPedido' + _vm.index
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": 'itensNovo' + _vm.index
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.linha.itensPedido), function(item) {
    return _c('div', {
      staticClass: "even"
    }, [_vm._v("\r\n                        " + _vm._s(item.qtde) + " - R$ " + _vm._s(item.total.toFixed(2)) + " - " + _vm._s(item.nome) + " " + _vm._s(item.descricao && item.descricao.length < 50 ? ("(" + (item.descricao) + ")") : '')), _c('br'), _vm._v(" "), _vm._l((item.adicionais), function(adc) {
      return (item.adicionais) ? _c('div', {
        staticClass: "adicionais"
      }, [_vm._v("\r\n                            + " + _vm._s(adc.qtde) + " - " + _vm._s(adc.produtos.nome) + "\r\n                        ")]) : _vm._e()
    }), _vm._v(" "), _c('br'), _vm._v("-------------------------------------------\r\n                    ")], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 table-responsive",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "id": 'pagamentoNovo' + _vm.index
    }
  }, [_vm._l((_vm.colunas_pagamento), function(coluna) {
    return _c('div', [_vm._v("\r\n                        " + _vm._s(coluna) + "\r\n                    ")])
  }), _vm._v(" "), _vm._l((_vm.linha.formaPagamento), function(p) {
    return _c('div', [_c('label', [_vm._v(_vm._s(p.pagamento.nome))]), _vm._v(" "), (p.pagamento.nome !== 'dinheiro') ? _c('label', [_vm._v(_vm._s(p.observacao))]) : _c('label', [_vm._v("Troco: R$" + _vm._s((parseInt(p.observacao) - _vm.linha.preco_total).toFixed(2)) + " (Troco para R$" + _vm._s(p.observacao) + ")")])])
  }), _vm._v("\r\n                -------------------------------------------\r\n                "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linha.desconto && _vm.linha.desconto > 0),
      expression: "linha.desconto && linha.desconto > 0"
    }]
  }, [_vm._v("\r\n                 Desconto: " + _vm._s(_vm.linha.desconto) + "%\r\n                -------------------------------------------\r\n                ")]), _vm._v(" "), _c('br'), _c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Total do Pedido: " + _vm._s(_vm.linha.preco_total.toFixed(2)))])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 endereco",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "endereco-body",
    attrs: {
      "id": 'enderecoNovo' + _vm.index
    }
  }, [(_vm.linha.enderecosPedidos && _vm.linha.enderecosPedidos.length > 0) ? _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Rua: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Numero: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Bairro: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Complemento: " + _vm._s(_vm.linha.enderecosPedidos[0].enderecos.complemento))])]) : (_vm.linha.cliente.enderecoCliente && _vm.linha.cliente.enderecoCliente.length > 0) ? _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Rua: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Numero: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Bairro: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Complemento: " + _vm._s(_vm.linha.cliente.enderecoCliente[0].complemento))])]) : _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Irá Retirar")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("ITENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endereco-title"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Endereço de Entrega")])])
}]}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollList",
    staticClass: "sc-message-list"
  }, _vm._l((_vm.messages), function(message, idx) {
    return _c('Message', {
      key: idx,
      attrs: {
        "message": message,
        "chatImageUrl": _vm.chatImageUrl
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--cube-shadow",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": "Clique para selecionar os clientes que deseja notificar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void();"
    },
    on: {
      "click": _vm.selecionarTodos
    }
  }, [_vm._v("Selecionar Todos (" + _vm._s(_vm.clientes.length) + ") >>")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter1),
      expression: "filter1"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filter1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group groupNotifica"
  }, _vm._l((_vm.usersFiltered1), function(element, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item itemNotificar",
      on: {
        "click": function($event) {
          return _vm.selecionar(element)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.nome(element.nome, element.sobrenome)) + " - " + _vm._s(element.fb_id ? element.fb_id : element.facebook_id) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void();"
    },
    on: {
      "click": _vm.removerTodos
    }
  }, [_vm._v(_vm._s("<< Remover Todos") + " (" + _vm._s(_vm.notificar.length) + ")\n              ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter2),
      expression: "filter2"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filter2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group groupNotifica"
  }, _vm._l((_vm.usersFiltered2), function(element, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item itemNotificar",
      on: {
        "click": function($event) {
          return _vm.remover(element)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.nome(element.nome, element.sobrenome)) + " - " + _vm._s(element.fb_id ? element.fb_id : element.facebook_id) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Texto da notificação:")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "2",
      "maxlength": "240"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "cont"
    }
  }, [_vm._v(_vm._s(_vm.msg.length) + "/240")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Enviar botões ?")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.enviarReplies),
      callback: function($$v) {
        _vm.enviarReplies = $$v
      },
      expression: "enviarReplies"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enviarReplies),
      expression: "enviarReplies"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replies),
      expression: "replies"
    }],
    attrs: {
      "type": "checkbox",
      "value": "cardapio"
    },
    domProps: {
      "checked": Array.isArray(_vm.replies) ? _vm._i(_vm.replies, "cardapio") > -1 : (_vm.replies)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.replies,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "cardapio",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.replies = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.replies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.replies = $$c
        }
      }
    }
  }), _vm._v("Ver Cardápio")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replies),
      expression: "replies"
    }],
    attrs: {
      "type": "checkbox",
      "value": "pergunta"
    },
    domProps: {
      "checked": Array.isArray(_vm.replies) ? _vm._i(_vm.replies, "pergunta") > -1 : (_vm.replies)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.replies,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "pergunta",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.replies = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.replies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.replies = $$c
        }
      }
    }
  }), _vm._v("Fazer Pergunta")])])])]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/clientes"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificar.length > 0 && _vm.msg),
      expression: "notificar.length > 0 && msg"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.notificarClientes
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v(" Enviar Notificação")])])], 1)])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info animated zoomIn",
    staticStyle: {
      "animation-duration": "0.5s"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._t("icon"), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-3",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-4",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-5",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle-6",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100"
    }
  }, [_c('g', {
    staticClass: "anim-0"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": _vm.background
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-1"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-2"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "50",
      "x2": "75",
      "y2": "50",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-3"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "25",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "75",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-4"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "75",
      "y1": "25",
      "x2": "25",
      "y2": "25",
      "stroke": "white",
      "stroke-width": "3"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-7",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-8",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-container"
  }, [_c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_3"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_4"
  }, [_vm._v(" ")])])])
}]}

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-9",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading spin-1"
  }, [_c('div', {
    staticClass: "loading spin-2"
  }, [_c('div', {
    staticClass: "loading spin-3"
  }, [_c('div', {
    staticClass: "loading spin-4"
  }, [_c('div', {
    staticClass: "loading spin-5"
  }, [_c('div', {
    staticClass: "loading spin-6"
  })])])])])])
}]}

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--google",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "empresa"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('empresa')
      }
    }
  }, [_vm._v("DADOS DA EMPRESA")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "perfil"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('perfil')
      }
    }
  }, [_vm._v("PERFIL DE USUÁRIO")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pedidos"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('pedidos')
      }
    }
  }, [_vm._v("PEDIDOS")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "funcionamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('funcionamento')
      }
    }
  }, [_vm._v("FUNCIONAMENTO")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'empresa'),
      expression: "ativo === 'empresa'"
    }]
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n                      CEP:\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cep),
      expression: "cep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cep = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.buscaCEP
    }
  }, [_vm._v("Buscar Endereco")])]), _vm._v(" "), _c('li', [_vm._v("\n                    RUA:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rua),
      expression: "rua"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rua)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rua = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    NUMERO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numero),
      expression: "numero"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numero = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li'), _c('li', [_vm._v("\n                    BAIRRO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bairro),
      expression: "bairro"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bairro = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    CIDADE:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade),
      expression: "cidade"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cidade = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    ESTADO:\n                    "), _c('div', {
    staticClass: "form-group inputEndereco"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estado),
      expression: "estado"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("AC")]), _vm._v(" "), _c('option', [_vm._v("AL")]), _vm._v(" "), _c('option', [_vm._v("AP")]), _vm._v(" "), _c('option', [_vm._v("AM")]), _vm._v(" "), _c('option', [_vm._v("BA")]), _vm._v(" "), _c('option', [_vm._v("CE")]), _vm._v(" "), _c('option', [_vm._v("DF")]), _vm._v(" "), _c('option', [_vm._v("ES")]), _vm._v(" "), _c('option', [_vm._v("GO")]), _vm._v(" "), _c('option', [_vm._v("MA")]), _vm._v(" "), _c('option', [_vm._v("MT")]), _vm._v(" "), _c('option', [_vm._v("MS")]), _vm._v(" "), _c('option', [_vm._v("MG")]), _vm._v(" "), _c('option', [_vm._v("PA")]), _vm._v(" "), _c('option', [_vm._v("PB")]), _vm._v(" "), _c('option', [_vm._v("PR")]), _vm._v(" "), _c('option', [_vm._v("PE")]), _vm._v(" "), _c('option', [_vm._v("PI")]), _vm._v(" "), _c('option', [_vm._v("RJ")]), _vm._v(" "), _c('option', [_vm._v("RN")]), _vm._v(" "), _c('option', [_vm._v("RS")]), _vm._v(" "), _c('option', [_vm._v("RO")]), _vm._v(" "), _c('option', [_vm._v("RR")]), _vm._v(" "), _c('option', [_vm._v("SC")]), _vm._v(" "), _c('option', [_vm._v("SP")]), _vm._v(" "), _c('option', [_vm._v("SE")]), _vm._v(" "), _c('option', [_vm._v("TO")])])])]), _vm._v(" "), _c('li', [_vm._v("\n                    COMPLEMENTO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complemento),
      expression: "complemento"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.complemento = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'perfil'),
      expression: "ativo === 'perfil'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permite_impressao),
      expression: "permite_impressao"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.permite_impressao) ? _vm._i(_vm.permite_impressao, null) > -1 : _vm._q(_vm.permite_impressao, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.permite_impressao,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.permite_impressao = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.permite_impressao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permite_impressao = $$c
        }
      }
    }
  }), _vm._v("\n                        1. Permite Impressão de Pedido automaticamente\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permite_email),
      expression: "permite_email"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.permite_email) ? _vm._i(_vm.permite_email, null) > -1 : _vm._q(_vm.permite_email, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.permite_email,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.permite_email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.permite_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permite_email = $$c
        }
      }
    }
  }), _vm._v("\n                        2. Permite o envio de e-mail de notificação ao cliente enviar dúvida\n                      ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'pedidos'),
      expression: "ativo === 'pedidos'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.notifica_cliente),
      expression: "config.notifica_cliente"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.notifica_cliente) ? _vm._i(_vm.config.notifica_cliente, null) > -1 : _vm._q(_vm.config.notifica_cliente, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.notifica_cliente,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config, "notifica_cliente", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config, "notifica_cliente", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config, "notifica_cliente", $$c)
        }
      }
    }
  }), _vm._v("\n                        1. Notifica o cliente sobre alteração de status\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('h6', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.tabelaVariaveis
    }
  }, [_vm._v("Tabela de Variáveis")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.1 Texto padrão para notificação de status APROVADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_aprovado),
      expression: "config.texto_padrao_aprovado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_aprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_aprovado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_aprovado) + " ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.2 Texto padrão para notificação de status REPROVADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_reprovado),
      expression: "config.texto_padrao_reprovado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_reprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_reprovado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_reprovado))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.3 Texto padrão para notificação de status CANCELADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_cancelado),
      expression: "config.texto_padrao_cancelado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_cancelado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_cancelado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_cancelado))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.4 Texto padrão para notificação de status SAIU PARA ENTREGA")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_entrega),
      expression: "config.texto_padrao_entrega"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_entrega", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_entrega))])])])])]), _c('br'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("2. Raio de Entrega dos pedidos (Km)")]), _vm._v(" "), (_vm.frete.length > 0) ? _c('div', _vm._l((_vm.frete), function(item, index) {
    return _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('h5', [_vm._v("Até")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.distancia),
        expression: "item.distancia"
      }],
      staticClass: "form-control inputFrete",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.distancia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distancia", $event.target.value)
        }
      }
    }), _c('h5', [_vm._v("km, cobrar R$")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.valor),
        expression: "item.valor"
      }],
      staticClass: "form-control inputFrete",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "valor", $event.target.value)
        }
      }
    }), _vm._v(" "), (index === 0) ? _c('a', {
      on: {
        "click": _vm.adicionarFrete
      }
    }, [_c('h5', {
      staticClass: "inputRaioEntrega"
    }, [_vm._v("Novo Raio de Entrega")])]) : _c('a', {
      staticClass: "removeFrete",
      on: {
        "click": function($event) {
          return _vm.removerFrete(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0) : _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h5', [_vm._v("Até")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.raio_entrega),
      expression: "config.raio_entrega"
    }],
    staticClass: "form-control inputFrete",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.raio_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "raio_entrega", $event.target.value)
      }
    }
  }), _c('h5', [_vm._v("km, cobrar R$")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.taxa_entrega),
      expression: "config.taxa_entrega"
    }],
    staticClass: "form-control inputFrete",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.taxa_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "taxa_entrega", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.imprimir_descricao),
      expression: "config.imprimir_descricao"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.imprimir_descricao) ? _vm._i(_vm.config.imprimir_descricao, null) > -1 : _vm._q(_vm.config.imprimir_descricao, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.imprimir_descricao,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config, "imprimir_descricao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config, "imprimir_descricao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config, "imprimir_descricao", $$c)
        }
      }
    }
  }), _vm._v("\n                          3. Imprimir descrição do produto no Recibo.\n                        ")])])]), _c('br'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                          4. Valor mínimo para pedidos\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.pedido_minimo),
      expression: "config.pedido_minimo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.pedido_minimo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "pedido_minimo", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'funcionamento'),
      expression: "ativo === 'funcionamento'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.funcionamento), function(linha) {
    return _c('li', [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.aberto),
        expression: "linha.aberto"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(linha.aberto) ? _vm._i(linha.aberto, null) > -1 : (linha.aberto)
      },
      on: {
        "change": function($event) {
          var $$a = linha.aberto,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(linha, "aberto", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(linha, "aberto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(linha, "aberto", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(linha.dia.toUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('ul', {
      attrs: {
        "type": "none"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.aberto),
        expression: "linha.aberto"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_1),
        expression: "linha.hr_abertura_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_1", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_1),
        expression: "linha.hr_fechamento_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_1", $event.target.value)
        }
      }
    }), _vm._v("    -   "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_2),
        expression: "linha.hr_abertura_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_2", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_2),
        expression: "linha.hr_fechamento_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_2", $event.target.value)
        }
      }
    })])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'promocao'),
      expression: "ativo === 'promocao'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        1. Promoção Por Período\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_vm._v("\n                        1.1. Promoção ativa entre \n                        ")]), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 noPadding"
  }, [_vm._v("\n                          1.2. Promoção válida para pedidos acima de \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1",
    staticStyle: {
      "margin-left": "-3%"
    }
  }), _vm._v("\n                        reais\n                      ")]), _c('br'), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio1),
      expression: "optradio1"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio1",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio1, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio1 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio1),
      expression: "optradio1"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio1",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio1, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio1 = "desc"
      }
    }
  }), _vm._v("Desconto")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio1 === 'desc'),
      expression: "optradio1 === 'desc'"
    }]
  }, [_vm._v("\n                          1.3. Porcentagem de desconto\n                          ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        2. Promoção Por Pedidos Realizados\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1 noPadding"
  }, [_vm._v("\n                          2.1. A partir de\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" pedidos\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio2),
      expression: "optradio2"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio2",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio2, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio2 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio2),
      expression: "optradio2"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio2",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio2, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio2 = "desc"
      }
    }
  }), _vm._v("Desconto")])])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio2 === 'desc'),
      expression: "optradio2 === 'desc'"
    }]
  }, [_vm._v("\n                          2.2. Porcentagem de desconto\n                          ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        3. Promoção de Aniversário\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio3),
      expression: "optradio3"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio3",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio3, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio3 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio3),
      expression: "optradio3"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio3",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio3, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio3 = "desc"
      }
    }
  }), _vm._v("Desconto")])])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio3 === 'desc'),
      expression: "optradio3 === 'desc'"
    }]
  }, [_vm._v("\n                          3.1. Porcentagem de desconto\n                          ")])])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Repos")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Github Repos")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', [_vm._v("\n        Found an error\n      ")]) : _c('div', _vm._l((_vm.response), function(repo) {
    return (_vm.response) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-widget widget-user"
    }, [_c('div', {
      staticClass: "widget-user-header bg-aqua-active text-center"
    }, [_c('h3', {
      staticClass: "widget-user-username center-text"
    }, [_vm._v(_vm._s(repo.name))])]), _vm._v(" "), _c('div', {
      staticClass: "widget-user-image"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": repo.owner.avatar_url,
        "alt": "repo.owner.login + ' Avatar'"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-footer"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.stargazers_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Star")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('a', {
      attrs: {
        "href": repo.owner.html_url,
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Visit")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.forks_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Forks")])])])])])])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo-top"
    }
  }), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#one"
    }
  }, [_vm._v("Sobre")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#three"
    }
  }, [_vm._v("Fale Conosco")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "button special",
    attrs: {
      "href": "dashboard.html"
    }
  }, [_vm._v("Área do Logista")])])])])])])])
}]}

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    staticStyle: {
      "background": "none",
      "filter": "invert(1)"
    },
    attrs: {
      "src": "/static/img/image2vector.svg",
      "alt": "Logo"
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "id": "toggle-menu",
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    },
    on: {
      "click": _vm.barra
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])]), _vm._v(" "), (_vm.config.funcionamento === 'manual') ? _c('div', {
    staticClass: "modelSelect"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.bot_ativo),
      expression: "!bot_ativo"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("BOT DESLIGADO")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bot_ativo),
      expression: "bot_ativo"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("BOT LIGADO")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true,
      "labels": true
    },
    on: {
      "change": _vm.alteraStatusBot
    },
    model: {
      value: (_vm.bot_ativo),
      callback: function($$v) {
        _vm.bot_ativo = $$v
      },
      expression: "bot_ativo"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "notifications-menu status-bot"
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.demo.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("Olá, " + _vm._s(_vm.demo.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated slideInDown",
    staticStyle: {
      "animation-duration": "0.5s"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.minhaConta
    }
  }, [_c('i', {
    staticClass: "fa fa-user text-aqua"
  }), _vm._v(" Minha Conta\n                    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.novoUsuario
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus text-aqua"
  }), _vm._v(" Novo Usuário\n                    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out text-aqua"
  }), _vm._v(" Sair\n                    ")])])])])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.logo,
      "empresa": _vm.demo.empresa
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.pedidosImprimir), function(linha, index) {
    return (_vm.modal) ? _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "pedido"
      }
    }, [_c('modal-pedido', {
      attrs: {
        "index": index,
        "linha": linha
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.mostrar) ? _c('beautiful-chat', {
    attrs: {
      "escolheuCliente": _vm.escolheuCliente,
      "mensagens": _vm.mensagens,
      "onMessageWasSent": _vm.onMessageWasSent,
      "newMessagesCount": _vm.newMessagesCount,
      "isOpen": _vm.isChatOpen,
      "close": _vm.closeChat,
      "open": _vm.openChat,
      "showEmoji": true,
      "showFile": true
    },
    on: {
      "sendMsg": _vm.sendMessage,
      "leuMsg": _vm.leuMsg,
      "atualizarImagem": _vm.atualizarImagem,
      "backChat": _vm.getMessages
    }
  }) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "https://sevsolucoes.com"
    }
  }, [_vm._v("SEV")]), _vm._v(".")]), _vm._v(" All rights reserved.\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "src": "/static/audio/alerta.mp3",
      "loop": ""
    }
  }, [_vm._v("\n    O seu navegador não suporta o elemento "), _c('code', [_vm._v("audio")]), _vm._v(".\n  ")])
}]}

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do produto ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardapio),
      expression: "cardapio"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cardapio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Selecione a Categoria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "todos"
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.categorias), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-produto"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Produto")])]), _vm._v(" "), _c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": {
        name: 'orderProduto'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-list-ol paddingRight"
  }), _vm._v("Ordenar Produtos\n                  ")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.productsFiltered), function(p) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(p.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(p.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.descricao))]), _vm._v(" "), _c('td', [_vm._v("R$" + _vm._s(_vm.getPreco(p)))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": p.url_imagem
      }
    })]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + p.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'editarProduto',
          params: {
            id: p.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(p.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('tbody', _vm._l((_vm.clientes), function(c) {
    return _c('tr', {
      class: !c.lido ? 'txtBold clienteMsg' : 'clienteMsg',
      on: {
        "click": function($event) {
          return _vm.cliente(c.id)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticClass: "img-msg",
      attrs: {
        "src": c.img
      },
      on: {
        "error": function($event) {
          return _vm.syncClient(c.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.nome.toUpperCase()) + " "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!c.lido),
        expression: "!c.lido"
      }],
      staticClass: "fa fa-exclamation",
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": ".6em"
      }
    }, [_vm._v("Ultima mensagem: " + _vm._s(_vm._f("ajusteDate")(c.mensagem[c.mensagem.length - 1].date)))])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do Problema ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-problema"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Problema/Solução")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.servicos), function(s) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(s.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(s.descricao))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Problema',
          params: {
            id: s.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(s.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hour-glass",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('svg', {
    staticClass: "hourglass",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 206",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticClass: "middle",
    attrs: {
      "d": "M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "outer",
    attrs: {
      "d": "M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pergunta.descricao),
      expression: "pergunta.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pergunta.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pergunta, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.pergunta.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Posição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pergunta.posicao),
      expression: "pergunta.posicao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.pergunta.posicao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pergunta, "posicao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Tipo")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pergunta.tipo),
      expression: "pergunta.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "text",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.pergunta.tipo, "text")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.pergunta, "tipo", "text")
      }
    }
  }), _vm._v("Text")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pergunta.tipo),
      expression: "pergunta.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "options"
    },
    domProps: {
      "checked": _vm._q(_vm.pergunta.tipo, "options")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.pergunta, "tipo", "options")
      }
    }
  }), _vm._v("Options")])])]), _c('br'), _vm._v(" "), _vm._l((_vm.pergunta.opcoes), function(op, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.pergunta.tipo === 'options'),
        expression: "pergunta.tipo === 'options'"
      }]
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Opção " + _vm._s(index + 1))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (op.opcao),
        expression: "op.opcao"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (op.opcao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(op, "opcao", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3",
      staticStyle: {
        "margin-top": "3em",
        "cursor": "pointer"
      }
    }, [(index === _vm.pergunta.opcoes.length - 1) ? _c('a', {
      on: {
        "click": _vm.adicionarOpcao
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Adicionar Opção")])]) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.removerOpcao(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Remover Opção")])])])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.pergunta.ativo),
      callback: function($$v) {
        _vm.$set(_vm.pergunta, "ativo", $$v)
      },
      expression: "pergunta.ativo"
    }
  })], 1)]), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/perguntas"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.gravando),
      expression: "habilitaGravar && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--pencil",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 677.34762 182.15429"
    }
  }, [_c('g', [_c('path', {
    staticClass: "body-pencil",
    attrs: {
      "d": "M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M134.482 157.147v25l518.57.008.002-25-518.572-.008z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "dados"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('dados')
      }
    }
  }, [_vm._v("DADOS DO PRODUTO")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "funcionamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('funcionamento')
      }
    }
  }, [_vm._v("FUNCIONAMENTO")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva == 'dados'),
      expression: "tabAtiva == 'dados'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Codigo Interno (ERP)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo_interno),
      expression: "codigo_interno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigo_interno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo_interno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descricao),
      expression: "descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descricao = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.formularioPreco), function(linha, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.preco),
        expression: "linha.preco"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control currency",
      attrs: {
        "value": "0",
        "min": "0",
        "step": "0.01",
        "data-number-to-fixed": "2",
        "data-number-stepfactor": "100"
      },
      domProps: {
        "value": (linha.preco)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "preco", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.id_cardapio),
        expression: "linha.id_cardapio"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(linha, "id_cardapio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.id_cardapio === 0),
        expression: "linha.id_cardapio===0"
      }]
    }, [_vm._v("*Campo Obrigatório")])]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.adicionaPreco
      }
    }, [_vm._v("Adicionar Preço")])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerPreco(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.ativo),
      callback: function($$v) {
        _vm.ativo = $$v
      },
      expression: "ativo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Produtos permite adicionais")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "sync": true
    },
    model: {
      value: (_vm.permiteadicionais),
      callback: function($$v) {
        _vm.permiteadicionais = $$v
      },
      expression: "permiteadicionais"
    }
  })], 1)]), _c('br'), _vm._v(" "), _vm._l((_vm.adicionais), function(catAdicional, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.permiteadicionais),
        expression: "permiteadicionais"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria adicionais")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (catAdicional.categoria),
        expression: "catAdicional.categoria"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(catAdicional, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Quantidade Permitida")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (catAdicional.qtde),
        expression: "catAdicional.qtde"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (catAdicional.qtde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(catAdicional, "qtde", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Obrigatório")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "sync": true
      },
      model: {
        value: (catAdicional.exigido),
        callback: function($$v) {
          _vm.$set(catAdicional, "exigido", $$v)
        },
        expression: "catAdicional.exigido"
      }
    })], 1), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.addAdicionais
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerAdicional(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva === 'funcionamento'),
      expression: "tabAtiva === 'funcionamento'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Definir funcionamento")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.possuiFuncionamento),
      callback: function($$v) {
        _vm.possuiFuncionamento = $$v
      },
      expression: "possuiFuncionamento"
    }
  })], 1)]), _c('br'), _c('br'), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.possuiFuncionamento),
      expression: "possuiFuncionamento"
    }],
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.funcionamento), function(linha) {
    return _c('li', [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.ativo),
        expression: "linha.ativo"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(linha.ativo) ? _vm._i(linha.ativo, null) > -1 : (linha.ativo)
      },
      on: {
        "change": function($event) {
          var $$a = linha.ativo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(linha, "ativo", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(linha, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(linha, "ativo", $$c)
          }
        }
      }
    }), _vm._v("\n                    " + _vm._s(linha.dia.toUpperCase()) + "\n                  ")])]), _vm._v(" "), _c('ul', {
      attrs: {
        "type": "none"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.ativo),
        expression: "linha.ativo"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_1),
        expression: "linha.hr_abertura_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_1", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_1),
        expression: "linha.hr_fechamento_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_1", $event.target.value)
        }
      }
    }), _vm._v("    -   "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_2),
        expression: "linha.hr_abertura_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_2", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_2),
        expression: "linha.hr_fechamento_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_2", $event.target.value)
        }
      }
    })])])])
  }), 0)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h4', [_vm._v("Escolha o tipo de relatório:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoRelatorio),
      expression: "tipoRelatorio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlSelect1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoRelatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "regiao"
    }
  }, [_vm._v("Por região (bairro)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Bairros")]), _c('br'), _vm._v("\n              As regiões onde mais efetuam pedidos\n            ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "regioesPreferidas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPedidos(coluna.json)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                              ")])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.enderecos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.enderecos), function(p, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("upperCase")(p.bairro)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.qtde))])])
  })], 2), _vm._v(" "), _c('tfoot')])])])])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._l((_vm.categorias), function(c, index) {
    return _c('div', {
      staticClass: "categorias"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.nome),
        expression: "c.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (c.nome)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(c, "nome", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "id": ("file-input-" + index)
      }
    }), _vm._v(" "), _c('p', {
      attrs: {
        "id": "status"
      }
    }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('h4', [_vm._v("Habilita multiplo sabor (Pizza)")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      model: {
        value: (c.permitemeia),
        callback: function($$v) {
          _vm.$set(c, "permitemeia", $$v)
        },
        expression: "c.permitemeia"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('h4', [_vm._v("Categoria de Produtos Adicionais")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      model: {
        value: (c.adicionais),
        callback: function($$v) {
          _vm.$set(c, "adicionais", $$v)
        },
        expression: "c.adicionais"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "padding": "0.7em"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerCategoria(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 adicionaVoo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": _vm.adicionarCategoria
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Adicionar Categoria")])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/categorias"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nome != '' && !_vm.gravando),
      expression: "nome!='' && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cube panelLoad"
  }, [_c('div', {
    staticClass: "cube-face cube-face-front"
  }, [_vm._v("L")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-back"
  }, [_vm._v("O")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-left"
  }, [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-right"
  }, [_vm._v("D")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-bottom"
  }, [_vm._v("I")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-top"
  }, [_vm._v("N'")])])
}]}

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box animated zoomIn"
  }, [_c('span', {
    class: ['info-box-icon', _vm.colorIcon]
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._t("info")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'ID'),
      expression: "filtro==='ID'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "number",
      "placeholder": "Pesquisa por ID"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'NOME'),
      expression: "filtro==='NOME'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_name),
      expression: "filter_name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa por NOME"
    },
    domProps: {
      "value": (_vm.filter_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.filtro) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'ID';
        _vm.filter = _vm.filter_name;
        _vm.filter_name = ''
      }
    }
  }, [_vm._v("ID")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'NOME';
        _vm.filter_name = _vm.filter;
        _vm.filter = ''
      }
    }
  }, [_vm._v("Nome")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statuspedido),
      expression: "statuspedido"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlSelect1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statuspedido = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos Estados")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Em Espera")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Aprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Reprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 6
    }
  }, [_vm._v("Saiu para Entrega")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Cancelado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/pedidos/relatorios"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-line-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Relatórios\n                ")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary radioOntem",
    attrs: {
      "id": "radioOntem"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('ontem')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Ontem\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary radioHoje",
    attrs: {
      "id": "radioHoje"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('hoje')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Hoje\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInicial),
      expression: "dataInicial"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dataInicial)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInicial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon2"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataFinal),
      expression: "dataFinal"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.dataFinal)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataFinal = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPedidos(coluna.json)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                              " + _vm._s(_vm._f("ucwords")(coluna.name)) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [(_vm.order.keys === coluna.json && _vm.order.sort === 'asc') ? _c('i', {
      staticClass: "fa fa-sort-asc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (_vm.order.keys === coluna.json && _vm.order.sort === 'desc') ? _c('i', {
      staticClass: "fa fa-sort-desc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (coluna.json !== 'observacao' && coluna.json !== 'acoes') ? _c('i', {
      staticClass: "fa fa-sort",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.pedidosFiltered.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.pedidosFiltered), function(p, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("upperCase")(p.cliente.nome)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(p.preco_total ? p.preco_total.toFixed(2) : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("data")(p.data_hora)))]), _vm._v(" "), (p.estado.id == 1) ? _c('td', {
      staticClass: "coluna",
      staticStyle: {
        "background": "#FFF95B"
      }
    }, [_vm._v("Em Espera")]) : _vm._e(), _vm._v(" "), (p.estado.id == 2) ? _c('td', {
      staticClass: "coluna",
      staticStyle: {
        "background": "#88D89D"
      }
    }, [_vm._v("Aprovado")]) : _vm._e(), _vm._v(" "), (p.estado.id == 3) ? _c('td', {
      staticClass: "coluna",
      staticStyle: {
        "background": "#F48668"
      }
    }, [_vm._v("Reprovado")]) : _vm._e(), _vm._v(" "), (p.estado.id == 5) ? _c('td', {
      staticClass: "coluna",
      staticStyle: {
        "background": "#F48668"
      }
    }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (p.estado.id == 6) ? _c('td', {
      staticClass: "coluna",
      staticStyle: {
        "background": "#88D89D"
      }
    }, [_vm._v("Saiu para Entrega")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "iconPed",
      attrs: {
        "title": "Ver Pedido",
        "href": "javascript:;",
        "data-toggle": "modal",
        "data-target": "#modalLarge"
      },
      on: {
        "click": function($event) {
          return _vm.itens(index, p.id, p.cliente.nome, p.cliente.contato, p.cliente, p.desconto)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      class: p.estado.id != 1 ? 'iconPed disabled' : 'iconPed',
      attrs: {
        "title": "Aprovar",
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.gravarEstado(p.id, 2, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      class: p.estado.id != 1 ? 'iconPed disabled' : 'iconPed',
      attrs: {
        "title": "Reprovar",
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.gravarEstado(p.id, 3, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      class: p.estado.id != 1 && p.estado.id != 2 ? 'iconPed disabled' : 'iconPed',
      attrs: {
        "title": "Saiu para entrega",
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.gravarEstado(p.id, 6, p.cliente, p.cliente.nome, p.cliente.sobrenome, p.preco_total, p.estado.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bolt",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('label', [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('label', [_vm._v("R$ " + _vm._s(_vm.totalPedidos))])])])], 2), _vm._v(" "), _c('tfoot')])])])])])]), _vm._v(" "), _c('modal', {
    on: {
      "imprimir": _vm.btnImprime
    }
  }, [_c('p', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_vm._v("\n      Pedido " + _vm._s(_vm.pedido_id) + " - " + _vm._s(_vm._f("data")(_vm.dataPedido))), _c('br'), _vm._v("\n      " + _vm._s(_vm.nome_cliente.toUpperCase()) + " "), _c('br'), _vm._v("\n      Telefone: " + _vm._s(_vm.contato)), _c('br')]), _vm._v(" "), _c('h3', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": ""
    }
  }, [_c('thead', [(_vm.artCasa) ? _c('tr', _vm._l((_vm.colunas_itens2), function(coluna2) {
    return _c('th', [_vm._v("\n                        " + _vm._s(_vm._f("ucwords")(coluna2)) + "\n                      ")])
  }), 0) : _c('tr', _vm._l((_vm.colunas_itens), function(coluna) {
    return _c('th', [_vm._v("\n                        " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens_pedido), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(_vm.artCasa) ? _c('td', [_c('img', {
      staticStyle: {
        "max-width": "50%"
      },
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "bordaItem"
    }, [_vm._v(_vm._s(item.qtde))]), _vm._v(" "), _c('td', {
      staticClass: "bordaItem"
    }, [_vm._v("\n                          " + _vm._s(item.nome) + " " + _vm._s(_vm.config.imprimir_descricao && item.descricao && item.descricao.length < 50 ? ("(" + (item.descricao) + ")") : '') + "\n                          "), _vm._l((item.adicionais), function(adc) {
      return (item.adicionais) ? _c('p', {
        staticClass: "adicionais"
      }, [_vm._v("\n                            + " + _vm._s(adc.qtde) + " - " + _vm._s(adc.produtos.nome) + "\n                          ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(item.total ? item.total.toFixed(2) : 0))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 table-responsive",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "id": ""
    }
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas_pagamento), function(coluna) {
    return _c('th', [_vm._v("\n                        " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.pagamento), function(p) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(p.pagamento.nome))]), _vm._v(" "), (p.pagamento.nome.toLowerCase() !== 'dinheiro') ? _c('td', [_vm._v(_vm._s(p.observacao))]) : _c('td', [_vm._v("Troco para: R$" + _vm._s(p.observacao) + " "), _c('h5', [_vm._v("(R$" + _vm._s((parseInt(p.observacao) - _vm.total_pedido).toFixed(2)) + ")")])])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v("\n                -------------------------------------\n                "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.desconto && _vm.desconto > 0),
      expression: "desconto && desconto > 0"
    }]
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px",
      "padding-right": "5em"
    }
  }, [_vm._v("Desconto: " + _vm._s(_vm.desconto) + "% (Primeira Compra) ")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "15px",
      "padding-right": "5em"
    }
  }, [_vm._v("Total do Pedido")]), _c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.total_pedido.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 endereco",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_c('div', {
    staticClass: "endereco-title"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Endereço de Entrega")])]), _vm._v(" "), _c('div', {
    staticClass: "endereco-body",
    attrs: {
      "id": "endereco"
    }
  }, [(_vm.endereco) ? _c('div', [_c('label', {
    staticClass: "lblEnd End"
  }, [_vm._v("Rua: " + _vm._s(_vm.endereco.rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd End"
  }, [_vm._v("Número: " + _vm._s(_vm.endereco.numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd End"
  }, [_vm._v("Bairro: " + _vm._s(_vm.endereco.bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd End"
  }, [_vm._v("Complemento: " + _vm._s(_vm.endereco.complemento))])]) : _c('div', [_c('label', [_vm._v("Irá Retirar")])])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    attrs: {
      "id": "titlePedido"
    }
  }, [_c('label', {
    staticClass: "idPedido"
  }, [_vm._v("Pedido " + _vm._s(_vm.pedido_id) + " - " + _vm._s(_vm._f("data")(_vm.dataPedido)))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.nome_cliente.toUpperCase()) + " "), _c('br'), _vm._v("\n      Telefone: " + _vm._s(_vm.contato)), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "itensTable"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.itens_pedido), function(item) {
    return _c('div', [_vm._v("\n            " + _vm._s(item.qtde) + " - R$ " + _vm._s(item.total.toFixed(2)) + " - " + _vm._s(item.nome) + " " + _vm._s(_vm.config.imprimir_descricao && item.descricao && item.descricao.length < 50 ? ("(" + (item.descricao) + ")") : '') + "\n            "), _vm._l((item.adicionais), function(adc) {
      return (item.adicionais) ? _c('div', {
        staticClass: "adicionais"
      }, [_vm._v("\n              + " + _vm._s(adc.qtde) + " - " + _vm._s(adc.produtos.nome) + "\n            ")]) : _vm._e()
    }), _vm._v(" "), _c('br'), _vm._v("-------------------------------------------\n        ")], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 table-responsive",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "id": "pagamento"
    }
  }, [_vm._l((_vm.colunas_pagamento), function(coluna) {
    return _c('div', [_vm._v("\n                  " + _vm._s(coluna) + "\n              ")])
  }), _vm._v(" "), _vm._l((_vm.pagamento), function(p) {
    return _c('div', [_c('label', [_vm._v(_vm._s(p.pagamento.nome))]), _vm._v(" "), (p.pagamento.nome !== 'dinheiro') ? _c('label', [_vm._v(_vm._s(p.observacao))]) : _c('label', [_vm._v("Troco: R$" + _vm._s((parseInt(p.observacao) - _vm.total_pedido).toFixed(2)) + " (Troco para R$" + _vm._s(p.observacao) + ")")])])
  }), _vm._v("\n          -------------------------------------------\n          "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.desconto && _vm.desconto > 0),
      expression: "desconto && desconto > 0"
    }]
  }, [_vm._v("\n            Desconto: " + _vm._s(_vm.desconto) + "%\n          -------------------------------------------\n          ")]), _vm._v(" "), _c('br'), _c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Total do Pedido: " + _vm._s(_vm.total_pedido.toFixed(2)))])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 endereco",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "endereco-body",
    attrs: {
      "id": "endereco"
    }
  }, [(_vm.endereco) ? _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Rua: " + _vm._s(_vm.endereco.rua))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Numero: " + _vm._s(_vm.endereco.numero))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Bairro: " + _vm._s(_vm.endereco.bairro))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Complemento: " + _vm._s(_vm.endereco.complemento))])]) : _c('div', [_c('label', {
    staticClass: "lblEnd"
  }, [_vm._v("Irá Retirar")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("ITENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endereco-title"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Endereço de Entrega")])])
}]}

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._l((_vm.categorias), function(categoria, index) {
    return _c('div', {
      staticClass: "row center-block"
    }, [_c('box', {
      attrs: {
        "title": categoria.nome
      }
    }, [_c('div', {
      attrs: {
        "slot": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.ajustarCollapse(index)
        }
      },
      slot: "icon"
    }, [_c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": '#collapse' + index,
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "collapseExample"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      staticStyle: {
        "padding-right": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {
      staticClass: "dataTables_wrapper form-inline dt-bootstrap collapse",
      attrs: {
        "id": 'collapse' + index
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('draggable', {
      staticClass: "list-group",
      attrs: {
        "element": "ul",
        "options": _vm.dragOptions,
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.categorias[index].OrdemProdutos),
        callback: function($$v) {
          _vm.$set(_vm.categorias[index], "OrdemProdutos", $$v)
        },
        expression: "categorias[index].OrdemProdutos"
      }
    }, _vm._l((categoria.OrdemProdutos), function(element, i) {
      return _c('li', {
        key: element.order,
        staticClass: "list-group-item"
      }, [_vm._v("\n                          " + _vm._s(element.nome) + "\n                          "), _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(i))])])
    }), 0)], 1)])])])])], 1)
  }), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravarOrdem
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "htmlFor": "file-input"
    }
  }, [_c('button', {
    staticClass: "sc-user-input--file-icon-wrapper",
    attrs: {
      "type": "button"
    }
  }, [_c('svg', {
    staticClass: "sc-user-input--file-icon",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 37.393 37.393",
      "enableBackground": "new 0 0 37.393 37.393"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.807 10.22l-2.030-2.029-10.15 10.148c-1.682 1.681-1.682 4.408 0 6.089s4.408 1.681 6.090 0l12.18-12.178c2.804-2.802 2.804-7.346 0-10.148-2.802-2.803-7.347-2.803-10.149 0l-12.788 12.787c-0.009 0.009-0.019 0.018-0.027 0.026-3.909 3.909-3.909 10.245 0 14.153 3.908 3.908 10.246 3.908 14.156 0 0.009-0.009 0.016-0.018 0.026-0.027l0.001 0.001 8.729-8.728-2.031-2.029-8.729 8.727c-0.009 0.008-0.018 0.018-0.026 0.026-2.784 2.783-7.312 2.783-10.096 0-2.783-2.783-2.783-7.31 0-10.093 0.010-0.009 0.019-0.018 0.028-0.026l-0.001-0.002 12.79-12.786c1.678-1.679 4.411-1.679 6.090 0s1.678 4.411 0 6.089l-12.18 12.178c-0.56 0.56-1.47 0.56-2.030 0-0.559-0.559-0.559-1.47 0-2.029l10.15-10.149z"
    }
  })])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-input"
    },
    on: {
      "change": _vm._handleChange,
      "click": _vm._handleClick
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jawn"
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "jawn",
    style: (_vm.innerStyles)
  })])])
},staticRenderFns: []}

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.file) ? _c('div', {
    staticClass: "file-container"
  }, [_vm._m(0), _vm._v("\n    " + _vm._s(_vm.file.name) + "\n    "), _c('span', {
    staticClass: "delete-file-message",
    on: {
      "click": function($event) {
        return _vm.cancelFile()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1085),
      "alt": "close icon",
      "height": "10",
      "title": "Remove the file"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "sc-user-input",
    class: {
      active: _vm.inputActive
    }
  }, [_c('div', {
    ref: "userInput",
    staticClass: "sc-user-input--text",
    attrs: {
      "role": "button",
      "tabIndex": "0",
      "contentEditable": "true",
      "placeholder": _vm.placeholder
    },
    on: {
      "focus": function($event) {
        return _vm.setInputActive(true)
      },
      "blur": function($event) {
        return _vm.setInputActive(false)
      },
      "keydown": _vm.handleKey
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-user-input--buttons"
  }, [_c('div', {
    staticClass: "sc-user-input--button"
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-user-input--button"
  }, [_c('SendIcon', {
    attrs: {
      "onClick": _vm._submitText
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-file-message"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(424),
      "alt": "genericFileIcon",
      "height": "15"
    }
  })])
}]}

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-diamond",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--plane",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "middle"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "bottom"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
}]}

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--spin-line",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.lineStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Ativo")]), _c('br'), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.ativo),
      callback: function($$v) {
        _vm.ativo = $$v
      },
      expression: "ativo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Habilita multiplo sabor (Pizza)")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.permitemeia),
      callback: function($$v) {
        _vm.permitemeia = $$v
      },
      expression: "permitemeia"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Categoria de Produtos Adicionais")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.adicionais),
      callback: function($$v) {
        _vm.adicionais = $$v
      },
      expression: "adicionais"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/categorias"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nome != '' && !_vm.gravando),
      expression: "nome!='' && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--double-bounce",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "double-bounce1",
    style: (_vm.bounceStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2",
    style: (_vm.bounceStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Nome de Usuário")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Foto")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Senha")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/alterar-email"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Alterar Email")])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/alterar-senha"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Alterar Senha")])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'ID'),
      expression: "filtro==='ID'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "number",
      "placeholder": "Pesquisa por ID"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'NOME'),
      expression: "filtro==='NOME'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_name),
      expression: "filter_name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa por NOME"
    },
    domProps: {
      "value": (_vm.filter_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.filtro) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'ID';
        _vm.filter = _vm.filter_name;
        _vm.filter_name = ''
      }
    }
  }, [_vm._v("ID")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'NOME';
        _vm.filter_name = _vm.filter;
        _vm.filter = ''
      }
    }
  }, [_vm._v("Nome")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlSelect1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos Estados")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Em Espera")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Aprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Reprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Personalizado")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "col-md-2 btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary radioOntem",
    attrs: {
      "id": "radioOntem"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('ontem')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Ontem\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary radioHoje",
    attrs: {
      "id": "radioHoje"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('hoje')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Hoje\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInicial),
      expression: "dataInicial"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dataInicial)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInicial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon2"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataFinal),
      expression: "dataFinal"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.dataFinal)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataFinal = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPedidos(coluna.json)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                  " + _vm._s(_vm._f("ucwords")(coluna.name)) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [(_vm.order.keys === coluna.json && _vm.order.sort === 'asc') ? _c('i', {
      staticClass: "fa fa-sort-asc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (_vm.order.keys === coluna.json && _vm.order.sort === 'desc') ? _c('i', {
      staticClass: "fa fa-sort-desc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (coluna.json !== 'observacao') ? _c('i', {
      staticClass: "fa fa-sort",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.solicitacoesFiltered.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.solicitacoesFiltered), function(p, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('router-link', {
      staticClass: "padding",
      attrs: {
        "to": {
          name: 'Detalhe Solicitação',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(p.id) + "\n                          ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("upperCase")(p.Clientes.nome)))]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "obs"
      }
    }, [_vm._v(_vm._s(p.Pacotes ? p.Pacotes.titulo : 'Pacote Personalizado'))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(p.Pacotes ? p.Pacotes.preco.toFixed(2) : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("data")(p.datahora)))]), _vm._v(" "), (p.statusid == 2) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#FFF95B",
        "border-color": "#FFF95B",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 3) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#88D89D",
        "border-color": "#88D89D",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 4) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#F48668",
        "border-color": "#F48668",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 5) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      staticClass: "form-control",
      staticStyle: {
        "padding": "0px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_c('option', [_vm._v("Personalizado")])])]) : _vm._e()])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('label', [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('label', [_vm._v("R$ " + _vm._s(_vm.totalPedidos))])])])], 2), _vm._v(" "), _c('tfoot')])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo2.jpeg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "redefinir-senha"
    }
  }, [_vm._v("\n              Esqueceu sua senha?\n            ")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "id": "btn",
      "type": "submit"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Entrando")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v("Entrar")])])], 1), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Descrição da pergunta ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/nova-pergunta"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Nova Pergunta")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPergunta(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.perguntas), function(p) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(p.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(p.pergunta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.posicao))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Pergunta',
          params: {
            id: p.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(p.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPergunta(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('form', {
    staticClass: "sidebar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "placeholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": "Arraste as categorias para a ordem que deseja no chatbot"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('draggable', {
    staticClass: "list-group",
    attrs: {
      "element": "ul",
      "options": _vm.dragOptions,
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.categorias),
      callback: function($$v) {
        _vm.categorias = $$v
      },
      expression: "categorias"
    }
  }, _vm._l((_vm.categorias), function(element, index) {
    return _c('li', {
      key: element.order,
      staticClass: "list-group-item"
    }, [_vm._v("\n                          " + _vm._s(element.nome) + "\n                          "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(index))])])
  }), 0), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/categorias"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravarOrdem
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])])], 1)])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-5",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "load3 one"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3 two"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3-center"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-square4",
    style: (_vm.styles)
  }, [_c('span', {
    staticClass: "loader-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--cube",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 500.00001 500.00001"
    }
  }, [_c('g', {
    attrs: {
      "fill": _vm.color
    }
  }, [_c('path', {
    staticClass: "b0",
    attrs: {
      "d": "M66.734 66.734v366.533h366.532V66.734H66.734zm15 15h336.532v336.533H81.734V81.734z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b2",
    attrs: {
      "d": "M354.16 2.5v143.34H497.5V2.5H354.16zm10 10H487.5v123.34H364.16V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b1",
    attrs: {
      "d": "M0 2.5v143.34h143.34V2.5H0zm10 10h123.34v123.34H10V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b3",
    attrs: {
      "d": "M354.16 356.66V500H497.5V356.66H354.16zm10 10H487.5V490H364.16V366.66z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b4",
    attrs: {
      "d": "M0 356.66V500h143.34V356.66H0zm10 10h123.34V490H10V366.66z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._l((_vm.produtos), function(p, iProd) {
    return _c('div', {
      staticClass: "produtos"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.nome),
        expression: "p.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (p.nome)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "nome", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": ("file-input-" + iProd)
      }
    }), _vm._v(" "), _c('p', {
      attrs: {
        "id": "status"
      }
    }, [_vm._v("Please select a file")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.descricao),
        expression: "p.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "1",
        "cols": "12"
      },
      domProps: {
        "value": (p.descricao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "descricao", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((p.formularioPreco), function(linha, index) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-3"
      }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (linha.preco),
          expression: "linha.preco"
        }, {
          name: "money",
          rawName: "v-money",
          value: (_vm.money),
          expression: "money"
        }],
        staticClass: "form-control currency",
        attrs: {
          "value": "0",
          "min": "0",
          "step": "0.01",
          "data-number-to-fixed": "2",
          "data-number-stepfactor": "100"
        },
        domProps: {
          "value": (linha.preco)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(linha, "preco", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (linha.id_cardapio),
          expression: "linha.id_cardapio"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(linha, "id_cardapio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.categories), function(c) {
        return _c('option', {
          domProps: {
            "value": c.id
          }
        }, [_vm._v(_vm._s(c.nome))])
      }), 0), _vm._v(" "), _c('label', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (linha.id_cardapio === 0),
          expression: "linha.id_cardapio===0"
        }]
      }, [_vm._v("*Campo Obrigatório")])]), _vm._v(" "), (index === 0) ? _c('div', {
        staticClass: "col-md-3 adicionaPreco"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.adicionaPreco(iProd)
          }
        }
      }, [_vm._v("Adicionar Preço")])]) : _c('div', {
        staticClass: "col-md-3 adicionaPreco"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.removerPreco(index, iProd)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      model: {
        value: (p.ativo),
        callback: function($$v) {
          _vm.$set(p, "ativo", $$v)
        },
        expression: "p.ativo"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Produtos permite adicionais")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "sync": true
      },
      model: {
        value: (p.permiteadicionais),
        callback: function($$v) {
          _vm.$set(p, "permiteadicionais", $$v)
        },
        expression: "p.permiteadicionais"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "padding": "0.7em"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerProduto(iProd)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (p.permiteadicionais),
        expression: "p.permiteadicionais"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria adicionais")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.adicional),
        expression: "p.adicional"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "adicional", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 adicionaVoo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": _vm.adicionarCategoria
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Adicionar Categoria")])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--texture",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "blob top",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob bottom",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob left",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob move-blob",
    style: (_vm.moveBlobStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--mikepad",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "binding"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
}]}

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Senha Antiga")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongOldPassword),
      expression: "wrongOldPassword"
    }],
    staticClass: "col-sm-3 col-form-label lblWrong"
  }, [_vm._v("Senha Incorreta")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Nova Senha")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Confirmar Senha")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongNewPassword),
      expression: "wrongNewPassword"
    }],
    staticClass: "col-sm-3 col-form-label lblWrong"
  }, [_vm._v("Senhas divergentes")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/minha-conta"
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("CANCELAR")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" GRAVAR")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--two-cube",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-user-input--picker-wrapper"
  }, [(_vm.isActive) ? _c('EmojiPicker', {
    attrs: {
      "onEmojiPicked": _vm.onEmojiPicked,
      "onBlur": _vm._handlePickerBlur
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sc-user-input--emoji-icon-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm._openPicker($event)
      }
    }
  }, [_c('svg', {
    staticClass: "sc-user-input--emoji-icon",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "37.393px",
      "height": "37.393px",
      "viewBox": "0 0 37.393 37.393",
      "enableBackground": "new 0 0 37.393 37.393"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M18.696,37.393C8.387,37.393,0,29.006,0,18.696C0,8.387,8.387,0,18.696,0c10.31,0,18.696,8.387,18.696,18.696\n            C37.393,29.006,29.006,37.393,18.696,37.393z M18.696,2C9.49,2,2,9.49,2,18.696c0,9.206,7.49,16.696,16.696,16.696\n            c9.206,0,16.696-7.49,16.696-16.696C35.393,9.49,27.902,2,18.696,2z"
    }
  })]), _vm._v(" "), _c('g', [_c('circle', {
    attrs: {
      "cx": "12.379",
      "cy": "14.359",
      "r": "1.938"
    }
  })]), _vm._v(" "), _c('g', [_c('circle', {
    attrs: {
      "cx": "24.371",
      "cy": "14.414",
      "r": "1.992"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M18.035,27.453c-5.748,0-8.342-4.18-8.449-4.357c-0.286-0.473-0.135-1.087,0.338-1.373\n            c0.471-0.286,1.084-0.136,1.372,0.335c0.094,0.151,2.161,3.396,6.74,3.396c4.713,0,7.518-3.462,7.545-3.497\n            c0.343-0.432,0.973-0.504,1.405-0.161c0.433,0.344,0.505,0.973,0.161,1.405C27.009,23.374,23.703,27.453,18.035,27.453z"
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.idName
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
},staticRenderFns: []}

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Descrição do Filtro ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-filtro"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Filtro")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filtros), function(f) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(f.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(f.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.posicao))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + f.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Filtro',
          params: {
            id: f.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(f.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do pacote ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-pacote"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Pacote")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPacote(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.pacotes), function(p) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(p.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(p.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.nomehotel))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(p.preco))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + p.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Pacote',
          params: {
            id: p.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(p.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPacote(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--stretch",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "rect rect-1",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-2",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-3",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-4",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-5",
    style: (_vm.rectStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/condpagto"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nome != '' && !_vm.gravando),
      expression: "nome!='' && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalLarge",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-large-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    attrs: {
      "id": "printable"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._t("modal-title", [_vm._v("\r\n                default title\r\n            ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("modal-body", [_vm._v("\r\n            default body\r\n        ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('imprimir')
      }
    }
  }, [_vm._v("Imprimir")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classeLaucher"
  }, [_c('div', {
    staticClass: "sc-launcher",
    class: {
      opened: _vm.isOpen
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isOpen ? _vm.close() : _vm.open()
      }
    }
  }, [(_vm.newMessagesCount > 0 && !_vm.isOpen) ? _c('div', {
    staticClass: "sc-new-messsages-count"
  }, [_vm._v("\n      " + _vm._s(_vm.newMessagesCount) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "sc-open-icon",
    attrs: {
      "src": __webpack_require__(1084)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sc-closed-icon",
    attrs: {
      "src": __webpack_require__(1086)
    }
  })]), _vm._v(" "), _c('ChatWindow', {
    attrs: {
      "messageList": _vm.messageList,
      "mensagens": _vm.mensagens,
      "onUserInputSubmit": _vm.onMessageWasSent,
      "isOpen": _vm.isOpen,
      "onClose": _vm.close,
      "showEmoji": _vm.showEmoji,
      "showFile": _vm.showFile,
      "placeholder": _vm.placeholder
    },
    on: {
      "sendMsg": _vm.sendMsg,
      "escolheuCliente": _vm.leuMsg,
      "atualizarImagem": _vm.atualizarImagem,
      "backChat": _vm.backChat
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "square",
      "color": "#20a0ff",
      "error-color": "#ff4949",
      "title": "Cadastro nova campanha",
      "subtitle": "Avance pelas guias para finalizar o cadastro"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Tipo de Camapnha",
      "icon": "fa fa-info",
      "before-change": _vm.validateFirstStep
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "5%",
      "margin-bottom": "5%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-3"
  }, [_c('span', {
    class: ['infoBox', _vm.ticketColor],
    on: {
      "click": function($event) {
        return _vm.selecionarCard('ticket')
      }
    }
  }, [_c('i', {
    class: ("fa fa-ticket icon" + _vm.ticketColor)
  }), _vm._v(" "), _c('h3', {
    class: ("lblCard lbl" + _vm.ticketColor)
  }, [_vm._v("Cupom de desconto")])])])])])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Dados da Campanha",
      "icon": "fa fa-list-alt"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Código do cupom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo),
      expression: "codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.codigo === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Quantidade de cupons")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qtde_cupom),
      expression: "qtde_cupom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.qtde_cupom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.qtde_cupom = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.qtde_cupom === 0) ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Validade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validade),
      expression: "validade"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.validade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.validade = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.validade) ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Tipo do Cupom")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo_desc),
      expression: "tipo_desc"
    }],
    attrs: {
      "type": "radio",
      "name": "radioTipoDesc",
      "value": "frete"
    },
    domProps: {
      "checked": _vm._q(_vm.tipo_desc, "frete")
    },
    on: {
      "change": function($event) {
        _vm.tipo_desc = "frete"
      }
    }
  }), _vm._v("Frete Grátis")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo_desc),
      expression: "tipo_desc"
    }],
    attrs: {
      "type": "radio",
      "name": "radioTipoDesc",
      "value": "porcentagem"
    },
    domProps: {
      "checked": _vm._q(_vm.tipo_desc, "porcentagem")
    },
    on: {
      "change": function($event) {
        _vm.tipo_desc = "porcentagem"
      }
    }
  }), _vm._v("Porcentagem de desconto")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo_desc),
      expression: "tipo_desc"
    }],
    attrs: {
      "type": "radio",
      "name": "radioTipoDesc",
      "value": "dinheiro"
    },
    domProps: {
      "checked": _vm._q(_vm.tipo_desc, "dinheiro")
    },
    on: {
      "change": function($event) {
        _vm.tipo_desc = "dinheiro"
      }
    }
  }), _vm._v("Desconto em dinheiro")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo_desc != 'frete'),
      expression: "tipo_desc != 'frete'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Desconto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desconto),
      expression: "desconto"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.desconto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desconto = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.desconto === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.ativo),
      callback: function($$v) {
        _vm.ativo = $$v
      },
      expression: "ativo"
    }
  })], 1)]), _c('br')]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "prev",
      "type": "primary"
    },
    slot: "prev"
  }, [_vm._v("Anterior")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "next",
      "type": "primary"
    },
    slot: "next"
  }, [_vm._v("Próximo")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary"
    },
    slot: "finish"
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary",
      "disabled": ""
    },
    slot: "finish"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Confirmar")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.nome),
      expression: "servico.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.servico.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.descricao),
      expression: "servico.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.servico.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Tempo (min)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.tempo),
      expression: "servico.tempo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.servico.tempo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.servico, "tempo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servico.categorias_id),
      expression: "servico.categorias_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.servico, "categorias_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.descricao))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.servico.preco),
      callback: function($$v) {
        _vm.$set(_vm.servico, "preco", $$v)
      },
      expression: "servico.preco"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "v-label"
  }, [_vm._v("Imagem")]), _c('br'), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "multiple": false,
      "id": "file-input"
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.servico.ativo),
      callback: function($$v) {
        _vm.$set(_vm.servico, "ativo", $$v)
      },
      expression: "servico.ativo"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/servicos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.loading),
      expression: "habilitaGravar && !loading"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[779]);


// WEBPACK FOOTER //
// static/js/app.73fa0f1681313544f145.js